/** ============================================================================
======== This file was automatically generated. Do not edit manually. =========
================================================================================ */

export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

/** Defines the bundle products to add to the cart. */
export type MagentoApiAddBundleProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars["String"]["input"];
  /** An array of bundle products to add. */
  cart_items: Array<InputMaybe<MagentoApiBundleProductCartItemInput>>;
};

/** Contains details about the cart after adding bundle products. */
export type MagentoApiAddBundleProductsToCartOutput = {
  __typename: "AddBundleProductsToCartOutput";
  /** The cart after adding products. */
  cart: MagentoApiCart;
};

/** Defines the configurable products to add to the cart. */
export type MagentoApiAddConfigurableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars["String"]["input"];
  /** An array of configurable products to add. */
  cart_items: Array<InputMaybe<MagentoApiConfigurableProductCartItemInput>>;
};

/** Contains details about the cart after adding configurable products. */
export type MagentoApiAddConfigurableProductsToCartOutput = {
  __typename: "AddConfigurableProductsToCartOutput";
  /** The cart after adding products. */
  cart: MagentoApiCart;
};

/** Specifies the single coupon code to add to the cart. */
export type MagentoApiAddCouponToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** A valid single coupon code. */
  coupon_code: Scalars["String"]["input"];
};

/** Contains details about the cart after adding a coupon. */
export type MagentoApiAddCouponToCartOutput = {
  __typename: "AddCouponToCartOutput";
  /** The cart after applying a single coupon. */
  cart: MagentoApiCart;
};

export type MagentoApiAddDownloadableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars["String"]["input"];
  /** An array of downloadable products to add. */
  cart_items: Array<InputMaybe<MagentoApiDownloadableProductCartItemInput>>;
};

/** Contains details about the cart after adding downloadable products. */
export type MagentoApiAddDownloadableProductsToCartOutput = {
  __typename: "AddDownloadableProductsToCartOutput";
  /** The cart after adding products. */
  cart: MagentoApiCart;
};

/** Defines an item to add to the gift registry. */
export type MagentoApiAddGiftRegistryItemInput = {
  /** An array of options the customer has entered. */
  entered_options?: InputMaybe<Array<InputMaybe<MagentoApiEnteredOptionInput>>>;
  /** A brief note about the item. */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** For complex product types, the SKU of the parent product. */
  parent_sku?: InputMaybe<Scalars["String"]["input"]>;
  /** The quantity of the product to add. */
  quantity: Scalars["Float"]["input"];
  /** An array of strings corresponding to options the customer has selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** The SKU of the product to add to the gift registry. */
  sku: Scalars["String"]["input"];
};

/** Defines a new registrant. */
export type MagentoApiAddGiftRegistryRegistrantInput = {
  /** Additional attributes specified as a code-value pair. */
  dynamic_attributes?: InputMaybe<Array<InputMaybe<MagentoApiGiftRegistryDynamicAttributeInput>>>;
  /** The email address of the registrant. */
  email: Scalars["String"]["input"];
  /** The first name of the registrant. */
  firstname: Scalars["String"]["input"];
  /** The last name of the registrant. */
  lastname: Scalars["String"]["input"];
};

/** Contains the results of a request to add registrants. */
export type MagentoApiAddGiftRegistryRegistrantsOutput = {
  __typename: "AddGiftRegistryRegistrantsOutput";
  /** The gift registry after adding registrants. */
  gift_registry?: Maybe<MagentoApiGiftRegistry>;
};

/** Contains details about the cart after adding products to it. */
export type MagentoApiAddProductsToCartOutput = {
  __typename: "AddProductsToCartOutput";
  /** The cart after products have been added. */
  cart: MagentoApiCart;
  /** Contains errors encountered while adding an item to the cart. */
  user_errors: Array<Maybe<MagentoApiError>>;
};

/** Contains products to add to an existing compare list. */
export type MagentoApiAddProductsToCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products: Array<InputMaybe<Scalars["ID"]["input"]>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars["ID"]["input"];
};

/** Contains details about the cart after adding products to it. */
export type MagentoApiAddProductsToNewCartOutput = {
  __typename: "AddProductsToNewCartOutput";
  /** The cart after products have been added. */
  cart?: Maybe<MagentoApiCart>;
  /** Contains errors encountered while adding an item to the cart. */
  user_errors?: Maybe<Array<Maybe<MagentoApiCartUserInputError>>>;
};

/** Contains the customer's wish list and any errors encountered. */
export type MagentoApiAddProductsToWishlistOutput = {
  __typename: "AddProductsToWishlistOutput";
  /** An array of errors encountered while adding products to a wish list. */
  user_errors: Array<Maybe<MagentoApiWishListUserInputError>>;
  /** Contains the wish list with all items that were successfully added. */
  wishlist: MagentoApiWishlist;
};

/** Defines a return comment. */
export type MagentoApiAddReturnCommentInput = {
  /** The text added to the return request. */
  comment_text: Scalars["String"]["input"];
  /** The unique ID for a `Return` object. */
  return_uid: Scalars["ID"]["input"];
};

/** Contains details about the return request. */
export type MagentoApiAddReturnCommentOutput = {
  __typename: "AddReturnCommentOutput";
  /** The modified return. */
  return?: Maybe<MagentoApiReturn>;
};

/** Defines tracking information to be added to the return. */
export type MagentoApiAddReturnTrackingInput = {
  /** The unique ID for a `ReturnShippingCarrier` object. */
  carrier_uid: Scalars["ID"]["input"];
  /** The unique ID for a `Returns` object. */
  return_uid: Scalars["ID"]["input"];
  /** The shipping tracking number for this return request. */
  tracking_number: Scalars["String"]["input"];
};

/** Contains the response after adding tracking information. */
export type MagentoApiAddReturnTrackingOutput = {
  __typename: "AddReturnTrackingOutput";
  /** Details about the modified return. */
  return?: Maybe<MagentoApiReturn>;
  /** Details about shipping for a return. */
  return_shipping_tracking?: Maybe<MagentoApiReturnShippingTracking>;
};

/** Defines the simple and group products to add to the cart. */
export type MagentoApiAddSimpleProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of simple and group items to add. */
  cart_items: Array<InputMaybe<MagentoApiSimpleProductCartItemInput>>;
};

/** Contains details about the cart after adding simple or group products. */
export type MagentoApiAddSimpleProductsToCartOutput = {
  __typename: "AddSimpleProductsToCartOutput";
  /** The cart after adding products. */
  cart: MagentoApiCart;
};

/** Defines the virtual products to add to the cart. */
export type MagentoApiAddVirtualProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of virtual products to add. */
  cart_items: Array<InputMaybe<MagentoApiVirtualProductCartItemInput>>;
};

/** Contains details about the cart after adding virtual products. */
export type MagentoApiAddVirtualProductsToCartOutput = {
  __typename: "AddVirtualProductsToCartOutput";
  /** The cart after adding products. */
  cart: MagentoApiCart;
};

/** Contains the resultant wish list and any error information. */
export type MagentoApiAddWishlistItemsToCartOutput = {
  __typename: "AddWishlistItemsToCartOutput";
  /** An array of errors encountered while adding products to the customer's cart. */
  add_wishlist_items_to_cart_user_errors: Array<Maybe<MagentoApiWishlistCartUserInputError>>;
  /** Indicates whether the attempt to add items to the customer's cart was successful. */
  status: Scalars["Boolean"]["output"];
  /** Contains the wish list with all items that were successfully added. */
  wishlist: MagentoApiWishlist;
};

export type MagentoApiAddressValidationErrorCode =
  "INVALID_ADDRESS" | "INVALID_CITY" | "INVALID_POSTCODE" | "INVALID_PROVINCE" | "INVALID_SA" | "INVALID_TELEPHONE";

export type MagentoApiAgeVerificationMode = "CART" | "DISABLED" | "SHIPPING";

/** Contains information for each filterable option (such as price, category `UID`, and custom attributes). */
export type MagentoApiAggregation = {
  __typename: "Aggregation";
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars["String"]["output"];
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars["Int"]["output"]>;
  /** The aggregation display name. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<MagentoApiAggregationOption>>>;
  /** The relative position of the attribute in a layered navigation block. */
  position?: Maybe<Scalars["Int"]["output"]>;
};

/** An implementation of `AggregationOptionInterface`. */
export type MagentoApiAggregationOption = MagentoApiAggregationOptionInterface & {
  __typename: "AggregationOption";
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars["Int"]["output"]>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The internal ID that represents the value of the option. */
  value: Scalars["String"]["output"];
};

/** Defines aggregation option fields. */
export type MagentoApiAggregationOptionInterface = {
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars["Int"]["output"]>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The internal ID that represents the value of the option. */
  value: Scalars["String"]["output"];
};

/** Filter category aggregations in layered navigation. */
export type MagentoApiAggregationsCategoryFilterInput = {
  /** Indicates whether to include only direct subcategories or all children categories at all levels. */
  includeDirectChildrenOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** An input object that specifies the filters used in product aggregations. */
export type MagentoApiAggregationsFilterInput = {
  /** Filter category aggregations in layered navigation. */
  category?: InputMaybe<MagentoApiAggregationsCategoryFilterInput>;
};

export type MagentoApiApplePayConfig = MagentoApiPaymentConfigItem & {
  __typename: "ApplePayConfig";
  /** The styles for the ApplePay Smart Button configuration */
  button_styles?: Maybe<MagentoApiButtonStyles>;
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars["String"]["output"]>;
  /** The payment source for the payment method */
  payment_source?: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<MagentoApiSdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars["String"]["output"]>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Apple Pay inputs */
export type MagentoApiApplePayMethodInput = {
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars["String"]["input"]>;
  /** The payment services order ID */
  payments_order_id?: InputMaybe<Scalars["String"]["input"]>;
  /** PayPal order ID */
  paypal_order_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type MagentoApiAppliedCampaign = {
  __typename: "AppliedCampaign";
  loyalty_discount_amount?: Maybe<Scalars["Float"]["output"]>;
  loyalty_discount_name?: Maybe<Scalars["String"]["output"]>;
  loyalty_discount_points?: Maybe<Scalars["Int"]["output"]>;
  loyalty_discount_skus?: Maybe<Scalars["String"]["output"]>;
  loyalty_discount_uuid?: Maybe<Scalars["String"]["output"]>;
};

/** Contains the applied coupon code. */
export type MagentoApiAppliedCoupon = {
  __typename: "AppliedCoupon";
  /** The coupon code the shopper applied to the card. */
  code: Scalars["String"]["output"];
  /** The label of the coupon. */
  label?: Maybe<Scalars["String"]["output"]>;
};

/** Contains an applied gift card with applied and remaining balance. */
export type MagentoApiAppliedGiftCard = {
  __typename: "AppliedGiftCard";
  /** The amount applied to the current cart. */
  applied_balance?: Maybe<MagentoApiMoney>;
  /** The gift card account code. */
  code?: Maybe<Scalars["String"]["output"]>;
  /** The remaining balance on the gift card. */
  current_balance?: Maybe<MagentoApiMoney>;
  /** The expiration date of the gift card. */
  expiration_date?: Maybe<Scalars["String"]["output"]>;
};

/** Contains the applied and current balances. */
export type MagentoApiAppliedStoreCredit = {
  __typename: "AppliedStoreCredit";
  /** The applied store credit balance to the current cart. */
  applied_balance?: Maybe<MagentoApiMoney>;
  /** The current balance remaining on store credit. */
  current_balance?: Maybe<MagentoApiMoney>;
  /** Indicates whether store credits are enabled. If the feature is disabled, then the current balance will not be returned. */
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MagentoApiApplyCampaignToCartInput = {
  campaign_uuid?: InputMaybe<Scalars["String"]["input"]>;
  cart_id: Scalars["String"]["input"];
  points?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MagentoApiApplyCampaignToCartOutput = {
  __typename: "ApplyCampaignToCartOutput";
  cart: MagentoApiCart;
};

/** Specifies the coupon code to apply to the cart. */
export type MagentoApiApplyCouponToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** A valid coupon code. */
  coupon_code: Scalars["String"]["input"];
};

/** Contains details about the cart after applying a coupon. */
export type MagentoApiApplyCouponToCartOutput = {
  __typename: "ApplyCouponToCartOutput";
  /** The cart after applying a coupon. */
  cart: MagentoApiCart;
};

/** The strategy to apply coupons to the cart. */
export type MagentoApiApplyCouponsStrategy =
  /** Append new coupons keeping the coupons that have been applied before. */
  | "APPEND"
  /** Remove all the coupons from the cart and apply only new provided coupons. */
  | "REPLACE";

/** Apply coupons to the cart. */
export type MagentoApiApplyCouponsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of valid coupon codes. */
  coupon_codes: Array<InputMaybe<Scalars["String"]["input"]>>;
  /** `replace` to replace the existing coupon(s) or `append` to add the coupon to the coupon(s) list. */
  type?: InputMaybe<MagentoApiApplyCouponsStrategy>;
};

/** Defines the input required to run the `applyGiftCardToCart` mutation. */
export type MagentoApiApplyGiftCardToCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
  /** The gift card code to be applied to the cart. */
  gift_card_code: Scalars["String"]["input"];
};

/** Defines the possible output for the `applyGiftCardToCart` mutation. */
export type MagentoApiApplyGiftCardToCartOutput = {
  __typename: "ApplyGiftCardToCartOutput";
  /** Describes the contents of the specified shopping cart. */
  cart: MagentoApiCart;
};

/** Contains applied gift cards with gift card code and amount. */
export type MagentoApiApplyGiftCardToOrder = {
  __typename: "ApplyGiftCardToOrder";
  /** The gift card amount applied to the current order. */
  applied_balance: MagentoApiMoney;
  /** The gift card account code. */
  code: Scalars["String"]["output"];
};

/** Contains the customer cart. */
export type MagentoApiApplyRewardPointsToCartOutput = {
  __typename: "ApplyRewardPointsToCartOutput";
  /** The customer cart after reward points are applied. */
  cart: MagentoApiCart;
};

/** Defines the input required to run the `applyStoreCreditToCart` mutation. */
export type MagentoApiApplyStoreCreditToCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
};

/** Defines the possible output for the `applyStoreCreditToCart` mutation. */
export type MagentoApiApplyStoreCreditToCartOutput = {
  __typename: "ApplyStoreCreditToCartOutput";
  /** The contents of the specified shopping cart. */
  cart: MagentoApiCart;
};

/** Contains the results of the request to assign a compare list. */
export type MagentoApiAssignCompareListToCustomerOutput = {
  __typename: "AssignCompareListToCustomerOutput";
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<MagentoApiCompareList>;
  /** Indicates whether the compare list was successfully assigned to the customer. */
  result: Scalars["Boolean"]["output"];
};

/** Contains details about the attribute, including the code and type. */
export type MagentoApiAttribute = {
  __typename: "Attribute";
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: Maybe<Scalars["String"]["output"]>;
  /** Attribute options list. */
  attribute_options?: Maybe<Array<Maybe<MagentoApiAttributeOption>>>;
  /** The data type of the attribute. */
  attribute_type?: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type?: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  input_type?: Maybe<Scalars["String"]["output"]>;
  /** Details about the storefront properties configured for the attribute. */
  storefront_properties?: Maybe<MagentoApiStorefrontProperties>;
};

/** List of all entity types. Populated by the modules introducing EAV entities. */
export type MagentoApiAttributeEntityTypeEnum =
  "CATALOG_CATEGORY" | "CATALOG_PRODUCT" | "CUSTOMER" | "CUSTOMER_ADDRESS" | "RMA_ITEM";

/** An input object that specifies the filters used for attributes. */
export type MagentoApiAttributeFilterInput = {
  /** Whether a product or category attribute can be compared against another or not. */
  is_comparable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute can be filtered or not. */
  is_filterable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute can be filtered in search or not. */
  is_filterable_in_search?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute can use HTML on front or not. */
  is_html_allowed_on_front?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute can be searched or not. */
  is_searchable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a customer or customer address attribute is used for customer segment or not. */
  is_used_for_customer_segment?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute can be used for price rules or not. */
  is_used_for_price_rules?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute is used for promo rules or not. */
  is_used_for_promo_rules?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute is visible in advanced search or not. */
  is_visible_in_advanced_search?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute is visible on front or not. */
  is_visible_on_front?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute has WYSIWYG enabled or not. */
  is_wysiwyg_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute is used in product listing or not. */
  used_in_product_listing?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** EAV attribute frontend input types. */
export type MagentoApiAttributeFrontendInputEnum =
  | "BOOLEAN"
  | "DATE"
  | "DATETIME"
  | "FILE"
  | "GALLERY"
  | "HIDDEN"
  | "IMAGE"
  | "MEDIA_IMAGE"
  | "MULTILINE"
  | "MULTISELECT"
  | "PRICE"
  | "SELECT"
  | "TEXT"
  | "TEXTAREA"
  | "UNDEFINED"
  | "WEIGHT";

/** Defines the attribute characteristics to search for the `attribute_code` and `entity_type` to search. */
export type MagentoApiAttributeInput = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of entity that defines the attribute. */
  entity_type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Specifies selected option for a select or multiselect attribute value. */
export type MagentoApiAttributeInputSelectedOption = {
  /** The attribute option value. */
  value: Scalars["String"]["input"];
};

/** Base EAV implementation of CustomAttributeMetadataInterface. */
export type MagentoApiAttributeMetadata = MagentoApiCustomAttributeMetadataInterface & {
  __typename: "AttributeMetadata";
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars["ID"]["output"];
  /** Default attribute value. */
  default_value?: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type: MagentoApiAttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<MagentoApiAttributeFrontendInputEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars["Boolean"]["output"];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** Attribute options. */
  options: Array<Maybe<MagentoApiCustomAttributeOptionInterface>>;
};

/** Attribute metadata retrieval error. */
export type MagentoApiAttributeMetadataError = {
  __typename: "AttributeMetadataError";
  /** Attribute metadata retrieval error message. */
  message: Scalars["String"]["output"];
  /** Attribute metadata retrieval error type. */
  type: MagentoApiAttributeMetadataErrorType;
};

/** Attribute metadata retrieval error types. */
export type MagentoApiAttributeMetadataErrorType =
  /** The requested attribute was not found. */
  | "ATTRIBUTE_NOT_FOUND"
  /** The requested entity was not found. */
  | "ENTITY_NOT_FOUND"
  /** The filter cannot be applied as it does not belong to the entity */
  | "FILTER_NOT_FOUND"
  /** Not categorized error, see the error message. */
  | "UNDEFINED";

/** Defines an attribute option. */
export type MagentoApiAttributeOption = {
  __typename: "AttributeOption";
  /** The label assigned to the attribute option. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The attribute option value. */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Base EAV implementation of CustomAttributeOptionInterface. */
export type MagentoApiAttributeOptionMetadata = MagentoApiCustomAttributeOptionInterface & {
  __typename: "AttributeOptionMetadata";
  /** Is the option value default. */
  is_default: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute option. */
  label: Scalars["String"]["output"];
  /** The attribute option value. */
  value: Scalars["String"]["output"];
};

export type MagentoApiAttributeSelectedOption = MagentoApiAttributeSelectedOptionInterface & {
  __typename: "AttributeSelectedOption";
  /** The attribute selected option label. */
  label: Scalars["String"]["output"];
  /** The attribute selected option value. */
  value: Scalars["String"]["output"];
};

export type MagentoApiAttributeSelectedOptionInterface = {
  /** The attribute selected option label. */
  label: Scalars["String"]["output"];
  /** The attribute selected option value. */
  value: Scalars["String"]["output"];
};

export type MagentoApiAttributeSelectedOptions = MagentoApiAttributeValueInterface & {
  __typename: "AttributeSelectedOptions";
  /** The attribute code. */
  code: Scalars["ID"]["output"];
  selected_options: Array<Maybe<MagentoApiAttributeSelectedOptionInterface>>;
};

export type MagentoApiAttributeValue = MagentoApiAttributeValueInterface & {
  __typename: "AttributeValue";
  /** The attribute code. */
  code: Scalars["ID"]["output"];
  /** The attribute value. */
  value: Scalars["String"]["output"];
};

/** Specifies the value for attribute. */
export type MagentoApiAttributeValueInput = {
  /** The code of the attribute. */
  attribute_code: Scalars["String"]["input"];
  /** An array containing selected options for a select or multiselect attribute. */
  selected_options?: InputMaybe<Array<InputMaybe<MagentoApiAttributeInputSelectedOption>>>;
  /** The value assigned to the attribute. */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type MagentoApiAttributeValueInterface = {
  /** The attribute code. */
  code: Scalars["ID"]["output"];
};

/** Metadata of EAV attributes associated to form */
export type MagentoApiAttributesFormOutput = {
  __typename: "AttributesFormOutput";
  /** Errors of retrieving certain attributes metadata. */
  errors: Array<Maybe<MagentoApiAttributeMetadataError>>;
  /** Requested attributes metadata. */
  items: Array<Maybe<MagentoApiCustomAttributeMetadataInterface>>;
};

/** Metadata of EAV attributes. */
export type MagentoApiAttributesMetadataOutput = {
  __typename: "AttributesMetadataOutput";
  /** Errors of retrieving certain attributes metadata. */
  errors: Array<Maybe<MagentoApiAttributeMetadataError>>;
  /** Requested attributes metadata. */
  items: Array<Maybe<MagentoApiCustomAttributeMetadataInterface>>;
};

export type MagentoApiAvailableFreeGift = {
  __typename: "AvailableFreeGift";
  /** Products the customer may choose as a free gift */
  allowed_gift_products?: Maybe<Array<Maybe<MagentoApiGiftSelectionProduct>>>;
  /** Maximum number of gift items the customer may add for this rule */
  gift_qty_limit: Scalars["Int"]["output"];
  /** Whether the customer is allowed to remove the selected gift */
  is_removable: Scalars["Boolean"]["output"];
  /** ID of the applied sales rule that enables gift selection */
  sales_rule_id: Scalars["Int"]["output"];
};

/** Describes a payment method that the shopper can use to pay for the order. */
export type MagentoApiAvailablePaymentMethod = {
  __typename: "AvailablePaymentMethod";
  /** The payment method code. */
  code: Scalars["String"]["output"];
  /** If the payment method is an online integration */
  is_deferred: Scalars["Boolean"]["output"];
  /** The payment method title. */
  title: Scalars["String"]["output"];
};

/** Contains details about the possible shipping methods and carriers. */
export type MagentoApiAvailableShippingMethod = {
  __typename: "AvailableShippingMethod";
  /** The cost of shipping using this shipping method. */
  amount: MagentoApiMoney;
  /** Indicates whether this shipping method can be applied to the cart. */
  available: Scalars["Boolean"]["output"];
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<MagentoApiMoney>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars["String"]["output"];
  /** The label for the carrier code. */
  carrier_title: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether this shipping method is disabled for subscriptions. */
  disable_for_subscription?: Maybe<Scalars["Boolean"]["output"]>;
  /** Describes an error condition. */
  error_message?: Maybe<Scalars["String"]["output"]>;
  estimated_delivery_time?: Maybe<Scalars["String"]["output"]>;
  /** A shipping method code associated with a carrier. The value could be null if no method is available. */
  method_code?: Maybe<Scalars["String"]["output"]>;
  /** The label for the shipping method code. The value could be null if no method is available. */
  method_title?: Maybe<Scalars["String"]["output"]>;
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: MagentoApiMoney;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: MagentoApiMoney;
};

export type MagentoApiBatchMutationStatus = "FAILURE" | "MIXED_RESULTS" | "SUCCESS";

/** Defines the billing address. */
export type MagentoApiBillingAddressInput = {
  /** Defines a billing address. */
  address?: InputMaybe<MagentoApiCartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for billing. */
  customer_address_id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Indicates whether to set the billing address to be the same as the existing shipping address on the cart. */
  same_as_shipping?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Indicates whether to set the shipping address to be the same as this billing address. */
  use_for_shipping?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The billing address information */
export type MagentoApiBillingAddressPaymentSourceInput = {
  /** The first line of the address */
  address_line_1?: InputMaybe<Scalars["String"]["input"]>;
  /** The second line of the address */
  address_line_2?: InputMaybe<Scalars["String"]["input"]>;
  /** The city of the address */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** The country of the address */
  country_code: Scalars["String"]["input"];
  /** The postal code of the address */
  postal_code?: InputMaybe<Scalars["String"]["input"]>;
  /** The region of the address */
  region?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains details about the billing address. */
export type MagentoApiBillingCartAddress = MagentoApiCartAddressInterface & {
  __typename: "BillingCartAddress";
  /** Administrative area level 2 */
  administrative_area_level_2?: Maybe<Scalars["String"]["output"]>;
  /** Building Number */
  building_number?: Maybe<Scalars["String"]["output"]>;
  /** The city specified for the billing or shipping address. */
  city: Scalars["String"]["output"];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars["String"]["output"]>;
  /** An object containing the country label and code. */
  country: MagentoApiCartAddressCountry;
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes: Array<Maybe<MagentoApiAttributeValueInterface>>;
  /** @deprecated The field is used only in shipping address. */
  customer_notes?: Maybe<Scalars["String"]["output"]>;
  /** District */
  district?: Maybe<Scalars["String"]["output"]>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars["String"]["output"]>;
  /** The first name of the customer or guest. */
  firstname?: Maybe<Scalars["String"]["output"]>;
  /** Apartment, floor, building, etc. */
  house_details?: Maybe<Scalars["String"]["output"]>;
  /** Id of the customer address. */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** Landmark */
  landmark?: Maybe<Scalars["String"]["output"]>;
  /** The last name of the customer or guest. */
  lastname: Scalars["String"]["output"];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: Maybe<Scalars["String"]["output"]>;
  /** Neighborhood */
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars["String"]["output"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars["String"]["output"]>;
  /** Premise */
  premise?: Maybe<Scalars["String"]["output"]>;
  /** An object containing the region label and code. */
  region?: Maybe<MagentoApiCartAddressRegion>;
  /** Short National Address */
  short_address?: Maybe<Scalars["String"]["output"]>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars["String"]["output"]>>;
  /** Street number */
  street_nr?: Maybe<Scalars["String"]["output"]>;
  /** Sublocality level 2 */
  sublocality_level_2?: Maybe<Scalars["String"]["output"]>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars["String"]["output"]>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars["String"]["output"]>;
  /** The unique id of the customer address. */
  uid: Scalars["String"]["output"];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiBrandConsumablesMatrix = {
  __typename: "BrandConsumablesMatrix";
  brandIcon?: Maybe<Scalars["String"]["output"]>;
  brandLabel: Scalars["String"]["output"];
  brandLabels: Array<Maybe<MagentoApiBrandLabelTranslation>>;
  code: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  isNew: Scalars["Boolean"]["output"];
  items: Array<Maybe<MagentoApiConsumableMatrixItem>>;
  name: Scalars["String"]["output"];
  packagingFormats: Array<Maybe<MagentoApiPackagingFormat>>;
  productBrandOptionId?: Maybe<Scalars["Int"]["output"]>;
};

export type MagentoApiBrandLabelTranslation = {
  __typename: "BrandLabelTranslation";
  label: Scalars["String"]["output"];
  language: Scalars["String"]["output"];
};

/** Contains details about an individual category that comprises a breadcrumb. */
export type MagentoApiBreadcrumb = {
  __typename: "Breadcrumb";
  /**
   * The ID of the category.
   * @deprecated Use `category_uid` instead.
   */
  category_id?: Maybe<Scalars["Int"]["output"]>;
  /** The category level. */
  category_level?: Maybe<Scalars["Int"]["output"]>;
  /** The display name of the category. */
  category_name?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `Breadcrumb` object. */
  category_uid: Scalars["ID"]["output"];
  /** The URL key of the category. */
  category_url_key?: Maybe<Scalars["String"]["output"]>;
  /** The URL path of the category. */
  category_url_path?: Maybe<Scalars["String"]["output"]>;
};

/** An implementation for bundle product cart items. */
export type MagentoApiBundleCartItem = MagentoApiCartItemInterface & {
  __typename: "BundleCartItem";
  /** The list of available gift wrapping options for the cart item. */
  available_gift_wrapping: Array<Maybe<MagentoApiGiftWrapping>>;
  /** An array containing the bundle options the shopper selected. */
  bundle_options: Array<Maybe<MagentoApiSelectedBundleOption>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<MagentoApiCartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** The selected gift wrapping for the cart item. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiCartItemPrices>;
  /** Details about an item in the cart. */
  product: MagentoApiProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines bundle product options for `CreditMemoItemInterface`. */
export type MagentoApiBundleCreditMemoItem = MagentoApiCreditMemoItemInterface & {
  __typename: "BundleCreditMemoItem";
  /** A list of bundle options that are assigned to a bundle product that is part of a credit memo. */
  bundle_options?: Maybe<Array<Maybe<MagentoApiItemSelectedBundleOption>>>;
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars["Float"]["output"]>;
};

/** Defines bundle product options for `InvoiceItemInterface`. */
export type MagentoApiBundleInvoiceItem = MagentoApiInvoiceItemInterface & {
  __typename: "BundleInvoiceItem";
  /** A list of bundle options that are assigned to an invoiced bundle product. */
  bundle_options?: Maybe<Array<Maybe<MagentoApiItemSelectedBundleOption>>>;
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Details about an individual order item. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars["Float"]["output"]>;
};

/** Defines an individual item within a bundle product. */
export type MagentoApiBundleItem = {
  __typename: "BundleItem";
  /** An array of additional options for this bundle item including out of stock options. */
  all_options?: Maybe<Array<Maybe<MagentoApiBundleItemOption>>>;
  /**
   * An ID assigned to each type of item in a bundle product.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars["Int"]["output"]>;
  /** An array of additional options for this bundle item. */
  options?: Maybe<Array<Maybe<MagentoApiBundleItemOption>>>;
  /** A number indicating the sequence order of this item compared to the other bundle items. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** The range of prices for the product */
  price_range: MagentoApiPriceRange;
  /** Maximum allowed qty of items selected for this option */
  qty?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the item must be included in the bundle. */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** The SKU of the bundle product. */
  sku?: Maybe<Scalars["String"]["output"]>;
  /** The display name of the item. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `BundleItem` object. */
  uid?: Maybe<Scalars["ID"]["output"]>;
};

/** Defines the characteristics that comprise a specific bundle item and its options. */
export type MagentoApiBundleItemOption = {
  __typename: "BundleItemOption";
  /** Indicates whether the customer can change the number of items for this option. */
  can_change_quantity?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The ID assigned to the bundled item option.
   * @deprecated Use `uid` instead
   */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether this option is the default option. */
  is_default?: Maybe<Scalars["Boolean"]["output"]>;
  /** The text that identifies the bundled item option. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** The price of the selected option. */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** One of FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<MagentoApiPriceTypeEnum>;
  /** Contains details about this product option. */
  product?: Maybe<MagentoApiProductInterface>;
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated Use `quantity` instead.
   */
  qty?: Maybe<Scalars["Float"]["output"]>;
  /** The quantity of this specific bundle item. */
  quantity?: Maybe<Scalars["Float"]["output"]>;
  /** Swatch data for bundle product option - `color` attribute supported only. */
  swatch_data?: Maybe<MagentoApiSwatchDataInterface>;
  /** The unique ID for a `BundleItemOption` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines the input for a bundle option. */
export type MagentoApiBundleOptionInput = {
  /** The ID of the option. */
  id: Scalars["Int"]["input"];
  quantities?: InputMaybe<Array<InputMaybe<MagentoApiMultiselectQuantity>>>;
  /** The number of the selected item to add to the cart. */
  quantity?: InputMaybe<Scalars["Float"]["input"]>;
  /** An array with the chosen value of the option. */
  value: Array<InputMaybe<Scalars["String"]["input"]>>;
};

/** Defines bundle product options for `OrderItemInterface`. */
export type MagentoApiBundleOrderItem = MagentoApiOrderItemInterface & {
  __typename: "BundleOrderItem";
  /** A list of bundle options that are assigned to the bundle product. */
  bundle_options?: Maybe<Array<Maybe<MagentoApiItemSelectedBundleOption>>>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return?: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: MagentoApiMoney;
  /** The SKU of parent product. */
  parent_sku?: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<MagentoApiProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription?: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested?: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: MagentoApiMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: MagentoApiMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type MagentoApiBundleProduct = MagentoApiCustomizableProductInterface &
  MagentoApiPhysicalProductInterface &
  MagentoApiProductInterface &
  MagentoApiRoutableInterface & {
    __typename: "BundleProduct";
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer?: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<MagentoApiCategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1?: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2?: Maybe<MagentoApiProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code?: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the bundle product has a dynamic price. */
    dynamic_price?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the bundle product has a dynamic SKU. */
    dynamic_sku?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the bundle product has a dynamically calculated weight. */
    dynamic_weight?: Maybe<Scalars["Boolean"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family?: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<MagentoApiFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula?: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts?: Maybe<MagentoApiFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes?: Maybe<Array<Maybe<MagentoApiFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price?: Maybe<MagentoApiMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device?: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image?: Maybe<MagentoApiProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal?: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable?: Maybe<Scalars["String"]["output"]>;
    /** An array containing information about individual bundle items. */
    items?: Maybe<Array<Maybe<MagentoApiBundleItem>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent?: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MagentoApiMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MagentoApiMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type?: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description?: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label?: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price?: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled?: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model?: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks?: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand?: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<MagentoApiCustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<MagentoApiProductPrices>;
    /** The price details of the main product */
    price_details?: Maybe<MagentoApiPriceDetails>;
    /** The range of prices for the product */
    price_range: MagentoApiPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<MagentoApiTierPrice>>>;
    /** One of PRICE_RANGE or AS_LOW_AS. */
    price_view?: Maybe<MagentoApiPriceViewEnum>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand?: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation?: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<MagentoApiProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province?: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label?: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity?: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category?: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region?: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label?: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible?: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: MagentoApiProductReviews;
    /** Indicates whether to ship bundle items together or individually. */
    ship_bundle_items?: Maybe<MagentoApiShipBundleItemsEnum>;
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<MagentoApiProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility?: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status?: Maybe<MagentoApiProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details?: Maybe<MagentoApiStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<MagentoApiProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<MagentoApiProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka?: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku?: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label?: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<MagentoApiUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage?: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<MagentoApiWebsite>>>;
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars["Float"]["output"]>;
  };

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type MagentoApiBundleProductCustom_AttributesV2Args = {
  filters?: InputMaybe<MagentoApiAttributeFilterInput>;
};

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type MagentoApiBundleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Defines a single bundle product. */
export type MagentoApiBundleProductCartItemInput = {
  /** A mandatory array of options for the bundle product, including each chosen option and specified quantity. */
  bundle_options: Array<InputMaybe<MagentoApiBundleOptionInput>>;
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<MagentoApiCustomizableOptionInput>>>;
  /** The quantity and SKU of the bundle product. */
  data: MagentoApiCartItemInput;
};

/** Defines bundle product options for `ShipmentItemInterface`. */
export type MagentoApiBundleShipmentItem = MagentoApiShipmentItemInterface & {
  __typename: "BundleShipmentItem";
  /** A list of bundle options that are assigned to a shipped product. */
  bundle_options?: Maybe<Array<Maybe<MagentoApiItemSelectedBundleOption>>>;
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of shipped items. */
  quantity_shipped: Scalars["Float"]["output"];
};

/** Defines bundle product options for `WishlistItemInterface`. */
export type MagentoApiBundleWishlistItem = MagentoApiWishlistItemInterface & {
  __typename: "BundleWishlistItem";
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** An array containing information about the selected bundle items. */
  bundle_options?: Maybe<Array<Maybe<MagentoApiSelectedBundleOption>>>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

export type MagentoApiButtonStyles = {
  __typename: "ButtonStyles";
  /** The button color */
  color?: Maybe<Scalars["String"]["output"]>;
  /** The button height in pixels */
  height?: Maybe<Scalars["Int"]["output"]>;
  /** The button label */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The button layout */
  layout?: Maybe<Scalars["String"]["output"]>;
  /** The button shape */
  shape?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the tagline is displayed */
  tagline?: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines if the button uses default height. If the value is false, the value of height is used */
  use_default_height?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MagentoApiCanApplyCouponsInput = {
  cart_id: Scalars["String"]["input"];
};

export type MagentoApiCancelOrderError = {
  __typename: "CancelOrderError";
  /** An error code that is specific to cancel order. */
  code: MagentoApiCancelOrderErrorCode;
  /** A localized error message. */
  message: Scalars["String"]["output"];
};

export type MagentoApiCancelOrderErrorCode =
  | "INVALID_ORDER_STATUS"
  | "ORDER_CANCELLATION_DISABLED"
  | "ORDER_NOT_FOUND"
  | "PARTIAL_ORDER_ITEM_SHIPPED"
  | "UNAUTHORISED"
  | "UNDEFINED";

/** Defines the order to cancel. */
export type MagentoApiCancelOrderInput = {
  /** The unique ID of an `Order` type. */
  order_id: Scalars["ID"]["input"];
  /** Cancellation reason. */
  reason: Scalars["String"]["input"];
};

/** Contains the updated customer order and error message if any. */
export type MagentoApiCancelOrderOutput = {
  __typename: "CancelOrderOutput";
  /** Error encountered while cancelling the order. */
  error?: Maybe<Scalars["String"]["output"]>;
  errorV2?: Maybe<MagentoApiCancelOrderError>;
  /** Updated customer order. */
  order?: Maybe<MagentoApiCustomerOrder>;
};

export type MagentoApiCancellationReason = {
  __typename: "CancellationReason";
  description: Scalars["String"]["output"];
};

export type MagentoApiCard = {
  __typename: "Card";
  /** Card bin details */
  bin_details?: Maybe<MagentoApiCardBin>;
  /** Expiration month of the card */
  card_expiry_month?: Maybe<Scalars["String"]["output"]>;
  /** Expiration year of the card */
  card_expiry_year?: Maybe<Scalars["String"]["output"]>;
  /** Last four digits of the card */
  last_digits?: Maybe<Scalars["String"]["output"]>;
  /** Name on the card */
  name?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiCardBin = {
  __typename: "CardBin";
  /** Card bin number */
  bin?: Maybe<Scalars["String"]["output"]>;
};

/** The card payment source information */
export type MagentoApiCardPaymentSourceInput = {
  /** The billing address of the card */
  billing_address: MagentoApiBillingAddressPaymentSourceInput;
  /** The name on the cardholder */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** The card payment source information */
export type MagentoApiCardPaymentSourceOutput = {
  __typename: "CardPaymentSourceOutput";
  /** The brand of the card */
  brand?: Maybe<Scalars["String"]["output"]>;
  /** The expiry of the card */
  expiry?: Maybe<Scalars["String"]["output"]>;
  /** The last digits of the card */
  last_digits?: Maybe<Scalars["String"]["output"]>;
};

/** Contains the contents and other details about a guest or customer cart. */
export type MagentoApiCart = {
  __typename: "Cart";
  /** Quote additional attributes */
  additional_attributes?: Maybe<Array<Maybe<MagentoApiQuoteAttribute>>>;
  applied_campaign?: Maybe<MagentoApiAppliedCampaign>;
  /** @deprecated Use `applied_coupons` instead. */
  applied_coupon?: Maybe<MagentoApiAppliedCoupon>;
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code. */
  applied_coupons?: Maybe<Array<Maybe<MagentoApiAppliedCoupon>>>;
  /** An array of gift card items applied to the cart. */
  applied_gift_cards?: Maybe<Array<Maybe<MagentoApiAppliedGiftCard>>>;
  /** The amount of reward points applied to the cart. */
  applied_reward_points?: Maybe<MagentoApiRewardPointsAmount>;
  /** Store credit information applied to the cart. */
  applied_store_credit?: Maybe<MagentoApiAppliedStoreCredit>;
  /** Free gift options available for customer selection (jti_free_gift_selection rules) */
  available_free_gifts?: Maybe<Array<Maybe<MagentoApiAvailableFreeGift>>>;
  /** The list of available gift wrapping options for the cart. */
  available_gift_wrappings: Array<Maybe<MagentoApiGiftWrapping>>;
  /** An array of available payment methods. */
  available_payment_methods?: Maybe<Array<Maybe<MagentoApiAvailablePaymentMethod>>>;
  /** The billing address assigned to the cart. */
  billing_address?: Maybe<MagentoApiBillingCartAddress>;
  can_apply_coupons: Scalars["Boolean"]["output"];
  /** The cross-selling popup to display for this cart, or null when none applies. */
  cross_sell_popup?: Maybe<MagentoApiCrossSellPopup>;
  /** The email address of the guest or customer. */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Estimated shipping cost for display in the cart. Read-only — does not modify the quote. Requires the jti_quote_graphql/shipping/early_shipping_cost_display_enabled flag to be enabled. */
  estimated_shipping_cost?: Maybe<MagentoApiEstimatedShippingCost>;
  /** Effective free shipping threshold for the cart progress bar in the current store currency. Logged-in customers only. Returns null when no threshold is configured. */
  free_shipping_threshold?: Maybe<Scalars["Float"]["output"]>;
  /** The entered gift message for the cart */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** Indicates whether the shopper requested gift receipt for the cart. */
  gift_receipt_included: Scalars["Boolean"]["output"];
  /** The selected gift wrapping for the cart. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** The unique ID for a `Cart` object. */
  id: Scalars["ID"]["output"];
  is_trial_eligible: Scalars["Boolean"]["output"];
  /** Indicates whether the cart contains only virtual products. */
  is_virtual: Scalars["Boolean"]["output"];
  /**
   * An array of products that have been added to the cart.
   * @deprecated Use `itemsV2` instead.
   */
  items?: Maybe<Array<Maybe<MagentoApiCartItemInterface>>>;
  itemsV2?: Maybe<MagentoApiCartItems>;
  /** Unix timestamp of last cart modification. Used for conditional requests with if_modified_since. */
  last_modified?: Maybe<Scalars["String"]["output"]>;
  /** Last modification time in RFC 7232 format (e.g., 'Thu, 16 Oct 2025 15:57:29 GMT') */
  last_modified_time?: Maybe<Scalars["String"]["output"]>;
  /** Provides the minimum payable amount for the cart */
  minimum_payable_amount?: Maybe<MagentoApiMoney>;
  /** Pricing details for the quote. */
  prices?: Maybe<MagentoApiCartPrices>;
  /** Indicates whether the shopper requested a printed card for the cart. */
  printed_card_included: Scalars["Boolean"]["output"];
  /** Indicates which payment method was applied to the cart. */
  selected_payment_method?: Maybe<MagentoApiSelectedPaymentMethod>;
  /** An array of shipping addresses assigned to the cart. */
  shipping_addresses: Array<Maybe<MagentoApiShippingCartAddress>>;
  subscription_amount?: Maybe<Scalars["Float"]["output"]>;
  total_after_trial?: Maybe<MagentoApiTrialTotals>;
  total_including_trial?: Maybe<MagentoApiTrialTotals>;
  /** The total number of items in the cart. */
  total_quantity: Scalars["Float"]["output"];
  xselling_popup: Scalars["Boolean"]["output"];
};

/** Contains the contents and other details about a guest or customer cart. */
export type MagentoApiCartItemsV2Args = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<MagentoApiQuoteItemsSortInput>;
};

/** Contains details the country in a billing or shipping address. */
export type MagentoApiCartAddressCountry = {
  __typename: "CartAddressCountry";
  /** The country code. */
  code: Scalars["String"]["output"];
  /** The display label for the country. */
  label: Scalars["String"]["output"];
};

/** Extended input for billing or shipping address with region_code support. */
export type MagentoApiCartAddressInput = {
  /** Administrative area level 2 */
  administrative_area_level_2?: InputMaybe<Scalars["String"]["input"]>;
  /** Building Number */
  building_number?: InputMaybe<Scalars["String"]["input"]>;
  /** The city specified for the billing or shipping address. */
  city: Scalars["String"]["input"];
  /** The company specified for the billing or shipping address. */
  company?: InputMaybe<Scalars["String"]["input"]>;
  /** The country code and label for the billing or shipping address. */
  country_code: Scalars["String"]["input"];
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes?: InputMaybe<Array<InputMaybe<MagentoApiAttributeValueInput>>>;
  /** District */
  district?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's fax number. */
  fax?: InputMaybe<Scalars["String"]["input"]>;
  /** The first name of the customer or guest. */
  firstname?: InputMaybe<Scalars["String"]["input"]>;
  /** Apartment, floor, building, etc. */
  house_details?: InputMaybe<Scalars["String"]["input"]>;
  /** States if the selected address is a pickup address */
  is_pickup_address?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Landmark */
  landmark?: InputMaybe<Scalars["String"]["input"]>;
  /** The last name of the customer or guest. */
  lastname: Scalars["String"]["input"];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: InputMaybe<Scalars["String"]["input"]>;
  /** Neighborhood */
  neighborhood?: InputMaybe<Scalars["String"]["input"]>;
  /** JSON encoded string of required fields like store id etc for the pickup point */
  pickup_information?: InputMaybe<Scalars["String"]["input"]>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: InputMaybe<Scalars["String"]["input"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  /** Premise */
  premise?: InputMaybe<Scalars["String"]["input"]>;
  /** A string that defines the state or province of the billing or shipping address. */
  region?: InputMaybe<Scalars["String"]["input"]>;
  /** Two-letter region code (e.g., 'CA' for California). When provided, the region_id will be automatically resolved. */
  region_code?: InputMaybe<Scalars["String"]["input"]>;
  /** An integer that defines the state or province of the billing or shipping address. */
  region_id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Determines whether to save the address in the customer's address book. The default value is true. */
  save_in_address_book?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Short National Address */
  short_address?: InputMaybe<Scalars["String"]["input"]>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<InputMaybe<Scalars["String"]["input"]>>;
  /** Street number */
  street_nr?: InputMaybe<Scalars["String"]["input"]>;
  /** Sublocality level 2 */
  sublocality_level_2?: InputMaybe<Scalars["String"]["input"]>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars["String"]["input"]>;
  /** The telephone number for the billing or shipping address. */
  telephone?: InputMaybe<Scalars["String"]["input"]>;
  /** The VAT company number for billing or shipping address. */
  vat_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type MagentoApiCartAddressInterface = {
  /** Administrative area level 2 */
  administrative_area_level_2?: Maybe<Scalars["String"]["output"]>;
  /** Building Number */
  building_number?: Maybe<Scalars["String"]["output"]>;
  /** The city specified for the billing or shipping address. */
  city: Scalars["String"]["output"];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars["String"]["output"]>;
  /** An object containing the country label and code. */
  country: MagentoApiCartAddressCountry;
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes: Array<Maybe<MagentoApiAttributeValueInterface>>;
  /** District */
  district?: Maybe<Scalars["String"]["output"]>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars["String"]["output"]>;
  /** The first name of the customer or guest. */
  firstname?: Maybe<Scalars["String"]["output"]>;
  /** Apartment, floor, building, etc. */
  house_details?: Maybe<Scalars["String"]["output"]>;
  /** Id of the customer address. */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** Landmark */
  landmark?: Maybe<Scalars["String"]["output"]>;
  /** The last name of the customer or guest. */
  lastname: Scalars["String"]["output"];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: Maybe<Scalars["String"]["output"]>;
  /** Neighborhood */
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars["String"]["output"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars["String"]["output"]>;
  /** Premise */
  premise?: Maybe<Scalars["String"]["output"]>;
  /** An object containing the region label and code. */
  region?: Maybe<MagentoApiCartAddressRegion>;
  /** Short National Address */
  short_address?: Maybe<Scalars["String"]["output"]>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars["String"]["output"]>>;
  /** Street number */
  street_nr?: Maybe<Scalars["String"]["output"]>;
  /** Sublocality level 2 */
  sublocality_level_2?: Maybe<Scalars["String"]["output"]>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars["String"]["output"]>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars["String"]["output"]>;
  /** The unique id of the customer address. */
  uid: Scalars["String"]["output"];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about the region in a billing or shipping address. */
export type MagentoApiCartAddressRegion = {
  __typename: "CartAddressRegion";
  /** The state or province code. */
  code?: Maybe<Scalars["String"]["output"]>;
  /** The display label for the region. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars["Int"]["output"]>;
};

/** Contains information about discounts applied to the cart. */
export type MagentoApiCartDiscount = {
  __typename: "CartDiscount";
  /** The amount of the discount applied to the item. */
  amount: MagentoApiMoney;
  /** The description of the discount. */
  label: Array<Maybe<Scalars["String"]["output"]>>;
};

export type MagentoApiCartDiscountType = "ITEM" | "SHIPPING";

export type MagentoApiCartItemError = {
  __typename: "CartItemError";
  /** An error code that describes the error encountered */
  code: MagentoApiCartItemErrorType;
  /** A localized error message */
  message: Scalars["String"]["output"];
};

export type MagentoApiCartItemErrorType =
  | "CARTONS_LIMIT"
  | "FREEGIFTS_NO_SUCH_CHILD"
  | "FREEGIFTS_NO_SUCH_PARENT"
  | "FREEGIFTS_QTY_ERROR"
  | "FREEGIFTS_UNAVAILABLE"
  | "ITEM_INCREMENT"
  | "ITEM_INCREMENTS"
  | "ITEM_QTY"
  | "LIFETIME_PURCHASE_RESTRICTED"
  | "ONGOING_SUBSCRIPTION"
  | "ORDER_PURCHASE_RESTRICTED"
  | "PRODUCT_DISCONTINUED"
  | "PRODUCT_REGION_MISMATCH"
  | "SALESRULE_GIFT_NOT_VALID"
  | "TRADEIN_LIMIT"
  | "UNDEFINED";

/** Defines an item to be added to the cart. */
export type MagentoApiCartItemInput = {
  /** An array of entered options for the base product, such as personalization text. */
  entered_options?: InputMaybe<Array<InputMaybe<MagentoApiEnteredOptionInput>>>;
  /** For a child product, the SKU of its parent product. */
  parent_sku?: InputMaybe<Scalars["String"]["input"]>;
  /** The amount or number of an item to add. */
  quantity: Scalars["Float"]["input"];
  /** The selected options for the base product, such as color or size, using the unique ID for an object such as `CustomizableRadioOption`, `CustomizableDropDownOption`, or `ConfigurableProductOptionsValues`. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /** The SKU of the product. */
  sku: Scalars["String"]["input"];
};

/** An interface for products in a cart. */
export type MagentoApiCartItemInterface = {
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<MagentoApiCartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiCartItemPrices>;
  /** Details about an item in the cart. */
  product: MagentoApiProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains details about the price of the item, including taxes and discounts. */
export type MagentoApiCartItemPrices = {
  __typename: "CartItemPrices";
  /** The price discount for the unit price of the item represents the difference between its regular price and final price. */
  catalog_discount?: Maybe<MagentoApiProductDiscount>;
  /** An array of discounts to be applied to the cart item. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** An array of FPTs applied to the cart item. */
  fixed_product_taxes?: Maybe<Array<Maybe<MagentoApiFixedProductTax>>>;
  /** The value of the original unit price for the item, including discounts. */
  original_item_price: MagentoApiMoney;
  /** The value of the original price multiplied by the quantity of the item. */
  original_row_total: MagentoApiMoney;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: MagentoApiMoney;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price_including_tax: MagentoApiMoney;
  /** The price discount multiplied by the item quantity represents the total difference between the regular price and the final price for the entire quote item. */
  row_catalog_discount?: Maybe<MagentoApiProductDiscount>;
  /** The value of the price multiplied by the quantity of the item. */
  row_total: MagentoApiMoney;
  /** The value of `row_total` plus the tax applied to the item. */
  row_total_including_tax: MagentoApiMoney;
  /** The total of all discounts applied to the item. */
  total_item_discount?: Maybe<MagentoApiMoney>;
};

/** Deprecated: The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
export type MagentoApiCartItemQuantity = {
  __typename: "CartItemQuantity";
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  cart_item_id: Scalars["Int"]["output"];
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  quantity: Scalars["Float"]["output"];
};

/** Contains details about the price of a selected customizable value. */
export type MagentoApiCartItemSelectedOptionValuePrice = {
  __typename: "CartItemSelectedOptionValuePrice";
  /** Indicates whether the price type is fixed, percent, or dynamic. */
  type: MagentoApiPriceTypeEnum;
  /** A string that describes the unit of the value. */
  units: Scalars["String"]["output"];
  /** A price value. */
  value: Scalars["Float"]["output"];
};

/** A single item to be updated. */
export type MagentoApiCartItemUpdateInput = {
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars["Int"]["input"]>;
  /** The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars["ID"]["input"]>;
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<MagentoApiCustomizableOptionInput>>>;
  /** Gift message details for the cart item */
  gift_message?: InputMaybe<MagentoApiGiftMessageInput>;
  /** The unique ID for a `GiftWrapping` object to be used for the cart item. */
  gift_wrapping_id?: InputMaybe<Scalars["ID"]["input"]>;
  /** The new quantity of the item. */
  quantity?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MagentoApiCartItems = {
  __typename: "CartItems";
  /** An array of products that have been added to the cart. */
  items: Array<Maybe<MagentoApiCartItemInterface>>;
  /** Metadata for pagination rendering. */
  page_info?: Maybe<MagentoApiSearchResultPageInfo>;
  /** The number of returned cart items. */
  total_count: Scalars["Int"]["output"];
};

export type MagentoApiCartPerformanceErrorType =
  /** Cart has not been modified (HTTP 304 equivalent) */
  "CART_NOT_MODIFIED";

/** Contains details about the final price of items in the cart, including discount and tax information. */
export type MagentoApiCartPrices = {
  __typename: "CartPrices";
  /** An array containing the names and amounts of taxes applied to each item in the cart. */
  applied_taxes?: Maybe<Array<Maybe<MagentoApiCartTaxItem>>>;
  /** @deprecated Use discounts instead. */
  discount?: Maybe<MagentoApiCartDiscount>;
  /** An array containing cart rule discounts, store credit and gift cards applied to the cart. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** The list of prices for the selected gift options. */
  gift_options?: Maybe<MagentoApiGiftOptionsPrices>;
  /** The total, including discounts, taxes, shipping, and other fees. */
  grand_total?: Maybe<MagentoApiMoney>;
  /** The total of the cart, including discounts, shipping, and other fees without tax. */
  grand_total_excluding_tax?: Maybe<MagentoApiMoney>;
  /** The subtotal without any applied taxes. */
  subtotal_excluding_tax?: Maybe<MagentoApiMoney>;
  /** The subtotal including any applied taxes. */
  subtotal_including_tax?: Maybe<MagentoApiMoney>;
  /** The subtotal with any discounts applied, but not taxes. */
  subtotal_with_discount_excluding_tax?: Maybe<MagentoApiMoney>;
};

/** Contains tax information about an item in the cart. */
export type MagentoApiCartTaxItem = {
  __typename: "CartTaxItem";
  /** The amount of tax applied to the item. */
  amount: MagentoApiMoney;
  /** The description of the tax. */
  label: Scalars["String"]["output"];
  /** The tax rate percentage. */
  rate?: Maybe<Scalars["Float"]["output"]>;
};

export type MagentoApiCartUserInputError = MagentoApiError & {
  __typename: "CartUserInputError";
  /** A cart-specific error code. */
  code: MagentoApiCartUserInputErrorType;
  /** A localized error message. */
  message: Scalars["String"]["output"];
};

export type MagentoApiCartUserInputErrorType =
  | "COULD_NOT_FIND_CART_ITEM"
  /** 2.4.6 adaptation to errors being thrown in graphql */
  | "GIFT_ERROR"
  | "INSUFFICIENT_STOCK"
  | "INVALID_PARAMETER_VALUE"
  | "LIFETIME_PURCHASE_RESTRICTED"
  | "NOT_SALABLE"
  | "ORDER_PURCHASE_RESTRICTED"
  | "PERMISSION_DENIED"
  | "PRODUCT_DISCONTINUED"
  | "PRODUCT_NOT_FOUND"
  | "REQUIRED_PARAMETER_MISSING"
  | "UNDEFINED";

export type MagentoApiCatalogAttributeApplyToEnum =
  "BUNDLE" | "CATEGORY" | "CONFIGURABLE" | "DOWNLOADABLE" | "GROUPED" | "SIMPLE" | "VIRTUAL";

/** Swatch attribute metadata. */
export type MagentoApiCatalogAttributeMetadata = MagentoApiCustomAttributeMetadataInterface & {
  __typename: "CatalogAttributeMetadata";
  /** To which catalog types an attribute can be applied. */
  apply_to?: Maybe<Array<Maybe<MagentoApiCatalogAttributeApplyToEnum>>>;
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars["ID"]["output"];
  /** Default attribute value. */
  default_value?: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type: MagentoApiAttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<MagentoApiAttributeFrontendInputEnum>;
  /** Whether a product or category attribute can be compared against another or not. */
  is_comparable?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute can be filtered or not. */
  is_filterable?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute can be filtered in search or not. */
  is_filterable_in_search?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute can use HTML on front or not. */
  is_html_allowed_on_front?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether the attribute value is required. */
  is_required: Scalars["Boolean"]["output"];
  /** Whether a product or category attribute can be searched or not. */
  is_searchable?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether the attribute value must be unique. */
  is_unique: Scalars["Boolean"]["output"];
  /** Whether a product or category attribute can be used for price rules or not. */
  is_used_for_price_rules?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute is used for promo rules or not. */
  is_used_for_promo_rules?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute is visible in advanced search or not. */
  is_visible_in_advanced_search?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute is visible on front or not. */
  is_visible_on_front?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute has WYSIWYG enabled or not. */
  is_wysiwyg_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** Attribute options. */
  options: Array<Maybe<MagentoApiCustomAttributeOptionInterface>>;
  /** Input type of the swatch attribute option. */
  swatch_input_type?: Maybe<MagentoApiSwatchInputTypeEnum>;
  /** Whether update product preview image or not. */
  update_product_preview_image?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether use product image for swatch or not. */
  use_product_image_for_swatch?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute is used in product listing or not. */
  used_in_product_listing?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type MagentoApiCategoryFilterInput = {
  /** Filter by the unique category ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Deprecated: use 'category_uid' to filter uniquely identifiers of categories. */
  ids?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Filter by the display name of the category. */
  name?: InputMaybe<MagentoApiFilterMatchTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_category_uid?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_id?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Filter by the part of the URL that identifies the category. */
  url_key?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Filter by the URL path for the category. */
  url_path?: InputMaybe<MagentoApiFilterEqualTypeInput>;
};

/** Contains the full set of attributes that can be returned in a category search. */
export type MagentoApiCategoryInterface = {
  automatic_sorting?: Maybe<Scalars["String"]["output"]>;
  available_sort_by?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<MagentoApiBreadcrumb>>>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url?: Maybe<Scalars["String"]["output"]>;
  children_count?: Maybe<Scalars["String"]["output"]>;
  /** Contains a category CMS block. */
  cms_block?: Maybe<MagentoApiCmsBlock>;
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars["String"]["output"]>;
  custom_layout_update_file?: Maybe<Scalars["String"]["output"]>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars["String"]["output"]>;
  /** An optional description of the category. */
  description?: Maybe<Scalars["String"]["output"]>;
  display_mode?: Maybe<Scalars["String"]["output"]>;
  filter_price_range?: Maybe<Scalars["Float"]["output"]>;
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars["Int"]["output"]>;
  image?: Maybe<Scalars["String"]["output"]>;
  include_in_menu?: Maybe<Scalars["Int"]["output"]>;
  is_anchor?: Maybe<Scalars["Int"]["output"]>;
  jti_new_badge_enabled?: Maybe<Scalars["Int"]["output"]>;
  jti_new_badge_label?: Maybe<Scalars["String"]["output"]>;
  landing_page?: Maybe<Scalars["Int"]["output"]>;
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars["Int"]["output"]>;
  meta_description?: Maybe<Scalars["String"]["output"]>;
  meta_keywords?: Maybe<Scalars["String"]["output"]>;
  meta_title?: Maybe<Scalars["String"]["output"]>;
  /** The display name of the category. */
  name?: Maybe<Scalars["String"]["output"]>;
  /** The full category path. */
  path?: Maybe<Scalars["String"]["output"]>;
  /** The category path within the store. */
  path_in_store?: Maybe<Scalars["String"]["output"]>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count?: Maybe<Scalars["Int"]["output"]>;
  /** The list of products assigned to the category. */
  products?: Maybe<MagentoApiCategoryProducts>;
  /** Indicates whether the category is staged for a future campaign. */
  staged: Scalars["Boolean"]["output"];
  /** Store Locator Name. */
  store_locator_name?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars["ID"]["output"];
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars["String"]["output"]>;
  /** The URL key assigned to the category. */
  url_key?: Maybe<Scalars["String"]["output"]>;
  /** The URL path assigned to the category. */
  url_path?: Maybe<Scalars["String"]["output"]>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars["String"]["output"]>;
};

/** Contains the full set of attributes that can be returned in a category search. */
export type MagentoApiCategoryInterfaceProductsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<MagentoApiProductAttributeSortInput>;
};

/** Contains details about the products assigned to a category. */
export type MagentoApiCategoryProducts = {
  __typename: "CategoryProducts";
  /** An array of products that are assigned to the category. */
  items?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
  /** Pagination metadata. */
  page_info?: Maybe<MagentoApiSearchResultPageInfo>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars["Int"]["output"]>;
};

/** Contains a collection of `CategoryTree` objects and pagination information. */
export type MagentoApiCategoryResult = {
  __typename: "CategoryResult";
  /** A list of categories that match the filter criteria. */
  items?: Maybe<Array<Maybe<MagentoApiCategoryTree>>>;
  /** An object that includes the `page_info` and `currentPage` values specified in the query. */
  page_info?: Maybe<MagentoApiSearchResultPageInfo>;
  /** The total number of categories that match the criteria. */
  total_count?: Maybe<Scalars["Int"]["output"]>;
};

/** Contains the hierarchy of categories. */
export type MagentoApiCategoryTree = MagentoApiCategoryInterface &
  MagentoApiRoutableInterface & {
    __typename: "CategoryTree";
    automatic_sorting?: Maybe<Scalars["String"]["output"]>;
    available_sort_by?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** An array of breadcrumb items. */
    breadcrumbs?: Maybe<Array<Maybe<MagentoApiBreadcrumb>>>;
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
    canonical_url?: Maybe<Scalars["String"]["output"]>;
    /** A tree of child categories. */
    children?: Maybe<Array<Maybe<MagentoApiCategoryTree>>>;
    children_count?: Maybe<Scalars["String"]["output"]>;
    /** Contains a category CMS block. */
    cms_block?: Maybe<MagentoApiCmsBlock>;
    /**
     * The timestamp indicating when the category was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars["String"]["output"]>;
    custom_layout_update_file?: Maybe<Scalars["String"]["output"]>;
    /** The attribute to use for sorting. */
    default_sort_by?: Maybe<Scalars["String"]["output"]>;
    /** An optional description of the category. */
    description?: Maybe<Scalars["String"]["output"]>;
    display_mode?: Maybe<Scalars["String"]["output"]>;
    filter_price_range?: Maybe<Scalars["Float"]["output"]>;
    /**
     * An ID that uniquely identifies the category.
     * @deprecated Use `uid` instead.
     */
    id?: Maybe<Scalars["Int"]["output"]>;
    image?: Maybe<Scalars["String"]["output"]>;
    include_in_menu?: Maybe<Scalars["Int"]["output"]>;
    is_anchor?: Maybe<Scalars["Int"]["output"]>;
    jti_new_badge_enabled?: Maybe<Scalars["Int"]["output"]>;
    jti_new_badge_label?: Maybe<Scalars["String"]["output"]>;
    landing_page?: Maybe<Scalars["Int"]["output"]>;
    /** The depth of the category within the tree. */
    level?: Maybe<Scalars["Int"]["output"]>;
    meta_description?: Maybe<Scalars["String"]["output"]>;
    meta_keywords?: Maybe<Scalars["String"]["output"]>;
    meta_title?: Maybe<Scalars["String"]["output"]>;
    /** The display name of the category. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The full category path. */
    path?: Maybe<Scalars["String"]["output"]>;
    /** The category path within the store. */
    path_in_store?: Maybe<Scalars["String"]["output"]>;
    /** The position of the category relative to other categories at the same level in tree. */
    position?: Maybe<Scalars["Int"]["output"]>;
    /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
    product_count?: Maybe<Scalars["Int"]["output"]>;
    /** The list of products assigned to the category. */
    products?: Maybe<MagentoApiCategoryProducts>;
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the category is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** Store Locator Name. */
    store_locator_name?: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
    /** The unique ID for a `CategoryInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * The timestamp indicating when the category was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars["String"]["output"]>;
    /** The URL key assigned to the category. */
    url_key?: Maybe<Scalars["String"]["output"]>;
    /** The URL path assigned to the category. */
    url_path?: Maybe<Scalars["String"]["output"]>;
    /** The part of the category URL that is appended after the url key */
    url_suffix?: Maybe<Scalars["String"]["output"]>;
  };

/** Contains the hierarchy of categories. */
export type MagentoApiCategoryTreeProductsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<MagentoApiProductAttributeSortInput>;
};

/** Defines details about an individual checkout agreement. */
export type MagentoApiCheckoutAgreement = {
  __typename: "CheckoutAgreement";
  /** The ID for a checkout agreement. */
  agreement_id: Scalars["Int"]["output"];
  /** The checkbox text for the checkout agreement. */
  checkbox_text: Scalars["String"]["output"];
  /** Required. The text of the agreement. */
  content: Scalars["String"]["output"];
  /** The height of the text box where the Terms and Conditions statement appears during checkout. */
  content_height?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the `content` text is in HTML format. */
  is_html: Scalars["Boolean"]["output"];
  /** Indicates whether agreements are accepted automatically or manually. */
  mode: MagentoApiCheckoutAgreementMode;
  /** The name given to the condition. */
  name: Scalars["String"]["output"];
};

/** Indicates how agreements are accepted. */
export type MagentoApiCheckoutAgreementMode =
  /** Conditions are automatically accepted upon checkout. */
  | "AUTO"
  /** Shoppers must manually accept the conditions to place an order. */
  | "MANUAL";

/** An error encountered while adding an item to the cart. */
export type MagentoApiCheckoutUserInputError = {
  __typename: "CheckoutUserInputError";
  /** An error code that is specific to Checkout. */
  code: MagentoApiCheckoutUserInputErrorCodes;
  /** A localized error message. */
  message: Scalars["String"]["output"];
  /** The path to the input field that caused an error. See the GraphQL specification about path errors for details: http://spec.graphql.org/draft/#sec-Errors */
  path: Array<Maybe<Scalars["String"]["output"]>>;
};

export type MagentoApiCheckoutUserInputErrorCodes =
  "INSUFFICIENT_STOCK" | "NOT_SALABLE" | "PRODUCT_NOT_FOUND" | "REORDER_NOT_AVAILABLE" | "UNDEFINED";

/** Contains details about errors encountered when a customer clear cart. */
export type MagentoApiClearCartError = {
  __typename: "ClearCartError";
  /** A localized error message */
  message: Scalars["String"]["output"];
  /** A cart-specific error type. */
  type: MagentoApiClearCartErrorType;
};

export type MagentoApiClearCartErrorType = "INACTIVE" | "NOT_FOUND" | "UNAUTHORISED" | "UNDEFINED";

/** Assigns a specific `cart_id` to the empty cart. */
export type MagentoApiClearCartInput = {
  /** The unique ID of a `Cart` object. */
  uid: Scalars["ID"]["input"];
};

/** Output of the request to clear the customer cart. */
export type MagentoApiClearCartOutput = {
  __typename: "ClearCartOutput";
  /** The cart after clear cart items. */
  cart?: Maybe<MagentoApiCart>;
  /** An array of errors encountered while clearing the cart item */
  errors?: Maybe<Array<Maybe<MagentoApiClearCartError>>>;
};

/** Contains details about a specific CMS block. */
export type MagentoApiCmsBlock = {
  __typename: "CmsBlock";
  /** The content of the CMS block in raw HTML. */
  content?: Maybe<Scalars["String"]["output"]>;
  /** The CMS block identifier. */
  identifier?: Maybe<Scalars["String"]["output"]>;
  /** The title assigned to the CMS block. */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Contains an array CMS block items. */
export type MagentoApiCmsBlocks = {
  __typename: "CmsBlocks";
  /** An array of CMS blocks. */
  items?: Maybe<Array<Maybe<MagentoApiCmsBlock>>>;
};

/** Contains details about a CMS page. */
export type MagentoApiCmsPage = MagentoApiRoutableInterface & {
  __typename: "CmsPage";
  /** The content of the CMS page in raw HTML. */
  content?: Maybe<Scalars["String"]["output"]>;
  /** The heading that displays at the top of the CMS page. */
  content_heading?: Maybe<Scalars["String"]["output"]>;
  /** The ID of a CMS page. */
  identifier?: Maybe<Scalars["String"]["output"]>;
  /** A brief description of the page for search results listings. */
  meta_description?: Maybe<Scalars["String"]["output"]>;
  /** A brief description of the page for search results listings. */
  meta_keywords?: Maybe<Scalars["String"]["output"]>;
  /** A page title that is indexed by search engines and appears in search results listings. */
  meta_title?: Maybe<Scalars["String"]["output"]>;
  /** The design layout of the page, indicating the number of columns and navigation features used on the page. */
  page_layout?: Maybe<Scalars["String"]["output"]>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars["Int"]["output"];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars["String"]["output"]>;
  /** The name that appears in the breadcrumb trail navigation and in the browser title bar and tab. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
  /** The URL key of the CMS page, which is often based on the `content_heading`. */
  url_key?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiColorSwatchData = MagentoApiSwatchDataInterface & {
  __typename: "ColorSwatchData";
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Contains an attribute code that is used for product comparisons. */
export type MagentoApiComparableAttribute = {
  __typename: "ComparableAttribute";
  /** An attribute code that is enabled for product comparisons. */
  code: Scalars["String"]["output"];
  /** The label of the attribute code. */
  label: Scalars["String"]["output"];
};

/** Defines an object used to iterate through items for product comparisons. */
export type MagentoApiComparableItem = {
  __typename: "ComparableItem";
  /** An array of product attributes that can be used to compare products. */
  attributes: Array<Maybe<MagentoApiProductAttribute>>;
  /** Details about a product in a compare list. */
  product: MagentoApiProductInterface;
  /** The unique ID of an item in a compare list. */
  uid: Scalars["ID"]["output"];
};

/** Contains iterable information such as the array of items, the count, and attributes that represent the compare list. */
export type MagentoApiCompareList = {
  __typename: "CompareList";
  /** An array of attributes that can be used for comparing products. */
  attributes?: Maybe<Array<Maybe<MagentoApiComparableAttribute>>>;
  /** The number of items in the compare list. */
  item_count: Scalars["Int"]["output"];
  /** An array of products to compare. */
  items?: Maybe<Array<Maybe<MagentoApiComparableItem>>>;
  /** The unique ID assigned to the compare list. */
  uid: Scalars["ID"]["output"];
};

/** Update the quote and complete the order */
export type MagentoApiCompleteOrderInput = {
  /** The customer cart ID */
  cartId: Scalars["String"]["input"];
  /** PayPal order ID */
  id: Scalars["String"]["input"];
};

export type MagentoApiComplexTextValue = {
  __typename: "ComplexTextValue";
  /** Text that can contain HTML tags. */
  html: Scalars["String"]["output"];
};

/** Contains details about a configurable product attribute option. */
export type MagentoApiConfigurableAttributeOption = {
  __typename: "ConfigurableAttributeOption";
  /** The ID assigned to the attribute. */
  code?: Maybe<Scalars["String"]["output"]>;
  /** A string that describes the configurable attribute option. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `ConfigurableAttributeOption` object. */
  uid: Scalars["ID"]["output"];
  /** A unique index number assigned to the configurable product option. */
  value_index?: Maybe<Scalars["Int"]["output"]>;
};

/** An implementation for configurable product cart items. */
export type MagentoApiConfigurableCartItem = MagentoApiCartItemInterface & {
  __typename: "ConfigurableCartItem";
  /** The list of available gift wrapping options for the cart item. */
  available_gift_wrapping: Array<Maybe<MagentoApiGiftWrapping>>;
  /** An array containing the configuranle options the shopper selected. */
  configurable_options: Array<Maybe<MagentoApiSelectedConfigurableOption>>;
  /** Product details of the cart item. */
  configured_variant: MagentoApiProductInterface;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<MagentoApiCartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** The selected gift wrapping for the cart item. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiCartItemPrices>;
  /** Details about an item in the cart. */
  product: MagentoApiProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Describes configurable options that have been selected and can be selected as a result of the previous selections. */
export type MagentoApiConfigurableOptionAvailableForSelection = {
  __typename: "ConfigurableOptionAvailableForSelection";
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars["String"]["output"];
  /** An array of selectable option value IDs. */
  option_value_uids: Array<Maybe<Scalars["ID"]["output"]>>;
};

export type MagentoApiConfigurableOrderItem = MagentoApiOrderItemInterface & {
  __typename: "ConfigurableOrderItem";
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return?: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: MagentoApiMoney;
  /** The SKU of parent product. */
  parent_sku?: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<MagentoApiProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription?: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested?: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: MagentoApiMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: MagentoApiMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Defines basic features of a configurable product and its simple product variants. */
export type MagentoApiConfigurableProduct = MagentoApiCustomizableProductInterface &
  MagentoApiPhysicalProductInterface &
  MagentoApiProductInterface &
  MagentoApiRoutableInterface & {
    __typename: "ConfigurableProduct";
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer?: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<MagentoApiCategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label?: Maybe<Scalars["String"]["output"]>;
    /** An array of options for the configurable product. */
    configurable_options?: Maybe<Array<Maybe<MagentoApiConfigurableProductOptions>>>;
    /** An array of media gallery items and other details about selected configurable product options as well as details about remaining selectable options. */
    configurable_product_options_selection?: Maybe<MagentoApiConfigurableProductOptionsSelection>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1?: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2?: Maybe<MagentoApiProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code?: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family?: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<MagentoApiFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula?: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts?: Maybe<MagentoApiFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes?: Maybe<Array<Maybe<MagentoApiFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price?: Maybe<MagentoApiMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device?: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image?: Maybe<MagentoApiProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal?: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent?: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MagentoApiMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MagentoApiMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type?: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description?: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label?: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price?: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled?: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model?: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks?: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand?: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<MagentoApiCustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<MagentoApiProductPrices>;
    /** The range of prices for the product */
    price_range: MagentoApiPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<MagentoApiTierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand?: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation?: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<MagentoApiProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province?: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label?: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity?: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category?: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region?: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label?: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible?: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: MagentoApiProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<MagentoApiProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility?: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status?: Maybe<MagentoApiProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details?: Maybe<MagentoApiStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<MagentoApiProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<MagentoApiProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka?: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku?: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label?: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<MagentoApiUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars["String"]["output"]>;
    /** An array of simple product variants. */
    variants?: Maybe<Array<Maybe<MagentoApiConfigurableVariant>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage?: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<MagentoApiWebsite>>>;
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars["Float"]["output"]>;
  };

/** Defines basic features of a configurable product and its simple product variants. */
export type MagentoApiConfigurableProductConfigurable_Product_Options_SelectionArgs = {
  configurableOptionValueUids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Defines basic features of a configurable product and its simple product variants. */
export type MagentoApiConfigurableProductCustom_AttributesV2Args = {
  filters?: InputMaybe<MagentoApiAttributeFilterInput>;
};

/** Defines basic features of a configurable product and its simple product variants. */
export type MagentoApiConfigurableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MagentoApiConfigurableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<MagentoApiCustomizableOptionInput>>>;
  /** The quantity and SKU of the configurable product. */
  data: MagentoApiCartItemInput;
  /** The SKU of the parent configurable product. */
  parent_sku?: InputMaybe<Scalars["String"]["input"]>;
  variant_sku?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains details about configurable product options. */
export type MagentoApiConfigurableProductOption = {
  __typename: "ConfigurableProductOption";
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars["String"]["output"];
  /** The display name of the option. */
  label: Scalars["String"]["output"];
  /** The unique ID of the configurable option. */
  uid: Scalars["ID"]["output"];
  /** An array of values that are applicable for this option. */
  values?: Maybe<Array<Maybe<MagentoApiConfigurableProductOptionValue>>>;
};

/** Defines a value for a configurable product option. */
export type MagentoApiConfigurableProductOptionValue = {
  __typename: "ConfigurableProductOptionValue";
  /** Indicates whether the product is available with this selected option. */
  is_available: Scalars["Boolean"]["output"];
  /** Indicates whether the value is the default. */
  is_use_default: Scalars["Boolean"]["output"];
  /** The display name of the value. */
  label: Scalars["String"]["output"];
  /** The URL assigned to the thumbnail of the swatch image. */
  swatch?: Maybe<MagentoApiSwatchDataInterface>;
  /** The unique ID of the value. */
  uid: Scalars["ID"]["output"];
};

/** Defines configurable attributes for the specified product. */
export type MagentoApiConfigurableProductOptions = {
  __typename: "ConfigurableProductOptions";
  /** A string that identifies the attribute. */
  attribute_code?: Maybe<Scalars["String"]["output"]>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id?: Maybe<Scalars["String"]["output"]>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id_v2?: Maybe<Scalars["Int"]["output"]>;
  /** The unique ID for an `Attribute` object. */
  attribute_uid: Scalars["ID"]["output"];
  /**
   * The configurable option ID number assigned by the system.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** A displayed string that describes the configurable product option. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** A number that indicates the order in which the attribute is displayed. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /**
   * This is the same as a product's `id` field.
   * @deprecated `product_id` is not needed and can be obtained from its parent.
   */
  product_id?: Maybe<Scalars["Int"]["output"]>;
  /** The unique ID for a `ConfigurableProductOptions` object. */
  uid: Scalars["ID"]["output"];
  /** Indicates whether the option is the default. */
  use_default?: Maybe<Scalars["Boolean"]["output"]>;
  /** An array that defines the `value_index` codes assigned to the configurable product. */
  values?: Maybe<Array<Maybe<MagentoApiConfigurableProductOptionsValues>>>;
};

/** Contains metadata corresponding to the selected configurable options. */
export type MagentoApiConfigurableProductOptionsSelection = {
  __typename: "ConfigurableProductOptionsSelection";
  /** An array of all possible configurable options. */
  configurable_options?: Maybe<Array<Maybe<MagentoApiConfigurableProductOption>>>;
  /** Product images and videos corresponding to the specified configurable options selection. */
  media_gallery?: Maybe<Array<Maybe<MagentoApiMediaGalleryInterface>>>;
  /** The configurable options available for further selection based on the current selection. */
  options_available_for_selection?: Maybe<Array<Maybe<MagentoApiConfigurableOptionAvailableForSelection>>>;
  /** A variant represented by the specified configurable options selection. The value is expected to be null until selections are made for each configurable option. */
  variant?: Maybe<MagentoApiSimpleProduct>;
};

/** Contains the index number assigned to a configurable product option. */
export type MagentoApiConfigurableProductOptionsValues = {
  __typename: "ConfigurableProductOptionsValues";
  /** The label of the product on the default store. */
  default_label?: Maybe<Scalars["String"]["output"]>;
  /** The label of the product. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The label of the product on the current store. */
  store_label?: Maybe<Scalars["String"]["output"]>;
  /** Swatch data for a configurable product option. */
  swatch_data?: Maybe<MagentoApiSwatchDataInterface>;
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  uid?: Maybe<Scalars["ID"]["output"]>;
  /** Indicates whether to use the default_label. */
  use_default_value?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * A unique index number assigned to the configurable product option.
   * @deprecated Use `uid` instead.
   */
  value_index?: Maybe<Scalars["Int"]["output"]>;
};

/** Contains all the simple product variants of a configurable product. */
export type MagentoApiConfigurableVariant = {
  __typename: "ConfigurableVariant";
  /** An array of configurable attribute options. */
  attributes?: Maybe<Array<Maybe<MagentoApiConfigurableAttributeOption>>>;
  /** An array of linked simple products. */
  product?: Maybe<MagentoApiSimpleProduct>;
  variant_position?: Maybe<Scalars["Int"]["output"]>;
};

/** A configurable product wish list item. */
export type MagentoApiConfigurableWishlistItem = MagentoApiWishlistItemInterface & {
  __typename: "ConfigurableWishlistItem";
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /**
   * The SKU of the simple product corresponding to a set of selected configurable options.
   * @deprecated Use `ConfigurableWishlistItem.configured_variant.sku` instead.
   */
  child_sku: Scalars["String"]["output"];
  /** An array of selected configurable options. */
  configurable_options?: Maybe<Array<Maybe<MagentoApiSelectedConfigurableOption>>>;
  /** Product details of the selected variant. The value is null if some options are not configured. */
  configured_variant?: Maybe<MagentoApiProductInterface>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

export type MagentoApiConfirmCancelOrderInput = {
  /** Confirmation Key to cancel the order. */
  confirmation_key: Scalars["String"]["input"];
  /** The unique ID of an `Order` type. */
  order_id: Scalars["ID"]["input"];
};

/** Contains details about a customer email address to confirm. */
export type MagentoApiConfirmEmailInput = {
  /** The key to confirm the email address. */
  confirmation_key: Scalars["String"]["input"];
  /** The email address to be confirmed. */
  email: Scalars["String"]["input"];
};

export type MagentoApiConfirmReturnInput = {
  /** Confirmation Key to return order. */
  confirmation_key: Scalars["String"]["input"];
  /** The unique ID of an `Order` type. */
  order_id: Scalars["ID"]["input"];
};

/** List of account confirmation statuses. */
export type MagentoApiConfirmationStatusEnum =
  /** Account confirmation not required */
  | "ACCOUNT_CONFIRMATION_NOT_REQUIRED"
  /** Account confirmed */
  | "ACCOUNT_CONFIRMED";

export type MagentoApiConsumableMatrixItem = {
  __typename: "ConsumableMatrixItem";
  brandId: Scalars["ID"]["output"];
  flavorDetails: MagentoApiConsumableMatrixItemFlavorDetails;
  flavorFamily: Array<Maybe<Scalars["String"]["output"]>>;
  isDefault: Scalars["Boolean"]["output"];
  packagingFormatId: Scalars["ID"]["output"];
  purchaseType: Scalars["String"]["output"];
  sku: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  /** Strength details associated with the matrix item SKU. */
  strengthDetails?: Maybe<MagentoApiConsumableMatrixItemStrengthDetails>;
};

export type MagentoApiConsumableMatrixItemFlavorDetails = {
  __typename: "ConsumableMatrixItemFlavorDetails";
  flavour?: Maybe<Scalars["Int"]["output"]>;
  flavour_label?: Maybe<Scalars["String"]["output"]>;
  swatch_data?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiConsumableMatrixItemStrengthDetails = {
  __typename: "ConsumableMatrixItemStrengthDetails";
  /** Strength label configured in Magento. */
  name: Scalars["String"]["output"];
  /** Numeric rating used to render the strength indicator. */
  rating: Scalars["Int"]["output"];
};

export type MagentoApiConsumablesMatrix = {
  __typename: "ConsumablesMatrix";
  items: Array<Maybe<MagentoApiConsumableMatrixItem>>;
  packagingFormats: Array<Maybe<MagentoApiPackagingFormat>>;
};

export type MagentoApiContactUsInput = {
  /** The shopper's comment to the merchant. */
  comment: Scalars["String"]["input"];
  /** The email address of the shopper. */
  email: Scalars["String"]["input"];
  /** The full name of the shopper. */
  name: Scalars["String"]["input"];
  /** The shopper's telephone number. */
  telephone?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains the status of the request. */
export type MagentoApiContactUsOutput = {
  __typename: "ContactUsOutput";
  /** Indicates whether the request was successful. */
  status: Scalars["Boolean"]["output"];
};

/** Contains the source and target wish lists after copying products. */
export type MagentoApiCopyProductsBetweenWishlistsOutput = {
  __typename: "CopyProductsBetweenWishlistsOutput";
  /** The destination wish list containing the copied products. */
  destination_wishlist: MagentoApiWishlist;
  /** The wish list that the products were copied from. */
  source_wishlist: MagentoApiWishlist;
  /** An array of errors encountered while copying products in a wish list. */
  user_errors: Array<Maybe<MagentoApiWishListUserInputError>>;
};

export type MagentoApiCountry = {
  __typename: "Country";
  /** An array of regions within a particular country. */
  available_regions?: Maybe<Array<Maybe<MagentoApiRegion>>>;
  /** The name of the country in English. */
  full_name_english?: Maybe<Scalars["String"]["output"]>;
  /** The name of the country in the current locale. */
  full_name_locale?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `Country` object. */
  id?: Maybe<Scalars["String"]["output"]>;
  /** The three-letter abbreviation of the country, such as USA. */
  three_letter_abbreviation?: Maybe<Scalars["String"]["output"]>;
  /** The two-letter abbreviation of the country, such as US. */
  two_letter_abbreviation?: Maybe<Scalars["String"]["output"]>;
};

/** The list of country codes. */
export type MagentoApiCountryCodeEnum =
  /** Andorra */
  | "AD"
  /** United Arab Emirates */
  | "AE"
  /** Afghanistan */
  | "AF"
  /** Antigua & Barbuda */
  | "AG"
  /** Anguilla */
  | "AI"
  /** Albania */
  | "AL"
  /** Armenia */
  | "AM"
  /** Netherlands Antilles */
  | "AN"
  /** Angola */
  | "AO"
  /** Antarctica */
  | "AQ"
  /** Argentina */
  | "AR"
  /** American Samoa */
  | "AS"
  /** Austria */
  | "AT"
  /** Australia */
  | "AU"
  /** Aruba */
  | "AW"
  /** Åland Islands */
  | "AX"
  /** Azerbaijan */
  | "AZ"
  /** Bosnia & Herzegovina */
  | "BA"
  /** Barbados */
  | "BB"
  /** Bangladesh */
  | "BD"
  /** Belgium */
  | "BE"
  /** Burkina Faso */
  | "BF"
  /** Bulgaria */
  | "BG"
  /** Bahrain */
  | "BH"
  /** Burundi */
  | "BI"
  /** Benin */
  | "BJ"
  /** St. Barthélemy */
  | "BL"
  /** Bermuda */
  | "BM"
  /** Brunei */
  | "BN"
  /** Bolivia */
  | "BO"
  /** Brazil */
  | "BR"
  /** Bahamas */
  | "BS"
  /** Bhutan */
  | "BT"
  /** Bouvet Island */
  | "BV"
  /** Botswana */
  | "BW"
  /** Belarus */
  | "BY"
  /** Belize */
  | "BZ"
  /** Canada */
  | "CA"
  /** Cocos (Keeling) Islands */
  | "CC"
  /** Congo-Kinshasa */
  | "CD"
  /** Central African Republic */
  | "CF"
  /** Congo-Brazzaville */
  | "CG"
  /** Switzerland */
  | "CH"
  /** Côte d’Ivoire */
  | "CI"
  /** Cook Islands */
  | "CK"
  /** Chile */
  | "CL"
  /** Cameroon */
  | "CM"
  /** China */
  | "CN"
  /** Colombia */
  | "CO"
  /** Costa Rica */
  | "CR"
  /** Cuba */
  | "CU"
  /** Cape Verde */
  | "CV"
  /** Christmas Island */
  | "CX"
  /** Cyprus */
  | "CY"
  /** Czech Republic */
  | "CZ"
  /** Germany */
  | "DE"
  /** Djibouti */
  | "DJ"
  /** Denmark */
  | "DK"
  /** Dominica */
  | "DM"
  /** Dominican Republic */
  | "DO"
  /** Algeria */
  | "DZ"
  /** Ecuador */
  | "EC"
  /** Estonia */
  | "EE"
  /** Egypt */
  | "EG"
  /** Western Sahara */
  | "EH"
  /** Eritrea */
  | "ER"
  /** Spain */
  | "ES"
  /** Ethiopia */
  | "ET"
  /** Finland */
  | "FI"
  /** Fiji */
  | "FJ"
  /** Falkland Islands */
  | "FK"
  /** Micronesia */
  | "FM"
  /** Faroe Islands */
  | "FO"
  /** France */
  | "FR"
  /** Gabon */
  | "GA"
  /** United Kingdom */
  | "GB"
  /** Grenada */
  | "GD"
  /** Georgia */
  | "GE"
  /** French Guiana */
  | "GF"
  /** Guernsey */
  | "GG"
  /** Ghana */
  | "GH"
  /** Gibraltar */
  | "GI"
  /** Greenland */
  | "GL"
  /** Gambia */
  | "GM"
  /** Guinea */
  | "GN"
  /** Guadeloupe */
  | "GP"
  /** Equatorial Guinea */
  | "GQ"
  /** Greece */
  | "GR"
  /** South Georgia & South Sandwich Islands */
  | "GS"
  /** Guatemala */
  | "GT"
  /** Guam */
  | "GU"
  /** Guinea-Bissau */
  | "GW"
  /** Guyana */
  | "GY"
  /** Hong Kong SAR China */
  | "HK"
  /** Heard &amp; McDonald Islands */
  | "HM"
  /** Honduras */
  | "HN"
  /** Croatia */
  | "HR"
  /** Haiti */
  | "HT"
  /** Hungary */
  | "HU"
  /** Indonesia */
  | "ID"
  /** Ireland */
  | "IE"
  /** Israel */
  | "IL"
  /** Isle of Man */
  | "IM"
  /** India */
  | "IN"
  /** British Indian Ocean Territory */
  | "IO"
  /** Iraq */
  | "IQ"
  /** Iran */
  | "IR"
  /** Iceland */
  | "IS"
  /** Italy */
  | "IT"
  /** Jersey */
  | "JE"
  /** Jamaica */
  | "JM"
  /** Jordan */
  | "JO"
  /** Japan */
  | "JP"
  /** Kenya */
  | "KE"
  /** Kyrgyzstan */
  | "KG"
  /** Cambodia */
  | "KH"
  /** Kiribati */
  | "KI"
  /** Comoros */
  | "KM"
  /** St. Kitts & Nevis */
  | "KN"
  /** North Korea */
  | "KP"
  /** South Korea */
  | "KR"
  /** Kuwait */
  | "KW"
  /** Cayman Islands */
  | "KY"
  /** Kazakhstan */
  | "KZ"
  /** Laos */
  | "LA"
  /** Lebanon */
  | "LB"
  /** St. Lucia */
  | "LC"
  /** Liechtenstein */
  | "LI"
  /** Sri Lanka */
  | "LK"
  /** Liberia */
  | "LR"
  /** Lesotho */
  | "LS"
  /** Lithuania */
  | "LT"
  /** Luxembourg */
  | "LU"
  /** Latvia */
  | "LV"
  /** Libya */
  | "LY"
  /** Morocco */
  | "MA"
  /** Monaco */
  | "MC"
  /** Moldova */
  | "MD"
  /** Montenegro */
  | "ME"
  /** St. Martin */
  | "MF"
  /** Madagascar */
  | "MG"
  /** Marshall Islands */
  | "MH"
  /** Macedonia */
  | "MK"
  /** Mali */
  | "ML"
  /** Myanmar (Burma) */
  | "MM"
  /** Mongolia */
  | "MN"
  /** Macau SAR China */
  | "MO"
  /** Northern Mariana Islands */
  | "MP"
  /** Martinique */
  | "MQ"
  /** Mauritania */
  | "MR"
  /** Montserrat */
  | "MS"
  /** Malta */
  | "MT"
  /** Mauritius */
  | "MU"
  /** Maldives */
  | "MV"
  /** Malawi */
  | "MW"
  /** Mexico */
  | "MX"
  /** Malaysia */
  | "MY"
  /** Mozambique */
  | "MZ"
  /** Namibia */
  | "NA"
  /** New Caledonia */
  | "NC"
  /** Niger */
  | "NE"
  /** Norfolk Island */
  | "NF"
  /** Nigeria */
  | "NG"
  /** Nicaragua */
  | "NI"
  /** Netherlands */
  | "NL"
  /** Norway */
  | "NO"
  /** Nepal */
  | "NP"
  /** Nauru */
  | "NR"
  /** Niue */
  | "NU"
  /** New Zealand */
  | "NZ"
  /** Oman */
  | "OM"
  /** Panama */
  | "PA"
  /** Peru */
  | "PE"
  /** French Polynesia */
  | "PF"
  /** Papua New Guinea */
  | "PG"
  /** Philippines */
  | "PH"
  /** Pakistan */
  | "PK"
  /** Poland */
  | "PL"
  /** St. Pierre & Miquelon */
  | "PM"
  /** Pitcairn Islands */
  | "PN"
  /** Palestinian Territories */
  | "PS"
  /** Portugal */
  | "PT"
  /** Palau */
  | "PW"
  /** Paraguay */
  | "PY"
  /** Qatar */
  | "QA"
  /** Réunion */
  | "RE"
  /** Romania */
  | "RO"
  /** Serbia */
  | "RS"
  /** Russia */
  | "RU"
  /** Rwanda */
  | "RW"
  /** Saudi Arabia */
  | "SA"
  /** Solomon Islands */
  | "SB"
  /** Seychelles */
  | "SC"
  /** Sudan */
  | "SD"
  /** Sweden */
  | "SE"
  /** Singapore */
  | "SG"
  /** St. Helena */
  | "SH"
  /** Slovenia */
  | "SI"
  /** Svalbard & Jan Mayen */
  | "SJ"
  /** Slovakia */
  | "SK"
  /** Sierra Leone */
  | "SL"
  /** San Marino */
  | "SM"
  /** Senegal */
  | "SN"
  /** Somalia */
  | "SO"
  /** Suriname */
  | "SR"
  /** São Tomé & Príncipe */
  | "ST"
  /** El Salvador */
  | "SV"
  /** Syria */
  | "SY"
  /** Eswatini */
  | "SZ"
  /** Turks & Caicos Islands */
  | "TC"
  /** Chad */
  | "TD"
  /** French Southern Territories */
  | "TF"
  /** Togo */
  | "TG"
  /** Thailand */
  | "TH"
  /** Tajikistan */
  | "TJ"
  /** Tokelau */
  | "TK"
  /** Timor-Leste */
  | "TL"
  /** Turkmenistan */
  | "TM"
  /** Tunisia */
  | "TN"
  /** Tonga */
  | "TO"
  /** Turkey */
  | "TR"
  /** Trinidad & Tobago */
  | "TT"
  /** Tuvalu */
  | "TV"
  /** Taiwan */
  | "TW"
  /** Tanzania */
  | "TZ"
  /** Ukraine */
  | "UA"
  /** Uganda */
  | "UG"
  /** U.S. Outlying Islands */
  | "UM"
  /** United States */
  | "US"
  /** Uruguay */
  | "UY"
  /** Uzbekistan */
  | "UZ"
  /** Vatican City */
  | "VA"
  /** St. Vincent & Grenadines */
  | "VC"
  /** Venezuela */
  | "VE"
  /** British Virgin Islands */
  | "VG"
  /** U.S. Virgin Islands */
  | "VI"
  /** Vietnam */
  | "VN"
  /** Vanuatu */
  | "VU"
  /** Wallis & Futuna */
  | "WF"
  /** Samoa */
  | "WS"
  /** Yemen */
  | "YE"
  /** Mayotte */
  | "YT"
  /** South Africa */
  | "ZA"
  /** Zambia */
  | "ZM"
  /** Zimbabwe */
  | "ZW";

/** Contains an array of product IDs to use for creating a compare list. */
export type MagentoApiCreateCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

/** Defines a new gift registry. */
export type MagentoApiCreateGiftRegistryInput = {
  /** Additional attributes specified as a code-value pair. */
  dynamic_attributes?: InputMaybe<Array<InputMaybe<MagentoApiGiftRegistryDynamicAttributeInput>>>;
  /** The name of the event. */
  event_name: Scalars["String"]["input"];
  /** The ID of the selected event type. */
  gift_registry_type_uid: Scalars["ID"]["input"];
  /** A message describing the event. */
  message: Scalars["String"]["input"];
  /** Indicates whether the registry is PRIVATE or PUBLIC. */
  privacy_settings: MagentoApiGiftRegistryPrivacySettings;
  /** The list of people who receive notifications about the registry. */
  registrants: Array<InputMaybe<MagentoApiAddGiftRegistryRegistrantInput>>;
  /** The shipping address for all gift registry items. */
  shipping_address?: InputMaybe<MagentoApiGiftRegistryShippingAddressInput>;
  /** Indicates whether the registry is ACTIVE or INACTIVE. */
  status: MagentoApiGiftRegistryStatus;
};

/** Contains the results of a request to create a gift registry. */
export type MagentoApiCreateGiftRegistryOutput = {
  __typename: "CreateGiftRegistryOutput";
  /** The newly-created gift registry. */
  gift_registry?: Maybe<MagentoApiGiftRegistry>;
};

export type MagentoApiCreateGuestCartInput = {
  /** Optional client-generated ID */
  cart_uid?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MagentoApiCreateGuestCartOutput = {
  __typename: "CreateGuestCartOutput";
  /** The newly created cart. */
  cart?: Maybe<MagentoApiCart>;
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type MagentoApiCreatePayflowProTokenOutput = {
  __typename: "CreatePayflowProTokenOutput";
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars["String"]["output"];
  /** A non-zero value if any errors occurred. */
  result: Scalars["Int"]["output"];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars["Int"]["output"];
  /** A secure token generated by PayPal. */
  secure_token: Scalars["String"]["output"];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars["String"]["output"];
};

/** Contains payment order details that are used while processing the payment order */
export type MagentoApiCreatePaymentOrderInput = {
  /** The customer cart ID */
  cartId: Scalars["String"]["input"];
  /** Defines the origin location for that payment request */
  location: MagentoApiPaymentLocation;
  /** The code for the payment method used in the order */
  methodCode: Scalars["String"]["input"];
  /** The identifiable payment source for the payment method */
  paymentSource: Scalars["String"]["input"];
  /** Indicates whether the payment information should be vaulted */
  vaultIntent?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Contains payment order details that are used while processing the payment order */
export type MagentoApiCreatePaymentOrderOutput = {
  __typename: "CreatePaymentOrderOutput";
  /** The amount of the payment order */
  amount?: Maybe<Scalars["Float"]["output"]>;
  /** The currency of the payment order */
  currency_code?: Maybe<Scalars["String"]["output"]>;
  /** PayPal order ID */
  id?: Maybe<Scalars["String"]["output"]>;
  /** The order ID generated by Payment Services */
  mp_order_id?: Maybe<Scalars["String"]["output"]>;
  /** The status of the payment order */
  status?: Maybe<Scalars["String"]["output"]>;
};

/** Defines a new product review. */
export type MagentoApiCreateProductReviewInput = {
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars["String"]["input"];
  /** The ratings details by category. For example, Price: 5 stars, Quality: 4 stars, etc. */
  ratings: Array<InputMaybe<MagentoApiProductReviewRatingInput>>;
  /** The SKU of the reviewed product. */
  sku: Scalars["String"]["input"];
  /** The summary (title) of the review. */
  summary: Scalars["String"]["input"];
  /** The review text. */
  text: Scalars["String"]["input"];
};

/** Contains the completed product review. */
export type MagentoApiCreateProductReviewOutput = {
  __typename: "CreateProductReviewOutput";
  /** Product review details. */
  review: MagentoApiProductReview;
};

/** Describe the variables needed to create a vault payment token */
export type MagentoApiCreateVaultCardPaymentTokenInput = {
  /** Description of the vaulted card */
  card_description?: InputMaybe<Scalars["String"]["input"]>;
  /** The setup token obtained by the createVaultCardSetupToken endpoint */
  setup_token_id: Scalars["String"]["input"];
};

/** The vault token id and information about the payment source */
export type MagentoApiCreateVaultCardPaymentTokenOutput = {
  __typename: "CreateVaultCardPaymentTokenOutput";
  /** The payment source information */
  payment_source: MagentoApiPaymentSourceOutput;
  /** The vault payment token information */
  vault_token_id: Scalars["String"]["output"];
};

/** Describe the variables needed to create a vault card setup token */
export type MagentoApiCreateVaultCardSetupTokenInput = {
  /** The setup token information */
  setup_token: MagentoApiVaultSetupTokenInput;
  /** The 3DS mode */
  three_ds_mode?: InputMaybe<MagentoApiThreeDsMode>;
};

/** The setup token id information */
export type MagentoApiCreateVaultCardSetupTokenOutput = {
  __typename: "CreateVaultCardSetupTokenOutput";
  /** The setup token id */
  setup_token: Scalars["String"]["output"];
};

/** Defines the name and visibility of a new wish list. */
export type MagentoApiCreateWishlistInput = {
  /** The name of the new wish list. */
  name: Scalars["String"]["input"];
  /** Indicates whether the wish list is public or private. */
  visibility: MagentoApiWishlistVisibilityEnum;
};

/** Contains the wish list. */
export type MagentoApiCreateWishlistOutput = {
  __typename: "CreateWishlistOutput";
  /** The newly-created wish list */
  wishlist: MagentoApiWishlist;
};

/** Required fields for Payflow Pro and Payments Pro credit card payments. */
export type MagentoApiCreditCardDetailsInput = {
  /** The credit card expiration month. */
  cc_exp_month: Scalars["Int"]["input"];
  /** The credit card expiration year. */
  cc_exp_year: Scalars["Int"]["input"];
  /** The last 4 digits of the credit card. */
  cc_last_4: Scalars["Int"]["input"];
  /** The credit card type. */
  cc_type: Scalars["String"]["input"];
};

/** Contains credit memo details. */
export type MagentoApiCreditMemo = {
  __typename: "CreditMemo";
  /** Comments on the credit memo. */
  comments?: Maybe<Array<Maybe<MagentoApiSalesCommentItem>>>;
  /** The unique ID for a `CreditMemo` object. */
  id: Scalars["ID"]["output"];
  /** An array containing details about refunded items. */
  items?: Maybe<Array<Maybe<MagentoApiCreditMemoItemInterface>>>;
  /** The sequential credit memo number. */
  number: Scalars["String"]["output"];
  /** Details about the total refunded amount. */
  total?: Maybe<MagentoApiCreditMemoTotal>;
};

export type MagentoApiCreditMemoItem = MagentoApiCreditMemoItemInterface & {
  __typename: "CreditMemoItem";
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars["Float"]["output"]>;
};

/** Credit memo item details. */
export type MagentoApiCreditMemoItemInterface = {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars["Float"]["output"]>;
};

/** Contains credit memo price details. */
export type MagentoApiCreditMemoTotal = {
  __typename: "CreditMemoTotal";
  /** An adjustment manually applied to the order. */
  adjustment: MagentoApiMoney;
  /** The final base grand total amount in the base currency. */
  base_grand_total: MagentoApiMoney;
  /** The applied discounts to the credit memo. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: MagentoApiMoney;
  /** Details about the shipping and handling costs for the credit memo. */
  shipping_handling?: Maybe<MagentoApiShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: MagentoApiMoney;
  /** The credit memo tax details. */
  taxes?: Maybe<Array<Maybe<MagentoApiTaxItem>>>;
  /** The shipping amount for the credit memo. */
  total_shipping: MagentoApiMoney;
  /** The amount of tax applied to the credit memo. */
  total_tax: MagentoApiMoney;
};

/** Defines a cross-selling popup offer to display for a cart. */
export type MagentoApiCrossSellPopup = {
  __typename: "CrossSellPopup";
  /** The identifier of the cross-selling rule that produced this popup. */
  id: Scalars["String"]["output"];
  /** How many times the popup may be displayed within a single session. */
  max_displays_per_session?: Maybe<Scalars["Int"]["output"]>;
  /** The products offered by the popup. At most three. */
  offer?: Maybe<Array<Maybe<MagentoApiCrossSellPopupOffer>>>;
  /** The priority of the rule. The lowest value wins when several rules match. */
  priority?: Maybe<Scalars["Int"]["output"]>;
};

/** Defines a product offered by a cross-selling popup. */
export type MagentoApiCrossSellPopupOffer = {
  __typename: "CrossSellPopupOffer";
  /** The price of the offered product. */
  price?: Maybe<MagentoApiMoney>;
  /** The SKU of the offered product. */
  sku: Scalars["String"]["output"];
};

export type MagentoApiCurrency = {
  __typename: "Currency";
  /** An array of three-letter currency codes accepted by the store, such as USD and EUR. */
  available_currency_codes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The base currency set for the store, such as USD. */
  base_currency_code?: Maybe<Scalars["String"]["output"]>;
  /** The symbol for the specified base currency, such as $. */
  base_currency_symbol?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_code?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_symbol?: Maybe<Scalars["String"]["output"]>;
  /** The currency that is displayed by default, such as USD. */
  default_display_currency_code?: Maybe<Scalars["String"]["output"]>;
  /** The currency symbol that is displayed by default, such as $. */
  default_display_currency_symbol?: Maybe<Scalars["String"]["output"]>;
  /** An array of exchange rates for currencies defined in the store. */
  exchange_rates?: Maybe<Array<Maybe<MagentoApiExchangeRate>>>;
};

/** The list of available currency codes. */
export type MagentoApiCurrencyEnum =
  | "AED"
  | "AFN"
  | "ALL"
  | "AMD"
  | "ANG"
  | "AOA"
  | "ARS"
  | "AUD"
  | "AWG"
  | "AZM"
  | "AZN"
  | "BAM"
  | "BBD"
  | "BDT"
  | "BGN"
  | "BHD"
  | "BIF"
  | "BMD"
  | "BND"
  | "BOB"
  | "BRL"
  | "BSD"
  | "BTN"
  | "BUK"
  | "BWP"
  | "BYN"
  | "BZD"
  | "CAD"
  | "CDF"
  | "CHE"
  | "CHF"
  | "CHW"
  | "CLP"
  | "CNY"
  | "COP"
  | "CRC"
  | "CUP"
  | "CVE"
  | "CZK"
  | "DJF"
  | "DKK"
  | "DOP"
  | "DZD"
  | "EEK"
  | "EGP"
  | "ERN"
  | "ETB"
  | "EUR"
  | "FJD"
  | "FKP"
  | "GBP"
  | "GEK"
  | "GEL"
  | "GHS"
  | "GIP"
  | "GMD"
  | "GNF"
  | "GQE"
  | "GTQ"
  | "GYD"
  | "HKD"
  | "HNL"
  | "HRK"
  | "HTG"
  | "HUF"
  | "IDR"
  | "ILS"
  | "INR"
  | "IQD"
  | "IRR"
  | "ISK"
  | "JMD"
  | "JOD"
  | "JPY"
  | "KES"
  | "KGS"
  | "KHR"
  | "KMF"
  | "KPW"
  | "KRW"
  | "KWD"
  | "KYD"
  | "KZT"
  | "LAK"
  | "LBP"
  | "LKR"
  | "LRD"
  | "LSL"
  | "LSM"
  | "LTL"
  | "LVL"
  | "LYD"
  | "MAD"
  | "MDL"
  | "MGA"
  | "MKD"
  | "MMK"
  | "MNT"
  | "MOP"
  | "MRO"
  | "MUR"
  | "MVR"
  | "MWK"
  | "MXN"
  | "MYR"
  | "MZN"
  | "NAD"
  | "NGN"
  | "NIC"
  | "NOK"
  | "NPR"
  | "NZD"
  | "OMR"
  | "PAB"
  | "PEN"
  | "PGK"
  | "PHP"
  | "PKR"
  | "PLN"
  | "PYG"
  | "QAR"
  | "RHD"
  | "ROL"
  | "RON"
  | "RSD"
  | "RUB"
  | "RWF"
  | "SAR"
  | "SBD"
  | "SCR"
  | "SDG"
  | "SEK"
  | "SGD"
  | "SHP"
  | "SKK"
  | "SLL"
  | "SOS"
  | "SRD"
  | "STD"
  | "SVC"
  | "SYP"
  | "SZL"
  | "THB"
  | "TJS"
  | "TMM"
  | "TND"
  | "TOP"
  | "TRL"
  | "TRY"
  | "TTD"
  | "TWD"
  | "TZS"
  | "UAH"
  | "UGX"
  | "USD"
  | "UYU"
  | "UZS"
  | "VEB"
  | "VEF"
  | "VND"
  | "VUV"
  | "WST"
  | "XCD"
  | "XOF"
  | "XPF"
  | "YER"
  | "YTL"
  | "ZAR"
  | "ZMK"
  | "ZWD";

/** Defines an array of custom attributes. */
export type MagentoApiCustomAttributeMetadata = {
  __typename: "CustomAttributeMetadata";
  /** An array of attributes. */
  items?: Maybe<Array<Maybe<MagentoApiAttribute>>>;
};

/** An interface containing fields that define the EAV attribute. */
export type MagentoApiCustomAttributeMetadataInterface = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars["ID"]["output"];
  /** Default attribute value. */
  default_value?: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type: MagentoApiAttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<MagentoApiAttributeFrontendInputEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars["Boolean"]["output"];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** Attribute options. */
  options: Array<Maybe<MagentoApiCustomAttributeOptionInterface>>;
};

export type MagentoApiCustomAttributeOptionInterface = {
  /** Is the option value default. */
  is_default: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute option. */
  label: Scalars["String"]["output"];
  /** The attribute option value. */
  value: Scalars["String"]["output"];
};

/** Customer defines the customer name and address and other details */
export type MagentoApiCustomer = {
  __typename: "Customer";
  /** An array containing the customer's shipping and billing addresses. */
  addresses?: Maybe<Array<Maybe<MagentoApiCustomerAddress>>>;
  /** An array containing the customer's shipping and billing addresses. */
  addressesV2?: Maybe<MagentoApiCustomerAddresses>;
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance: Scalars["Boolean"]["output"];
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<MagentoApiCompareList>;
  /** The customer's confirmation status. */
  confirmation_status: MagentoApiConfirmationStatusEnum;
  /** Timestamp indicating when the account was created. */
  created_at?: Maybe<Scalars["String"]["output"]>;
  /** Customer's custom attributes. */
  custom_attributes?: Maybe<Array<Maybe<MagentoApiAttributeValueInterface>>>;
  /** The customer's date of birth. */
  date_of_birth?: Maybe<Scalars["String"]["output"]>;
  /** The ID assigned to the billing address. */
  default_billing?: Maybe<Scalars["String"]["output"]>;
  /** The ID assigned to the shipping address. */
  default_shipping?: Maybe<Scalars["String"]["output"]>;
  /**
   * The customer's date of birth.
   * @deprecated Use `date_of_birth` instead.
   */
  dob?: Maybe<Scalars["String"]["output"]>;
  /** The customer's email address. Required. */
  email?: Maybe<Scalars["String"]["output"]>;
  /** The customer's first name. */
  firstname?: Maybe<Scalars["String"]["output"]>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: Maybe<Scalars["Int"]["output"]>;
  /** Details about all of the customer's gift registries. */
  gift_registries?: Maybe<Array<Maybe<MagentoApiGiftRegistry>>>;
  /** Details about a specific gift registry. */
  gift_registry?: Maybe<MagentoApiGiftRegistry>;
  /** @deprecated Customer group should not be exposed in the storefront scenarios. */
  group_id?: Maybe<Scalars["Int"]["output"]>;
  /**
   * The ID assigned to the customer.
   * @deprecated `id` is not needed as part of `Customer`, because on the server side, it can be identified based on the customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: Maybe<Scalars["Boolean"]["output"]>;
  /** The customer's family name. */
  lastname?: Maybe<Scalars["String"]["output"]>;
  /** The customer's middle name. */
  middlename?: Maybe<Scalars["String"]["output"]>;
  orders?: Maybe<MagentoApiCustomerOrders>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars["String"]["output"]>;
  /** Details about the specified return request from the unique ID for a `Return` object. */
  return?: Maybe<MagentoApiReturn>;
  /** Information about the customer's return requests. */
  returns?: Maybe<MagentoApiReturns>;
  /** Contains the customer's product reviews. */
  reviews: MagentoApiProductReviews;
  /** Customer reward points details. */
  reward_points?: Maybe<MagentoApiRewardPoints>;
  /** Store credit information applied for the logged in customer. */
  store_credit?: Maybe<MagentoApiCustomerStoreCredit>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars["String"]["output"]>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  taxvat?: Maybe<Scalars["String"]["output"]>;
  /** Unique user id. */
  uuid?: Maybe<Scalars["String"]["output"]>;
  /**
   * Return a customer's wish lists.
   * @deprecated Use `Customer.wishlists` or `Customer.wishlist_v2` instead.
   */
  wishlist: MagentoApiWishlist;
  /** Retrieve the wish list identified by the unique ID for a `Wishlist` object. */
  wishlist_v2?: Maybe<MagentoApiWishlist>;
  /** An array of wishlists. In Magento Open Source, customers are limited to one wish list. The number of wish lists is configurable for Adobe Commerce. */
  wishlists: Array<Maybe<MagentoApiWishlist>>;
};

/** Customer defines the customer name and address and other details */
export type MagentoApiCustomerAddressesV2Args = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Customer defines the customer name and address and other details */
export type MagentoApiCustomerCustom_AttributesArgs = {
  attributeCodes?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Customer defines the customer name and address and other details */
export type MagentoApiCustomerGift_RegistryArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
};

/** Customer defines the customer name and address and other details */
export type MagentoApiCustomerOrdersArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  filter?: InputMaybe<MagentoApiCustomerOrdersFilterInput>;
  order_type?: InputMaybe<MagentoApiOrderTypeEnum>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  scope?: InputMaybe<MagentoApiScopeTypeEnum>;
  sort?: InputMaybe<MagentoApiCustomerOrderSortInput>;
};

/** Customer defines the customer name and address and other details */
export type MagentoApiCustomerReturnArgs = {
  uid: Scalars["ID"]["input"];
};

/** Customer defines the customer name and address and other details */
export type MagentoApiCustomerReturnsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Customer defines the customer name and address and other details */
export type MagentoApiCustomerReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Customer defines the customer name and address and other details */
export type MagentoApiCustomerWishlist_V2Args = {
  id: Scalars["ID"]["input"];
};

/** Customer defines the customer name and address and other details */
export type MagentoApiCustomerWishlistsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Contains detailed information about a customer's billing or shipping address. */
export type MagentoApiCustomerAddress = {
  __typename: "CustomerAddress";
  /** The customer's city or town. */
  city?: Maybe<Scalars["String"]["output"]>;
  /** The customer's company. */
  company?: Maybe<Scalars["String"]["output"]>;
  /** The customer's country. */
  country_code?: Maybe<MagentoApiCountryCodeEnum>;
  /**
   * The customer's country.
   * @deprecated Use `country_code` instead.
   */
  country_id?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use custom_attributesV2 instead. */
  custom_attributes?: Maybe<Array<Maybe<MagentoApiCustomerAddressAttribute>>>;
  /** Custom attributes assigned to the customer address. */
  custom_attributesV2: Array<Maybe<MagentoApiAttributeValueInterface>>;
  /**
   * The customer ID
   * @deprecated `customer_id` is not needed as part of `CustomerAddress`. The `id` is a unique identifier for the addresses.
   */
  customer_id?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the address is the customer's default billing address. */
  default_billing?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the address is the customer's default shipping address. */
  default_shipping?: Maybe<Scalars["Boolean"]["output"]>;
  /** Contains any extension attributes for the address. */
  extension_attributes?: Maybe<Array<Maybe<MagentoApiCustomerAddressAttribute>>>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars["String"]["output"]>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname?: Maybe<Scalars["String"]["output"]>;
  /** The ID of a `CustomerAddress` object. */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** The family name of the person associated with the shipping/billing address. */
  lastname?: Maybe<Scalars["String"]["output"]>;
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars["String"]["output"]>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars["String"]["output"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars["String"]["output"]>;
  /** An object containing the region name, region code, and region ID. */
  region?: Maybe<MagentoApiCustomerAddressRegion>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars["Int"]["output"]>;
  /** An array of strings that define the street number and name. */
  street?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars["String"]["output"]>;
  /** The customer's telephone number. */
  telephone?: Maybe<Scalars["String"]["output"]>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars["String"]["output"]>;
};

/** Contains detailed information about a customer's billing or shipping address. */
export type MagentoApiCustomerAddressCustom_AttributesV2Args = {
  attributeCodes?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Specifies the attribute code and value of a customer address attribute. */
export type MagentoApiCustomerAddressAttribute = {
  __typename: "CustomerAddressAttribute";
  /** The name assigned to the customer address attribute. */
  attribute_code?: Maybe<Scalars["String"]["output"]>;
  /** The value assigned to the customer address attribute. */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Specifies the attribute code and value of a customer attribute. */
export type MagentoApiCustomerAddressAttributeInput = {
  /** The name assigned to the attribute. */
  attribute_code: Scalars["String"]["input"];
  /** The value assigned to the attribute. */
  value: Scalars["String"]["input"];
};

/** Contains details about a billing or shipping address. */
export type MagentoApiCustomerAddressInput = {
  /** The customer's city or town. */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's company. */
  company?: InputMaybe<Scalars["String"]["input"]>;
  /** The two-letter code representing the customer's country. */
  country_code?: InputMaybe<MagentoApiCountryCodeEnum>;
  country_id?: InputMaybe<MagentoApiCountryCodeEnum>;
  custom_attributes?: InputMaybe<Array<InputMaybe<MagentoApiCustomerAddressAttributeInput>>>;
  /** Custom attributes assigned to the customer address. */
  custom_attributesV2?: InputMaybe<Array<InputMaybe<MagentoApiAttributeValueInput>>>;
  /** Indicates whether the address is the default billing address. */
  default_billing?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Indicates whether the address is the default shipping address. */
  default_shipping?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's fax number. */
  fax?: InputMaybe<Scalars["String"]["input"]>;
  /** The first name of the person associated with the billing/shipping address. */
  firstname?: InputMaybe<Scalars["String"]["input"]>;
  /** The family name of the person associated with the billing/shipping address. */
  lastname?: InputMaybe<Scalars["String"]["input"]>;
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's ZIP or postal code. */
  postcode?: InputMaybe<Scalars["String"]["input"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  /** An object containing the region name, region code, and region ID. */
  region?: InputMaybe<MagentoApiCustomerAddressRegionInput>;
  /** An array of strings that define the street number and name. */
  street?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's telephone number. */
  telephone?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's Tax/VAT number (for corporate customers). */
  vat_id?: InputMaybe<Scalars["String"]["input"]>;
};

/** Defines the customer's state or province. */
export type MagentoApiCustomerAddressRegion = {
  __typename: "CustomerAddressRegion";
  /** The state or province name. */
  region?: Maybe<Scalars["String"]["output"]>;
  /** The address region code. */
  region_code?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars["Int"]["output"]>;
};

/** Defines the customer's state or province. */
export type MagentoApiCustomerAddressRegionInput = {
  /** The state or province name. */
  region?: InputMaybe<Scalars["String"]["input"]>;
  /** The address region code. */
  region_code?: InputMaybe<Scalars["String"]["input"]>;
  /** The unique ID for a pre-defined region. */
  region_id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MagentoApiCustomerAddresses = {
  __typename: "CustomerAddresses";
  /** An array containing the customer's shipping and billing addresses. */
  items?: Maybe<Array<Maybe<MagentoApiCustomerAddress>>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<MagentoApiSearchResultPageInfo>;
  /** The total count of customer addresses. */
  total_count?: Maybe<Scalars["Int"]["output"]>;
};

/** Customer attribute metadata. */
export type MagentoApiCustomerAttributeMetadata = MagentoApiCustomAttributeMetadataInterface & {
  __typename: "CustomerAttributeMetadata";
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars["ID"]["output"];
  /** Default attribute value. */
  default_value?: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type: MagentoApiAttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<MagentoApiAttributeFrontendInputEnum>;
  /** The template used for the input of the attribute (e.g., 'date'). */
  input_filter?: Maybe<MagentoApiInputFilterEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars["Boolean"]["output"];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The number of lines of the attribute value. */
  multiline_count?: Maybe<Scalars["Int"]["output"]>;
  /** Attribute options. */
  options: Array<Maybe<MagentoApiCustomAttributeOptionInterface>>;
  /** The position of the attribute in the form. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The validation rules of the attribute value. */
  validate_rules?: Maybe<Array<Maybe<MagentoApiValidationRule>>>;
};

/** An input object for creating a customer. */
export type MagentoApiCustomerCreateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's custom attributes. */
  custom_attributes?: InputMaybe<Array<InputMaybe<MagentoApiAttributeValueInput>>>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars["String"]["input"]>;
  dob?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's email address. */
  email: Scalars["String"]["input"];
  /** The customer's first name. */
  firstname: Scalars["String"]["input"];
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars["Int"]["input"]>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's family name. */
  lastname: Scalars["String"]["input"];
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's password. */
  password?: InputMaybe<Scalars["String"]["input"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains details about a single downloadable product. */
export type MagentoApiCustomerDownloadableProduct = {
  __typename: "CustomerDownloadableProduct";
  /** The date and time the purchase was made. */
  date?: Maybe<Scalars["String"]["output"]>;
  /** The fully qualified URL to the download file. */
  download_url?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID assigned to the item. */
  order_increment_id?: Maybe<Scalars["String"]["output"]>;
  /** The remaining number of times the customer can download the product. */
  remaining_downloads?: Maybe<Scalars["String"]["output"]>;
  /** Indicates when the product becomes available for download. Options are `Pending` and `Invoiced`. */
  status?: Maybe<Scalars["String"]["output"]>;
};

/** Contains a list of downloadable products. */
export type MagentoApiCustomerDownloadableProducts = {
  __typename: "CustomerDownloadableProducts";
  /** An array of purchased downloadable items. */
  items?: Maybe<Array<Maybe<MagentoApiCustomerDownloadableProduct>>>;
};

/** An input object that assigns or updates customer attributes. */
export type MagentoApiCustomerInput = {
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars["String"]["input"]>;
  dob?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's email address. Required when creating a customer. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars["Int"]["input"]>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's password. */
  password?: InputMaybe<Scalars["String"]["input"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains details about each of the customer's orders. */
export type MagentoApiCustomerOrder = {
  __typename: "CustomerOrder";
  /** A list of additional attributes for the order. */
  additional_attributes: Array<Maybe<MagentoApiOrderAttributeOutput>>;
  /** Coupons applied to the order. */
  applied_coupons: Array<Maybe<MagentoApiAppliedCoupon>>;
  /** An array of gift cards applied to the order. */
  applied_gift_cards?: Maybe<Array<Maybe<MagentoApiApplyGiftCardToOrder>>>;
  /** List of available order actions. */
  available_actions: Array<Maybe<MagentoApiOrderActionType>>;
  /** The billing address for the order. */
  billing_address?: Maybe<MagentoApiOrderAddress>;
  /** The shipping carrier for the order delivery. */
  carrier?: Maybe<Scalars["String"]["output"]>;
  /** Comments about the order. */
  comments?: Maybe<Array<Maybe<MagentoApiSalesCommentItem>>>;
  /** @deprecated Use the `order_date` field instead. */
  created_at?: Maybe<Scalars["String"]["output"]>;
  /** A list of credit memos. */
  credit_memos?: Maybe<Array<Maybe<MagentoApiCreditMemo>>>;
  /** Returns customer information from order. */
  customer_info: MagentoApiOrderCustomerInfo;
  /** Order customer email. */
  email?: Maybe<Scalars["String"]["output"]>;
  /** The entered gift message for the order */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** Indicates whether the customer requested a gift receipt for the order. */
  gift_receipt_included: Scalars["Boolean"]["output"];
  /** The selected gift wrapping for the order. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** @deprecated Use the `totals.grand_total` field instead. */
  grand_total?: Maybe<Scalars["Float"]["output"]>;
  /** Whether the order already has a withdrawal ID. */
  has_withdrawal: Scalars["Boolean"]["output"];
  /** The unique ID for a `CustomerOrder` object. */
  id: Scalars["ID"]["output"];
  /** @deprecated Use the `id` field instead. */
  increment_id?: Maybe<Scalars["String"]["output"]>;
  /** A list of invoices for the order. */
  invoices: Array<Maybe<MagentoApiInvoice>>;
  /** `TRUE` if the order is virtual */
  is_virtual: Scalars["Boolean"]["output"];
  /** An array containing the items purchased in this order. */
  items?: Maybe<Array<Maybe<MagentoApiOrderItemInterface>>>;
  /** A list of order items eligible to be in a return request. */
  items_eligible_for_return?: Maybe<Array<Maybe<MagentoApiOrderItemInterface>>>;
  loyalty_info?: Maybe<MagentoApiAppliedCampaign>;
  /** The order number. */
  number: Scalars["String"]["output"];
  /** The date the order was placed. */
  order_date: Scalars["String"]["output"];
  /** @deprecated Use the `number` field instead. */
  order_number: Scalars["String"]["output"];
  /** The order origin. */
  order_origin: Scalars["Int"]["output"];
  /** The order origin Label. */
  order_origin_label: Scalars["String"]["output"];
  /** The date the order status was last updated. */
  order_status_change_date: Scalars["String"]["output"];
  /** Provides the JTI Order Type for a given order */
  order_type?: Maybe<MagentoApiOrderTypeEnum>;
  /** Payment details for the order. */
  payment_methods?: Maybe<Array<Maybe<MagentoApiOrderPaymentMethod>>>;
  /** Indicates whether the customer requested a printed card for the order. */
  printed_card_included: Scalars["Boolean"]["output"];
  reasons?: Maybe<Array<Maybe<MagentoApiOrderStatusReason>>>;
  /** Return requests associated with this order. */
  returns?: Maybe<MagentoApiReturns>;
  /** A list of shipments for the order. */
  shipments?: Maybe<Array<Maybe<MagentoApiOrderShipment>>>;
  /** The shipping address for the order. */
  shipping_address?: Maybe<MagentoApiOrderAddress>;
  /** The delivery method for the order. */
  shipping_method?: Maybe<Scalars["String"]["output"]>;
  shipping_method_code?: Maybe<Scalars["String"]["output"]>;
  /** The current status of the order. */
  status: Scalars["String"]["output"];
  status_reason?: Maybe<MagentoApiStatusReason>;
  /** The store_code of the store. */
  store_code?: Maybe<Scalars["String"]["output"]>;
  /** The token that can be used to retrieve the order using order query. */
  token: Scalars["String"]["output"];
  /** Details about the calculated totals for this order. */
  total?: Maybe<MagentoApiOrderTotal>;
  total_after_trial?: Maybe<MagentoApiTrialTotals>;
  total_including_trial?: Maybe<MagentoApiTrialTotals>;
  /** The website_code of the website. */
  website_code?: Maybe<Scalars["String"]["output"]>;
  /** The withdrawal ID saved on the order, if any. */
  withdrawal_id?: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about each of the customer's orders. */
export type MagentoApiCustomerOrderReturnsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** CustomerOrderSortInput specifies the field to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type MagentoApiCustomerOrderSortInput = {
  /** This enumeration indicates whether to return results in ascending or descending order */
  sort_direction: MagentoApiSortEnum;
  /** Specifies the field to use for sorting */
  sort_field: MagentoApiCustomerOrderSortableField;
};

/** Specifies the field to use for sorting */
export type MagentoApiCustomerOrderSortableField =
  /** Sorts customer orders by created_at field */
  | "CREATED_AT"
  /** Sorts customer orders by number */
  | "NUMBER";

/** The collection of orders that match the conditions defined in the filter. */
export type MagentoApiCustomerOrders = {
  __typename: "CustomerOrders";
  /** Date of the first order placed in the store */
  date_of_first_order?: Maybe<Scalars["String"]["output"]>;
  /** An array of customer orders. */
  items: Array<Maybe<MagentoApiCustomerOrder>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<MagentoApiSearchResultPageInfo>;
  /** The total count of customer orders. */
  total_count?: Maybe<Scalars["Int"]["output"]>;
};

/** Identifies the filter to use for filtering orders. */
export type MagentoApiCustomerOrdersFilterInput = {
  /** Filters by order base grand total value. */
  grand_total?: InputMaybe<MagentoApiFilterRangeTypeInput>;
  /** Filters by order number. */
  number?: InputMaybe<MagentoApiFilterStringTypeInput>;
  /** Filters by order created_at time. */
  order_date?: InputMaybe<MagentoApiFilterRangeTypeInput>;
  /** Filters by order status. */
  status?: InputMaybe<MagentoApiFilterStringTypeInput>;
};

/** Contains details about a newly-created or updated customer. */
export type MagentoApiCustomerOutput = {
  __typename: "CustomerOutput";
  /** Customer details after creating or updating a customer. */
  customer: MagentoApiCustomer;
};

/** Contains payment tokens stored in the customer's vault. */
export type MagentoApiCustomerPaymentTokens = {
  __typename: "CustomerPaymentTokens";
  /** An array of payment tokens. */
  items: Array<Maybe<MagentoApiPaymentToken>>;
};

/** Contains store credit information with balance and history. */
export type MagentoApiCustomerStoreCredit = {
  __typename: "CustomerStoreCredit";
  /** Contains the customer's store credit balance history. If the history or store credit feature is disabled, then a null value will be returned. */
  balance_history?: Maybe<MagentoApiCustomerStoreCreditHistory>;
  /** The current balance of store credit. */
  current_balance?: Maybe<MagentoApiMoney>;
  /** Indicates whether store credits are enabled. If the feature is disabled, then the balance will not be returned. */
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Contains store credit information with balance and history. */
export type MagentoApiCustomerStoreCreditBalance_HistoryArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Lists changes to the amount of store credit available to the customer. */
export type MagentoApiCustomerStoreCreditHistory = {
  __typename: "CustomerStoreCreditHistory";
  /** An array containing information about changes to the store credit available to the customer. */
  items?: Maybe<Array<Maybe<MagentoApiCustomerStoreCreditHistoryItem>>>;
  /** Metadata for pagination rendering. */
  page_info?: Maybe<MagentoApiSearchResultPageInfo>;
  /** The number of items returned. */
  total_count?: Maybe<Scalars["Int"]["output"]>;
};

/** Contains store credit history information. */
export type MagentoApiCustomerStoreCreditHistoryItem = {
  __typename: "CustomerStoreCreditHistoryItem";
  /** The action that was made on the store credit. */
  action?: Maybe<Scalars["String"]["output"]>;
  /** The store credit available to the customer as a result of this action.  */
  actual_balance?: Maybe<MagentoApiMoney>;
  /** The amount added to or subtracted from the store credit as a result of this action. */
  balance_change?: Maybe<MagentoApiMoney>;
  /** The date and time when the store credit change was made. */
  date_time_changed?: Maybe<Scalars["String"]["output"]>;
};

/** Contains a customer authorization token. */
export type MagentoApiCustomerToken = {
  __typename: "CustomerToken";
  /** The customer authorization token. */
  token?: Maybe<Scalars["String"]["output"]>;
};

/** An input object for updating a customer. */
export type MagentoApiCustomerUpdateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's custom attributes. */
  custom_attributes?: InputMaybe<Array<InputMaybe<MagentoApiAttributeValueInput>>>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars["String"]["input"]>;
  dob?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars["Int"]["input"]>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars["String"]["input"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains information about a text area that is defined as part of a customizable option. */
export type MagentoApiCustomizableAreaOption = MagentoApiCustomizableOptionInterface & {
  __typename: "CustomizableAreaOption";
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars["Int"]["output"]>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An object that defines a text area. */
  value?: Maybe<MagentoApiCustomizableAreaValue>;
};

/** Defines the price and sku of a product whose page contains a customized text area. */
export type MagentoApiCustomizableAreaValue = {
  __typename: "CustomizableAreaValue";
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<MagentoApiPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableAreaValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a set of checkbox values that are defined as part of a customizable option. */
export type MagentoApiCustomizableCheckboxOption = MagentoApiCustomizableOptionInterface & {
  __typename: "CustomizableCheckboxOption";
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An array that defines a set of checkbox values. */
  value?: Maybe<Array<Maybe<MagentoApiCustomizableCheckboxValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of checkbox values. */
export type MagentoApiCustomizableCheckboxValue = {
  __typename: "CustomizableCheckboxValue";
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<MagentoApiPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars["String"]["output"]>;
  /** The order in which the checkbox value is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableCheckboxValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a date picker that is defined as part of a customizable option. */
export type MagentoApiCustomizableDateOption = MagentoApiCustomizableOptionInterface & {
  __typename: "CustomizableDateOption";
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars["Int"]["output"]>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An object that defines a date field in a customizable option. */
  value?: Maybe<MagentoApiCustomizableDateValue>;
};

/** Defines the customizable date type. */
export type MagentoApiCustomizableDateTypeEnum = "DATE" | "DATE_TIME" | "TIME";

/** Defines the price and sku of a product whose page contains a customized date picker. */
export type MagentoApiCustomizableDateValue = {
  __typename: "CustomizableDateValue";
  /** The price assigned to this option. */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<MagentoApiPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars["String"]["output"]>;
  /** DATE, DATE_TIME or TIME */
  type?: Maybe<MagentoApiCustomizableDateTypeEnum>;
  /** The unique ID for a `CustomizableDateValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a drop down menu that is defined as part of a customizable option. */
export type MagentoApiCustomizableDropDownOption = MagentoApiCustomizableOptionInterface & {
  __typename: "CustomizableDropDownOption";
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An array that defines the set of options for a drop down menu. */
  value?: Maybe<Array<Maybe<MagentoApiCustomizableDropDownValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized drop down menu. */
export type MagentoApiCustomizableDropDownValue = {
  __typename: "CustomizableDropDownValue";
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<MagentoApiPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars["String"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableDropDownValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a text field that is defined as part of a customizable option. */
export type MagentoApiCustomizableFieldOption = MagentoApiCustomizableOptionInterface & {
  __typename: "CustomizableFieldOption";
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars["Int"]["output"]>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An object that defines a text field. */
  value?: Maybe<MagentoApiCustomizableFieldValue>;
};

/** Defines the price and sku of a product whose page contains a customized text field. */
export type MagentoApiCustomizableFieldValue = {
  __typename: "CustomizableFieldValue";
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars["Int"]["output"]>;
  /** The price of the custom value. */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<MagentoApiPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableFieldValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a file picker that is defined as part of a customizable option. */
export type MagentoApiCustomizableFileOption = MagentoApiCustomizableOptionInterface & {
  __typename: "CustomizableFileOption";
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars["Int"]["output"]>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An object that defines a file value. */
  value?: Maybe<MagentoApiCustomizableFileValue>;
};

/** Defines the price and sku of a product whose page contains a customized file picker. */
export type MagentoApiCustomizableFileValue = {
  __typename: "CustomizableFileValue";
  /** The file extension to accept. */
  file_extension?: Maybe<Scalars["String"]["output"]>;
  /** The maximum width of an image. */
  image_size_x?: Maybe<Scalars["Int"]["output"]>;
  /** The maximum height of an image. */
  image_size_y?: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<MagentoApiPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableFileValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a multiselect that is defined as part of a customizable option. */
export type MagentoApiCustomizableMultipleOption = MagentoApiCustomizableOptionInterface & {
  __typename: "CustomizableMultipleOption";
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An array that defines the set of options for a multiselect. */
  value?: Maybe<Array<Maybe<MagentoApiCustomizableMultipleValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized multiselect. */
export type MagentoApiCustomizableMultipleValue = {
  __typename: "CustomizableMultipleValue";
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<MagentoApiPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars["String"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableMultipleValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines a customizable option. */
export type MagentoApiCustomizableOptionInput = {
  /** The customizable option ID of the product. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** The unique ID for a `CartItemInterface` object. */
  uid?: InputMaybe<Scalars["ID"]["input"]>;
  /** The string value of the option. */
  value_string: Scalars["String"]["input"];
};

/** Contains basic information about a customizable option. It can be implemented by several types of configurable options. */
export type MagentoApiCustomizableOptionInterface = {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about customizable product options. */
export type MagentoApiCustomizableProductInterface = {
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<MagentoApiCustomizableOptionInterface>>>;
};

/** Contains information about a set of radio buttons that are defined as part of a customizable option. */
export type MagentoApiCustomizableRadioOption = MagentoApiCustomizableOptionInterface & {
  __typename: "CustomizableRadioOption";
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An array that defines a set of radio buttons. */
  value?: Maybe<Array<Maybe<MagentoApiCustomizableRadioValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of radio buttons. */
export type MagentoApiCustomizableRadioValue = {
  __typename: "CustomizableRadioValue";
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<MagentoApiPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars["String"]["output"]>;
  /** The order in which the radio button is displayed. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableRadioValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains the results of the request to delete a compare list. */
export type MagentoApiDeleteCompareListOutput = {
  __typename: "DeleteCompareListOutput";
  /** Indicates whether the compare list was successfully deleted. */
  result: Scalars["Boolean"]["output"];
};

/** Indicates whether the request succeeded and returns the remaining customer payment tokens. */
export type MagentoApiDeletePaymentTokenOutput = {
  __typename: "DeletePaymentTokenOutput";
  /** A container for the customer's remaining payment tokens. */
  customerPaymentTokens?: Maybe<MagentoApiCustomerPaymentTokens>;
  /** Indicates whether the request succeeded. */
  result: Scalars["Boolean"]["output"];
};

/** Contains the status of the request to delete a wish list and an array of the customer's remaining wish lists. */
export type MagentoApiDeleteWishlistOutput = {
  __typename: "DeleteWishlistOutput";
  /** Indicates whether the wish list was deleted. */
  status: Scalars["Boolean"]["output"];
  /** A list of undeleted wish lists. */
  wishlists: Array<Maybe<MagentoApiWishlist>>;
};

export type MagentoApiDeliveryLimits = {
  __typename: "DeliveryLimits";
  /** country id */
  country_id?: Maybe<Scalars["String"]["output"]>;
  /** id */
  id?: Maybe<Scalars["String"]["output"]>;
  /** city/province name */
  name?: Maybe<Scalars["String"]["output"]>;
};

/** A province, matching an entry of the native available_regions query. */
export type MagentoApiDeliveryProvince = {
  __typename: "DeliveryProvince";
  /** Directory region code — this is what the address payload expects in region_code. */
  code?: Maybe<Scalars["String"]["output"]>;
  /** Directory region name. */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Directory region ID, the same value as Region.id. */
  region_id: Scalars["Int"]["output"];
};

/** A delivery region and the provinces it covers. */
export type MagentoApiDeliveryRegion = {
  __typename: "DeliveryRegion";
  /** Region code, matching the product `region` attribute. Send this value in the region header. */
  code: Scalars["String"]["output"];
  /** True for the region covering every province not explicitly assigned elsewhere. */
  is_default?: Maybe<Scalars["Boolean"]["output"]>;
  /** Translated region name for display. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** Value of the product `region` attribute mapped to this region. Option IDs are assigned per environment, so never hard-code one. Prefer `ProductInterface.region_code`, which resolves this server-side. Null when the admin has not mapped the region yet; if more than one option were ever mapped to it, the lowest is returned. */
  product_attribute_option_id?: Maybe<Scalars["Int"]["output"]>;
  /** Every province in this region, fully expanded, so the address form can offer only the provinces valid for the selected region. */
  provinces?: Maybe<Array<Maybe<MagentoApiDeliveryProvince>>>;
};

/** Defines an individual discount. A discount can be applied to the cart as a whole or to an item, shipping. */
export type MagentoApiDiscount = {
  __typename: "Discount";
  /** The amount of the discount. */
  amount: MagentoApiMoney;
  /** The type of the entity the discount is applied to. */
  applied_to: MagentoApiCartDiscountType;
  /** The coupon related to the discount. */
  coupon?: Maybe<MagentoApiAppliedCoupon>;
  /** A valid single coupon code. */
  coupon_code?: Maybe<Scalars["String"]["output"]>;
  /** A description of the discount. */
  label: Scalars["String"]["output"];
};

/** An implementation for downloadable product cart items. */
export type MagentoApiDownloadableCartItem = MagentoApiCartItemInterface & {
  __typename: "DownloadableCartItem";
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<MagentoApiCartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** An array containing information about the links for the downloadable product added to the cart. */
  links?: Maybe<Array<Maybe<MagentoApiDownloadableProductLinks>>>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiCartItemPrices>;
  /** Details about an item in the cart. */
  product: MagentoApiProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** An array containing information about samples of the selected downloadable product. */
  samples?: Maybe<Array<Maybe<MagentoApiDownloadableProductSamples>>>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines downloadable product options for `CreditMemoItemInterface`. */
export type MagentoApiDownloadableCreditMemoItem = MagentoApiCreditMemoItemInterface & {
  __typename: "DownloadableCreditMemoItem";
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** A list of downloadable links that are refunded from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<MagentoApiDownloadableItemsLinks>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars["Float"]["output"]>;
};

export type MagentoApiDownloadableFileTypeEnum = "FILE" | "URL";

/** Defines downloadable product options for `InvoiceItemInterface`. */
export type MagentoApiDownloadableInvoiceItem = MagentoApiInvoiceItemInterface & {
  __typename: "DownloadableInvoiceItem";
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** A list of downloadable links that are invoiced from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<MagentoApiDownloadableItemsLinks>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Details about an individual order item. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars["Float"]["output"]>;
};

/** Defines characteristics of the links for downloadable product. */
export type MagentoApiDownloadableItemsLinks = {
  __typename: "DownloadableItemsLinks";
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name of the link. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `DownloadableItemsLinks` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines downloadable product options for `OrderItemInterface`. */
export type MagentoApiDownloadableOrderItem = MagentoApiOrderItemInterface & {
  __typename: "DownloadableOrderItem";
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** A list of downloadable links that are ordered from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<MagentoApiDownloadableItemsLinks>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return?: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: MagentoApiMoney;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<MagentoApiProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription?: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested?: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: MagentoApiMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: MagentoApiMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Defines a product that the shopper downloads. */
export type MagentoApiDownloadableProduct = MagentoApiCustomizableProductInterface &
  MagentoApiProductInterface &
  MagentoApiRoutableInterface & {
    __typename: "DownloadableProduct";
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer?: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<MagentoApiCategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1?: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2?: Maybe<MagentoApiProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code?: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions?: Maybe<Scalars["String"]["output"]>;
    /** An array containing information about the links for this downloadable product. */
    downloadable_product_links?: Maybe<Array<Maybe<MagentoApiDownloadableProductLinks>>>;
    /** An array containing information about samples of this downloadable product. */
    downloadable_product_samples?: Maybe<Array<Maybe<MagentoApiDownloadableProductSamples>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family?: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<MagentoApiFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula?: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts?: Maybe<MagentoApiFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes?: Maybe<Array<Maybe<MagentoApiFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price?: Maybe<MagentoApiMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device?: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image?: Maybe<MagentoApiProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal?: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** A value of 1 indicates that each link in the array must be purchased separately. */
    links_purchased_separately?: Maybe<Scalars["Int"]["output"]>;
    /** The heading above the list of downloadable products. */
    links_title?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent?: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MagentoApiMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MagentoApiMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type?: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description?: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label?: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price?: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled?: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model?: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks?: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand?: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<MagentoApiCustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<MagentoApiProductPrices>;
    /** The range of prices for the product */
    price_range: MagentoApiPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<MagentoApiTierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand?: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation?: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<MagentoApiProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province?: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label?: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity?: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category?: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region?: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label?: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible?: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: MagentoApiProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<MagentoApiProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility?: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status?: Maybe<MagentoApiProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details?: Maybe<MagentoApiStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<MagentoApiProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<MagentoApiProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka?: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku?: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label?: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<MagentoApiUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage?: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<MagentoApiWebsite>>>;
  };

/** Defines a product that the shopper downloads. */
export type MagentoApiDownloadableProductCustom_AttributesV2Args = {
  filters?: InputMaybe<MagentoApiAttributeFilterInput>;
};

/** Defines a product that the shopper downloads. */
export type MagentoApiDownloadableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Defines a single downloadable product. */
export type MagentoApiDownloadableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<MagentoApiCustomizableOptionInput>>>;
  /** The quantity and SKU of the downloadable product. */
  data: MagentoApiCartItemInput;
  /** An array of objects containing the link_id of the downloadable product link. */
  downloadable_product_links?: InputMaybe<Array<InputMaybe<MagentoApiDownloadableProductLinksInput>>>;
};

/** Defines characteristics of a downloadable product. */
export type MagentoApiDownloadableProductLinks = {
  __typename: "DownloadableProductLinks";
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated This information should not be exposed on frontend. */
  is_shareable?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  link_type?: Maybe<MagentoApiDownloadableFileTypeEnum>;
  /** @deprecated This information should not be exposed on frontend. */
  number_of_downloads?: Maybe<Scalars["Int"]["output"]>;
  /** The price of the downloadable product. */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<MagentoApiDownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars["String"]["output"]>;
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name of the link. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `DownloadableProductLinks` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains the link ID for the downloadable product. */
export type MagentoApiDownloadableProductLinksInput = {
  /** The unique ID of the downloadable product link. */
  link_id: Scalars["Int"]["input"];
};

/** Defines characteristics of a downloadable product. */
export type MagentoApiDownloadableProductSamples = {
  __typename: "DownloadableProductSamples";
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<MagentoApiDownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars["String"]["output"]>;
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The display name of the sample. */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** A downloadable product wish list item. */
export type MagentoApiDownloadableWishlistItem = MagentoApiWishlistItemInterface & {
  __typename: "DownloadableWishlistItem";
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** An array containing information about the selected links. */
  links_v2?: Maybe<Array<Maybe<MagentoApiDownloadableProductLinks>>>;
  /** Product details of the wish list item. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
  /** An array containing information about the selected samples. */
  samples?: Maybe<Array<Maybe<MagentoApiDownloadableProductSamples>>>;
};

/** Contains a single dynamic block. */
export type MagentoApiDynamicBlock = {
  __typename: "DynamicBlock";
  /** The renderable HTML code of the dynamic block. */
  content: MagentoApiComplexTextValue;
  /** The unique ID of a `DynamicBlock` object. */
  uid: Scalars["ID"]["output"];
};

/** Indicates the locations the dynamic block can be placed. If this field is not specified, the query returns all locations. */
export type MagentoApiDynamicBlockLocationEnum = "CONTENT" | "FOOTER" | "HEADER" | "LEFT" | "RIGHT";

/** Indicates the selected Dynamic Blocks Rotator inline widget. */
export type MagentoApiDynamicBlockTypeEnum = "CART_PRICE_RULE_RELATED" | "CATALOG_PRICE_RULE_RELATED" | "SPECIFIED";

/** Contains an array of dynamic blocks. */
export type MagentoApiDynamicBlocks = {
  __typename: "DynamicBlocks";
  /** An array containing individual dynamic blocks. */
  items: Array<Maybe<MagentoApiDynamicBlock>>;
  /** Metadata for pagination rendering. */
  page_info?: Maybe<MagentoApiSearchResultPageInfo>;
  /** The number of returned dynamic blocks. */
  total_count: Scalars["Int"]["output"];
};

/** Defines the dynamic block filter. The filter can identify the block type, location and IDs to return. */
export type MagentoApiDynamicBlocksFilterInput = {
  /** An array of dynamic block UIDs to filter on. */
  dynamic_block_uids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /** An array indicating the locations the dynamic block can be placed. */
  locations?: InputMaybe<Array<InputMaybe<MagentoApiDynamicBlockLocationEnum>>>;
  /** A value indicating the type of dynamic block to filter on. */
  type: MagentoApiDynamicBlockTypeEnum;
};

/** Contains details about a custom text attribute that the buyer entered. */
export type MagentoApiEnteredCustomAttributeInput = {
  /** A string that identifies the entered custom attribute. */
  attribute_code: Scalars["String"]["input"];
  /** The text or other entered value. */
  value: Scalars["String"]["input"];
};

/** Defines a customer-entered option. */
export type MagentoApiEnteredOptionInput = {
  /** The unique ID for a `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  uid: Scalars["ID"]["input"];
  /** Text the customer entered. */
  value: Scalars["String"]["input"];
};

/** Contains the `uid`, `relative_url`, and `type` attributes. */
export type MagentoApiEntityUrl = {
  __typename: "EntityUrl";
  /** @deprecated Use `relative_url` instead. */
  canonical_url?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `ProductInterface`, `CategoryInterface`, `CmsPage`, or similar object associated with the specified URL. This could be a product, category, or CMS page UID. */
  entity_uid?: Maybe<Scalars["ID"]["output"]>;
  /**
   * The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID.
   * @deprecated Use `entity_uid` instead.
   */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirectCode?: Maybe<Scalars["Int"]["output"]>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars["String"]["output"]>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
};

/** An error encountered while adding an item to the the cart. */
export type MagentoApiError = {
  /** A cart-specific error code. */
  code: MagentoApiCartUserInputErrorType;
  /** A localized error message. */
  message: Scalars["String"]["output"];
};

export type MagentoApiErrorInterface = {
  /** The returned error message. */
  message: Scalars["String"]["output"];
};

/** Contains details about an address. */
export type MagentoApiEstimateAddressInput = {
  /** The two-letter code representing the customer's country. */
  country_code: MagentoApiCountryCodeEnum;
  /** The customer's ZIP or postal code. */
  postcode?: InputMaybe<Scalars["String"]["input"]>;
  /** An object containing the region name, region code, and region ID. */
  region?: InputMaybe<MagentoApiCustomerAddressRegionInput>;
};

export type MagentoApiEstimateTotalsInput = {
  /** Customer's address to estimate totals. */
  address: MagentoApiEstimateAddressInput;
  /** The unique ID of the cart to query. */
  cart_id: Scalars["String"]["input"];
  /** Selected shipping method to estimate totals. */
  shipping_method?: InputMaybe<MagentoApiShippingMethodInput>;
};

/** Estimate totals output. */
export type MagentoApiEstimateTotalsOutput = {
  __typename: "EstimateTotalsOutput";
  /** Cart after totals estimation */
  cart?: Maybe<MagentoApiCart>;
};

/** Read-only shipping cost estimation for cart display. Does not affect the quote or shipping address. */
export type MagentoApiEstimatedShippingCost = {
  __typename: "EstimatedShippingCost";
  /** The estimated shipping cost amount in the store currency. */
  amount?: Maybe<MagentoApiMoney>;
  /** The carrier code used for estimation. */
  carrier_code?: Maybe<Scalars["String"]["output"]>;
  /** True when the estimation used the market default address (guest user or logged-in customer without a saved default address). False when the customer's own default shipping address was used. */
  is_market_default?: Maybe<Scalars["Boolean"]["output"]>;
  /** The method code used for estimation. */
  method_code?: Maybe<Scalars["String"]["output"]>;
  /** The display title of the estimated shipping method. */
  method_title?: Maybe<Scalars["String"]["output"]>;
};

/** Lists the exchange rate. */
export type MagentoApiExchangeRate = {
  __typename: "ExchangeRate";
  /** Specifies the store’s default currency to exchange to. */
  currency_to?: Maybe<Scalars["String"]["output"]>;
  /** The exchange rate for the store’s default currency. */
  rate?: Maybe<Scalars["Float"]["output"]>;
};

export type MagentoApiFastlaneConfig = MagentoApiPaymentConfigItem & {
  __typename: "FastlaneConfig";
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars["String"]["output"]>;
  /** The payment source for the payment method */
  payment_source?: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<MagentoApiSdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars["String"]["output"]>;
  /** 3DS mode */
  three_ds_mode?: Maybe<MagentoApiThreeDsMode>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Fastlane Payment inputs */
export type MagentoApiFastlaneMethodInput = {
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars["String"]["input"]>;
  /** The single use token from Fastlane */
  paypal_fastlane_token?: InputMaybe<Scalars["String"]["input"]>;
};

/** Defines a filter that matches the input exactly. */
export type MagentoApiFilterEqualTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific category ID, specify a value such as `5`. */
  eq?: InputMaybe<Scalars["String"]["input"]>;
  /** Use this attribute to filter on an array of values. For example, to filter on category IDs 4, 5, and 6, specify a value of `["4", "5", "6"]`. */
  in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MagentoApiFilterMatchTypeEnum = "FULL" | "PARTIAL";

/** Defines a filter that performs a fuzzy search. */
export type MagentoApiFilterMatchTypeInput = {
  /** Use this attribute to fuzzy match the specified string. For example, to filter on a specific SKU, specify a value such as `24-MB01`. */
  match?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter match type for fine-tuned results. Possible values FULL or PARTIAL. If match_type is not provided, returned results will default to FULL match. */
  match_type?: InputMaybe<MagentoApiFilterMatchTypeEnum>;
};

/** Defines a filter that matches a range of values, such as prices or dates. */
export type MagentoApiFilterRangeTypeInput = {
  /** Use this attribute to specify the lowest possible value in the range. */
  from?: InputMaybe<Scalars["String"]["input"]>;
  /** Use this attribute to specify the highest possible value in the range. */
  to?: InputMaybe<Scalars["String"]["input"]>;
};

/** Defines a filter for an input string. */
export type MagentoApiFilterStringTypeInput = {
  /** Filters items that are exactly the same as the specified string. */
  eq?: InputMaybe<Scalars["String"]["input"]>;
  /** Filters items that are exactly the same as entries specified in an array of strings. */
  in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Defines a filter that performs a fuzzy search using the specified string. */
  match?: InputMaybe<Scalars["String"]["input"]>;
};

/** Defines the comparison operators that can be used in a filter. */
export type MagentoApiFilterTypeInput = {
  /** Equals. */
  eq?: InputMaybe<Scalars["String"]["input"]>;
  finset?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** From. Must be used with the `to` field. */
  from?: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than. */
  gt?: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than or equal to. */
  gteq?: InputMaybe<Scalars["String"]["input"]>;
  /** In. The value can contain a set of comma-separated values. */
  in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters. */
  like?: InputMaybe<Scalars["String"]["input"]>;
  /** Less than. */
  lt?: InputMaybe<Scalars["String"]["input"]>;
  /** Less than or equal to. */
  lteq?: InputMaybe<Scalars["String"]["input"]>;
  /** More than or equal to. */
  moreq?: InputMaybe<Scalars["String"]["input"]>;
  /** Not equal to. */
  neq?: InputMaybe<Scalars["String"]["input"]>;
  /** Not in. The value can contain a set of comma-separated values. */
  nin?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Not null. */
  notnull?: InputMaybe<Scalars["String"]["input"]>;
  /** Is null. */
  null?: InputMaybe<Scalars["String"]["input"]>;
  /** To. Must be used with the `from` field. */
  to?: InputMaybe<Scalars["String"]["input"]>;
};

/** A single FPT that can be applied to a product price. */
export type MagentoApiFixedProductTax = {
  __typename: "FixedProductTax";
  /** The amount of the Fixed Product Tax. */
  amount?: Maybe<MagentoApiMoney>;
  /** The display label assigned to the Fixed Product Tax. */
  label?: Maybe<Scalars["String"]["output"]>;
};

/** Lists display settings for the Fixed Product Tax. */
export type MagentoApiFixedProductTaxDisplaySettings =
  /** The displayed price does not include the FPT amount. The values of `ProductPrice.fixed_product_taxes` and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price.' */
  | "EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS"
  /** The displayed price does not include the FPT amount. The values from `ProductPrice.fixed_product_taxes` are not displayed. This value corresponds to 'Excluding FPT'. */
  | "EXCLUDE_FPT_WITHOUT_DETAILS"
  /** The FPT feature is not enabled. You can omit `ProductPrice.fixed_product_taxes` from your query. */
  | "FPT_DISABLED"
  /** The displayed price includes the FPT amount without displaying the `ProductPrice.fixed_product_taxes` values. This value corresponds to 'Including FPT only'. */
  | "INCLUDE_FPT_WITHOUT_DETAILS"
  /** The displayed price includes the FPT amount while displaying the values of `ProductPrice.fixed_product_taxes` separately. This value corresponds to 'Including FPT and FPT description'. */
  | "INCLUDE_FPT_WITH_DETAILS";

export type MagentoApiFlavourAttribute = {
  __typename: "FlavourAttribute";
  /** Flavour attribute sub option ID. */
  id: Scalars["Int"]["output"];
  /** Flavour attribute sub option label. */
  name: Scalars["String"]["output"];
  /** Flavour attribute sub option sort_order. */
  sort_order: Scalars["Int"]["output"];
  /** Flavour attribute sub option value. */
  value: Scalars["String"]["output"];
};

export type MagentoApiFlavourDetails = {
  __typename: "FlavourDetails";
  /** Flavour attributes. */
  attributes?: Maybe<Array<Maybe<MagentoApiFlavourAttribute>>>;
  /** Flavour description. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Flavour ID. */
  id: Scalars["Int"]["output"];
  /** Flavour label. */
  name?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiFreeGiftProductData = {
  __typename: "FreeGiftProductData";
  /** Maximum allowed quantity to be added in the basket for a given gift */
  allowed_qty?: Maybe<Scalars["Int"]["output"]>;
  /** Gifting product limitation enabled */
  lifetime_limit_active?: Maybe<Scalars["Boolean"]["output"]>;
  /** Gifting product limitation quantity */
  lifetime_limit_qty?: Maybe<Scalars["Int"]["output"]>;
  /** list of gift products */
  products?: Maybe<Array<Maybe<MagentoApiGiftProductData>>>;
};

export type MagentoApiFrontendAttribute = {
  __typename: "FrontendAttribute";
  /** Attribute label */
  label: Scalars["String"]["output"];
  /** Attribute values or attribute option values for selects and multiselects */
  values?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

/** Identifies which customer requires remote shopping assistance. */
export type MagentoApiGenerateCustomerTokenAsAdminInput = {
  /** The email address of the customer requesting remote shopping assistance. */
  customer_email: Scalars["String"]["input"];
};

/** Contains the generated customer token. */
export type MagentoApiGenerateCustomerTokenAsAdminOutput = {
  __typename: "GenerateCustomerTokenAsAdminOutput";
  /** The generated customer token. */
  customer_token: Scalars["String"]["output"];
};

export type MagentoApiGetOrderDeliveryLimits = {
  __typename: "GetOrderDeliveryLimits";
  /** delivery limits enabled */
  limits?: Maybe<Array<Maybe<MagentoApiDeliveryLimits>>>;
  /** mode */
  mode?: Maybe<Scalars["String"]["output"]>;
};

/** Gets the payment SDK URLs and values */
export type MagentoApiGetPaymentSdkOutput = {
  __typename: "GetPaymentSDKOutput";
  /** The payment SDK parameters */
  sdkParams?: Maybe<Array<Maybe<MagentoApiPaymentSdkParamsItem>>>;
};

export type MagentoApiGetorderstatus = {
  __typename: "Getorderstatus";
  /** Is cancel order possible. */
  cancelable?: Maybe<Scalars["Boolean"]["output"]>;
  /** Status label. */
  status_label?: Maybe<Scalars["String"]["output"]>;
  /** Status value. */
  status_value?: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about the gift card account. */
export type MagentoApiGiftCardAccount = {
  __typename: "GiftCardAccount";
  /** The balance remaining on the gift card. */
  balance?: Maybe<MagentoApiMoney>;
  /** The gift card account code. */
  code?: Maybe<Scalars["String"]["output"]>;
  /** The expiration date of the gift card. */
  expiration_date?: Maybe<Scalars["String"]["output"]>;
};

/** Contains the gift card code. */
export type MagentoApiGiftCardAccountInput = {
  /** The applied gift card code. */
  gift_card_code: Scalars["String"]["input"];
};

/** Contains the value of a gift card, the website that generated the card, and related information. */
export type MagentoApiGiftCardAmounts = {
  __typename: "GiftCardAmounts";
  /** An internal attribute ID. */
  attribute_id?: Maybe<Scalars["Int"]["output"]>;
  /** The unique ID for a `GiftCardAmounts` object. */
  uid: Scalars["ID"]["output"];
  /** The value of the gift card. */
  value?: Maybe<Scalars["Float"]["output"]>;
  /**
   * An ID that is assigned to each unique gift card amount.
   * @deprecated Use `uid` instead
   */
  value_id?: Maybe<Scalars["Int"]["output"]>;
  /** The ID of the website that generated the gift card. */
  website_id?: Maybe<Scalars["Int"]["output"]>;
  /** The value of the gift card. */
  website_value?: Maybe<Scalars["Float"]["output"]>;
};

/** Contains details about a gift card that has been added to a cart. */
export type MagentoApiGiftCardCartItem = MagentoApiCartItemInterface & {
  __typename: "GiftCardCartItem";
  /** The amount and currency of the gift card. */
  amount: MagentoApiMoney;
  /** The list of available gift wrapping options for the cart item. */
  available_gift_wrapping: Array<Maybe<MagentoApiGiftWrapping>>;
  /** An array of customizations applied to the gift card. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<MagentoApiCartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** The entered gift message data for the gift card cart item */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** The selected gift wrapping option for the cart item. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** The message from the sender to the recipient. */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiCartItemPrices>;
  /** Details about an item in the cart. */
  product: MagentoApiProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The email address of the person receiving the gift card. */
  recipient_email?: Maybe<Scalars["String"]["output"]>;
  /** The name of the person receiving the gift card. */
  recipient_name: Scalars["String"]["output"];
  /** The email address of the sender. */
  sender_email?: Maybe<Scalars["String"]["output"]>;
  /** The name of the sender. */
  sender_name: Scalars["String"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

export type MagentoApiGiftCardCreditMemoItem = MagentoApiCreditMemoItemInterface & {
  __typename: "GiftCardCreditMemoItem";
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** Selected gift card properties for a credit memo item. */
  gift_card?: Maybe<MagentoApiGiftCardItem>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars["Float"]["output"]>;
};

export type MagentoApiGiftCardInvoiceItem = MagentoApiInvoiceItemInterface & {
  __typename: "GiftCardInvoiceItem";
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** Selected gift card properties for an invoice item. */
  gift_card?: Maybe<MagentoApiGiftCardItem>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Details about an individual order item. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars["Float"]["output"]>;
};

/** Contains details about a gift card. */
export type MagentoApiGiftCardItem = {
  __typename: "GiftCardItem";
  /** The message from the sender to the recipient. */
  message?: Maybe<Scalars["String"]["output"]>;
  /** The email address of the receiver of a virtual gift card. */
  recipient_email?: Maybe<Scalars["String"]["output"]>;
  /** The name of the receiver of a physical or virtual gift card. */
  recipient_name?: Maybe<Scalars["String"]["output"]>;
  /** The email address of the sender of a virtual gift card. */
  sender_email?: Maybe<Scalars["String"]["output"]>;
  /** The name of the sender of a physical or virtual gift card. */
  sender_name?: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about the sender, recipient, and amount of a gift card. */
export type MagentoApiGiftCardOptions = {
  __typename: "GiftCardOptions";
  /** The amount and currency of the gift card. */
  amount?: Maybe<MagentoApiMoney>;
  /** The custom amount and currency of the gift card. */
  custom_giftcard_amount?: Maybe<MagentoApiMoney>;
  /** The message from the sender to the recipient. */
  message?: Maybe<Scalars["String"]["output"]>;
  /** The email address of the person receiving the gift card. */
  recipient_email?: Maybe<Scalars["String"]["output"]>;
  /** The name of the person receiving the gift card. */
  recipient_name?: Maybe<Scalars["String"]["output"]>;
  /** The email address of the sender. */
  sender_email?: Maybe<Scalars["String"]["output"]>;
  /** The name of the sender. */
  sender_name?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiGiftCardOrderItem = MagentoApiOrderItemInterface & {
  __typename: "GiftCardOrderItem";
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return?: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** Selected gift card properties for an order item. */
  gift_card?: Maybe<MagentoApiGiftCardItem>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: MagentoApiMoney;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<MagentoApiProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription?: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested?: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: MagentoApiMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: MagentoApiMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Defines properties of a gift card. */
export type MagentoApiGiftCardProduct = MagentoApiCustomizableProductInterface &
  MagentoApiPhysicalProductInterface &
  MagentoApiProductInterface &
  MagentoApiRoutableInterface & {
    __typename: "GiftCardProduct";
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the customer can provide a message to accompany the gift card. */
    allow_message?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether shoppers have the ability to set the value of the gift card. */
    allow_open_amount?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<MagentoApiCategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1?: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2?: Maybe<MagentoApiProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code?: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family?: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<MagentoApiFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula?: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts?: Maybe<MagentoApiFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes?: Maybe<Array<Maybe<MagentoApiFrontendAttribute>>>;
    /** An array of customizable gift card options. */
    gift_card_options: Array<Maybe<MagentoApiCustomizableOptionInterface>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price?: Maybe<MagentoApiMoney>;
    /** An array that contains information about the values and ID of a gift card. */
    giftcard_amounts?: Maybe<Array<Maybe<MagentoApiGiftCardAmounts>>>;
    /** An enumeration that specifies the type of gift card. */
    giftcard_type?: Maybe<MagentoApiGiftCardTypeEnum>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device?: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image?: Maybe<MagentoApiProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal?: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the customer can redeem the value on the card for cash. */
    is_redeemable?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** The number of days after purchase until the gift card expires. A null value means there is no limit. */
    lifetime?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent?: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MagentoApiMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MagentoApiMediaGalleryEntry>>>;
    /** The maximum number of characters the gift message can contain. */
    message_max_length?: Maybe<Scalars["Int"]["output"]>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type?: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description?: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label?: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price?: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled?: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model?: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks?: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars["Float"]["output"]>;
    /** The maximum acceptable value of an open amount gift card. */
    open_amount_max?: Maybe<Scalars["Float"]["output"]>;
    /** The minimum acceptable value of an open amount gift card. */
    open_amount_min?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand?: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<MagentoApiCustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<MagentoApiProductPrices>;
    /** The range of prices for the product */
    price_range: MagentoApiPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<MagentoApiTierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand?: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation?: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<MagentoApiProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province?: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label?: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity?: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category?: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region?: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label?: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible?: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: MagentoApiProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<MagentoApiProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility?: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status?: Maybe<MagentoApiProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details?: Maybe<MagentoApiStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<MagentoApiProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<MagentoApiProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka?: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku?: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label?: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<MagentoApiUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage?: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<MagentoApiWebsite>>>;
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars["Float"]["output"]>;
  };

/** Defines properties of a gift card. */
export type MagentoApiGiftCardProductCustom_AttributesV2Args = {
  filters?: InputMaybe<MagentoApiAttributeFilterInput>;
};

/** Defines properties of a gift card. */
export type MagentoApiGiftCardProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MagentoApiGiftCardShipmentItem = MagentoApiShipmentItemInterface & {
  __typename: "GiftCardShipmentItem";
  /** Selected gift card properties for a shipment item. */
  gift_card?: Maybe<MagentoApiGiftCardItem>;
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of shipped items. */
  quantity_shipped: Scalars["Float"]["output"];
};

/** Specifies the gift card type. */
export type MagentoApiGiftCardTypeEnum = "COMBINED" | "PHYSICAL" | "VIRTUAL";

/** A single gift card added to a wish list. */
export type MagentoApiGiftCardWishlistItem = MagentoApiWishlistItemInterface & {
  __typename: "GiftCardWishlistItem";
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Details about a gift card. */
  gift_card_options: MagentoApiGiftCardOptions;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

export type MagentoApiGiftData = {
  __typename: "GiftData";
  is_gift: Scalars["Boolean"]["output"];
  is_gift_removable?: Maybe<Scalars["Boolean"]["output"]>;
  parent_gift_id?: Maybe<Scalars["String"]["output"]>;
  parent_gift_sku: Scalars["String"]["output"];
};

/** Contains the text of a gift message, its sender, and recipient */
export type MagentoApiGiftMessage = {
  __typename: "GiftMessage";
  /** Sender name */
  from: Scalars["String"]["output"];
  /** Gift message text */
  message: Scalars["String"]["output"];
  /** Recipient name */
  to: Scalars["String"]["output"];
};

/** Defines a gift message. */
export type MagentoApiGiftMessageInput = {
  /** The name of the sender. */
  from: Scalars["String"]["input"];
  /** The text of the gift message. */
  message: Scalars["String"]["input"];
  /** The name of the recepient. */
  to: Scalars["String"]["input"];
};

/** Contains prices for gift wrapping options. */
export type MagentoApiGiftOptionsPrices = {
  __typename: "GiftOptionsPrices";
  /** Price of the gift wrapping for all individual order items. */
  gift_wrapping_for_items?: Maybe<MagentoApiMoney>;
  /** Price of the gift wrapping for all individual order items including tax. */
  gift_wrapping_for_items_incl_tax?: Maybe<MagentoApiMoney>;
  /** Price of the gift wrapping for the whole order. */
  gift_wrapping_for_order?: Maybe<MagentoApiMoney>;
  /** Price of the gift wrapping for the whole order including tax. */
  gift_wrapping_for_order_incl_tax?: Maybe<MagentoApiMoney>;
  /** Price for the printed card. */
  printed_card?: Maybe<MagentoApiMoney>;
  /** Price for the printed card including tax. */
  printed_card_incl_tax?: Maybe<MagentoApiMoney>;
};

export type MagentoApiGiftProductData = {
  __typename: "GiftProductData";
  /** Provides information about eligibility conditions */
  eligibility_description: Scalars["String"]["output"];
  /** Provides if the customer gift eligibility */
  is_eligible: Scalars["Boolean"]["output"];
  /** Gift Product */
  product: MagentoApiProductInterface;
};

/** Contains details about a gift registry. */
export type MagentoApiGiftRegistry = {
  __typename: "GiftRegistry";
  /** The date on which the gift registry was created. Only the registry owner can access this attribute. */
  created_at: Scalars["String"]["output"];
  /** An array of attributes that define elements of the gift registry. Each attribute is specified as a code-value pair. */
  dynamic_attributes?: Maybe<Array<Maybe<MagentoApiGiftRegistryDynamicAttribute>>>;
  /** The name of the event. */
  event_name: Scalars["String"]["output"];
  /** An array of products added to the gift registry. */
  items?: Maybe<Array<Maybe<MagentoApiGiftRegistryItemInterface>>>;
  /** The message text the customer entered to describe the event. */
  message: Scalars["String"]["output"];
  /** The customer who created the gift registry. */
  owner_name: Scalars["String"]["output"];
  /** An enum that states whether the gift registry is PRIVATE or PUBLIC. Only the registry owner can access this attribute. */
  privacy_settings: MagentoApiGiftRegistryPrivacySettings;
  /** Contains details about each registrant for the event. */
  registrants?: Maybe<Array<Maybe<MagentoApiGiftRegistryRegistrant>>>;
  /** Contains the customer's shipping address. Only the registry owner can access this attribute. */
  shipping_address?: Maybe<MagentoApiCustomerAddress>;
  /** An enum that states whether the gift registry is ACTIVE or INACTIVE. Only the registry owner can access this attribute. */
  status: MagentoApiGiftRegistryStatus;
  /** The type of gift registry. */
  type?: Maybe<MagentoApiGiftRegistryType>;
  /** The unique ID assigned to the gift registry. */
  uid: Scalars["ID"]["output"];
};

export type MagentoApiGiftRegistryDynamicAttribute = MagentoApiGiftRegistryDynamicAttributeInterface & {
  __typename: "GiftRegistryDynamicAttribute";
  /** The internal ID of the dynamic attribute. */
  code: Scalars["ID"]["output"];
  /** Indicates which group the dynamic attribute is a member of. */
  group: MagentoApiGiftRegistryDynamicAttributeGroup;
  /** The display name of the dynamic attribute. */
  label: Scalars["String"]["output"];
  /** A corresponding value for the code. */
  value: Scalars["String"]["output"];
};

/** Defines the group type of a gift registry dynamic attribute. */
export type MagentoApiGiftRegistryDynamicAttributeGroup =
  | "DETAILED_INFORMATION"
  | "EVENT_INFORMATION"
  | "GENERAL_INFORMATION"
  | "PRIVACY_SETTINGS"
  | "REGISTRANT"
  | "SHIPPING_ADDRESS";

/** Defines a dynamic attribute. */
export type MagentoApiGiftRegistryDynamicAttributeInput = {
  /** A unique key for an additional attribute of the event. */
  code: Scalars["ID"]["input"];
  /** A string that describes a dynamic attribute. */
  value: Scalars["String"]["input"];
};

export type MagentoApiGiftRegistryDynamicAttributeInterface = {
  /** The internal ID of the dynamic attribute. */
  code: Scalars["ID"]["output"];
  /** The display name of the dynamic attribute. */
  label: Scalars["String"]["output"];
  /** A corresponding value for the code. */
  value: Scalars["String"]["output"];
};

export type MagentoApiGiftRegistryDynamicAttributeMetadata = MagentoApiGiftRegistryDynamicAttributeMetadataInterface & {
  __typename: "GiftRegistryDynamicAttributeMetadata";
  /** Indicates which group the dynamic attribute a member of. */
  attribute_group: Scalars["String"]["output"];
  /** The internal ID of the dynamic attribute. */
  code: Scalars["ID"]["output"];
  /** The selected input type for this dynamic attribute. The value can be one of several static or custom types. */
  input_type: Scalars["String"]["output"];
  /** Indicates whether the dynamic attribute is required. */
  is_required: Scalars["Boolean"]["output"];
  /** The display name of the dynamic attribute. */
  label: Scalars["String"]["output"];
  /** The order in which to display the dynamic attribute. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
};

export type MagentoApiGiftRegistryDynamicAttributeMetadataInterface = {
  /** Indicates which group the dynamic attribute a member of. */
  attribute_group: Scalars["String"]["output"];
  /** The internal ID of the dynamic attribute. */
  code: Scalars["ID"]["output"];
  /** The selected input type for this dynamic attribute. The value can be one of several static or custom types. */
  input_type: Scalars["String"]["output"];
  /** Indicates whether the dynamic attribute is required. */
  is_required: Scalars["Boolean"]["output"];
  /** The display name of the dynamic attribute. */
  label: Scalars["String"]["output"];
  /** The order in which to display the dynamic attribute. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
};

export type MagentoApiGiftRegistryItem = MagentoApiGiftRegistryItemInterface & {
  __typename: "GiftRegistryItem";
  /** The date the product was added to the gift registry. */
  created_at: Scalars["String"]["output"];
  /** A brief message about the gift registry item. */
  note?: Maybe<Scalars["String"]["output"]>;
  /** Details about the gift registry item. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The requested quantity of the product. */
  quantity: Scalars["Float"]["output"];
  /** The fulfilled quantity of the product. */
  quantity_fulfilled: Scalars["Float"]["output"];
  /** The unique ID of a gift registry item. */
  uid: Scalars["ID"]["output"];
};

export type MagentoApiGiftRegistryItemInterface = {
  /** The date the product was added to the gift registry. */
  created_at: Scalars["String"]["output"];
  /** A brief message about the gift registry item. */
  note?: Maybe<Scalars["String"]["output"]>;
  /** Details about the gift registry item. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The requested quantity of the product. */
  quantity: Scalars["Float"]["output"];
  /** The fulfilled quantity of the product. */
  quantity_fulfilled: Scalars["Float"]["output"];
  /** The unique ID of a gift registry item. */
  uid: Scalars["ID"]["output"];
};

/** Contains the status and any errors that encountered with the customer's gift register item. */
export type MagentoApiGiftRegistryItemUserErrorInterface = {
  /** Indicates whether the attempt to move the cart items to the gift registry was successful. */
  status: Scalars["Boolean"]["output"];
  /** An array of errors encountered while moving items from the cart to the gift registry. */
  user_errors: Array<Maybe<MagentoApiGiftRegistryItemsUserError>>;
};

/** Contains error information. */
export type MagentoApiGiftRegistryItemUserErrors = MagentoApiGiftRegistryItemUserErrorInterface & {
  __typename: "GiftRegistryItemUserErrors";
  /** Indicates whether the attempt to move the cart items to the gift registry was successful. */
  status: Scalars["Boolean"]["output"];
  /** An array of errors encountered while moving items from the cart to the gift registry. */
  user_errors: Array<Maybe<MagentoApiGiftRegistryItemsUserError>>;
};

/** Contains details about an error that occurred when processing a gift registry item. */
export type MagentoApiGiftRegistryItemsUserError = {
  __typename: "GiftRegistryItemsUserError";
  /** An error code that describes the error encountered. */
  code: MagentoApiGiftRegistryItemsUserErrorType;
  /** The unique ID of the gift registry item containing an error. */
  gift_registry_item_uid?: Maybe<Scalars["ID"]["output"]>;
  /** The unique ID of the `GiftRegistry` object containing an error. */
  gift_registry_uid?: Maybe<Scalars["ID"]["output"]>;
  /** A localized error message. */
  message: Scalars["String"]["output"];
  /** The unique ID of the product containing an error. */
  product_uid?: Maybe<Scalars["ID"]["output"]>;
};

/** Defines the error type. */
export type MagentoApiGiftRegistryItemsUserErrorType =
  /** Used for exceptions like EntityNotFound. */
  | "NOT_FOUND"
  /** Used for handling out of stock products. */
  | "OUT_OF_STOCK"
  /** Used for other exceptions, such as database connection failures. */
  | "UNDEFINED";

/** Contains details about the gift registry. */
export type MagentoApiGiftRegistryOutput = MagentoApiGiftRegistryOutputInterface & {
  __typename: "GiftRegistryOutput";
  /** The gift registry. */
  gift_registry?: Maybe<MagentoApiGiftRegistry>;
};

/** Contains the customer's gift registry. */
export type MagentoApiGiftRegistryOutputInterface = {
  /** The gift registry. */
  gift_registry?: Maybe<MagentoApiGiftRegistry>;
};

/** Defines the privacy setting of the gift registry. */
export type MagentoApiGiftRegistryPrivacySettings = "PRIVATE" | "PUBLIC";

/** Contains details about a registrant. */
export type MagentoApiGiftRegistryRegistrant = {
  __typename: "GiftRegistryRegistrant";
  /** An array of dynamic attributes assigned to the registrant. */
  dynamic_attributes?: Maybe<Array<Maybe<MagentoApiGiftRegistryRegistrantDynamicAttribute>>>;
  /** The email address of the registrant. Only the registry owner can access this attribute. */
  email: Scalars["String"]["output"];
  /** The first name of the registrant. */
  firstname: Scalars["String"]["output"];
  /** The last name of the registrant. */
  lastname: Scalars["String"]["output"];
  /** The unique ID assigned to the registrant. */
  uid: Scalars["ID"]["output"];
};

export type MagentoApiGiftRegistryRegistrantDynamicAttribute = MagentoApiGiftRegistryDynamicAttributeInterface & {
  __typename: "GiftRegistryRegistrantDynamicAttribute";
  /** The internal ID of the dynamic attribute. */
  code: Scalars["ID"]["output"];
  /** The display name of the dynamic attribute. */
  label: Scalars["String"]["output"];
  /** A corresponding value for the code. */
  value: Scalars["String"]["output"];
};

/** Contains the results of a gift registry search. */
export type MagentoApiGiftRegistrySearchResult = {
  __typename: "GiftRegistrySearchResult";
  /** The date of the event. */
  event_date?: Maybe<Scalars["String"]["output"]>;
  /** The title given to the event. */
  event_title: Scalars["String"]["output"];
  /** The URL key of the gift registry. */
  gift_registry_uid: Scalars["ID"]["output"];
  /** The location of the event. */
  location?: Maybe<Scalars["String"]["output"]>;
  /** The name of the gift registry owner. */
  name: Scalars["String"]["output"];
  /** The type of event being held. */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Defines a shipping address for a gift registry. Specify either `address_data` or the `address_id`. If both are provided, validation will fail. */
export type MagentoApiGiftRegistryShippingAddressInput = {
  /** Defines the shipping address for this gift registry. */
  address_data?: InputMaybe<MagentoApiCustomerAddressInput>;
  /** The ID assigned to this customer address. */
  address_id?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Defines the status of the gift registry. */
export type MagentoApiGiftRegistryStatus = "ACTIVE" | "INACTIVE";

/** Contains details about a gift registry type. */
export type MagentoApiGiftRegistryType = {
  __typename: "GiftRegistryType";
  /** An array of attributes that define elements of the gift registry. Each attribute is specified as a code-value pair. */
  dynamic_attributes_metadata?: Maybe<Array<Maybe<MagentoApiGiftRegistryDynamicAttributeMetadataInterface>>>;
  /** The label assigned to the gift registry type on the Admin. */
  label: Scalars["String"]["output"];
  /** The unique ID assigned to the gift registry type. */
  uid: Scalars["ID"]["output"];
};

export type MagentoApiGiftSelectionProduct = {
  __typename: "GiftSelectionProduct";
  /** Product entity ID */
  id: Scalars["Int"]["output"];
  /** Product name */
  name: Scalars["String"]["output"];
  /** Product SKU */
  sku: Scalars["String"]["output"];
};

/** Contains details about the selected or available gift wrapping options. */
export type MagentoApiGiftWrapping = {
  __typename: "GiftWrapping";
  /** The name of the gift wrapping design. */
  design: Scalars["String"]["output"];
  /**
   * The unique ID for a `GiftWrapping` object.
   * @deprecated Use `uid` instead
   */
  id: Scalars["ID"]["output"];
  /** The preview image for a gift wrapping option. */
  image?: Maybe<MagentoApiGiftWrappingImage>;
  /** The gift wrapping price. */
  price: MagentoApiMoney;
  /** The unique ID for a `GiftWrapping` object. */
  uid: Scalars["ID"]["output"];
};

/** Points to an image associated with a gift wrapping option. */
export type MagentoApiGiftWrappingImage = {
  __typename: "GiftWrappingImage";
  /** The gift wrapping preview image label. */
  label: Scalars["String"]["output"];
  /** The gift wrapping preview image URL. */
  url: Scalars["String"]["output"];
};

export type MagentoApiGooglePayButtonStyles = {
  __typename: "GooglePayButtonStyles";
  /** The button color */
  color?: Maybe<Scalars["String"]["output"]>;
  /** The button height in pixels */
  height?: Maybe<Scalars["Int"]["output"]>;
  /** The button type */
  type?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiGooglePayConfig = MagentoApiPaymentConfigItem & {
  __typename: "GooglePayConfig";
  /** The styles for the GooglePay Button configuration */
  button_styles?: Maybe<MagentoApiGooglePayButtonStyles>;
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars["String"]["output"]>;
  /** The payment source for the payment method */
  payment_source?: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<MagentoApiSdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars["String"]["output"]>;
  /** 3DS mode */
  three_ds_mode?: Maybe<MagentoApiThreeDsMode>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Google Pay inputs */
export type MagentoApiGooglePayMethodInput = {
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars["String"]["input"]>;
  /** The payment services order ID */
  payments_order_id?: InputMaybe<Scalars["String"]["input"]>;
  /** PayPal order ID */
  paypal_order_id?: InputMaybe<Scalars["String"]["input"]>;
};

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type MagentoApiGroupedProduct = MagentoApiPhysicalProductInterface &
  MagentoApiProductInterface &
  MagentoApiRoutableInterface & {
    __typename: "GroupedProduct";
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer?: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<MagentoApiCategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1?: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2?: Maybe<MagentoApiProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code?: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family?: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<MagentoApiFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula?: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts?: Maybe<MagentoApiFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes?: Maybe<Array<Maybe<MagentoApiFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price?: Maybe<MagentoApiMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device?: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image?: Maybe<MagentoApiProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal?: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable?: Maybe<Scalars["String"]["output"]>;
    /** An array containing grouped product items. */
    items?: Maybe<Array<Maybe<MagentoApiGroupedProductItem>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent?: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MagentoApiMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MagentoApiMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type?: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description?: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label?: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price?: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled?: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model?: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks?: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand?: Maybe<Scalars["Int"]["output"]>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<MagentoApiProductPrices>;
    /** The range of prices for the product */
    price_range: MagentoApiPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<MagentoApiTierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand?: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation?: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<MagentoApiProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province?: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label?: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity?: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category?: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region?: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label?: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible?: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: MagentoApiProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<MagentoApiProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility?: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status?: Maybe<MagentoApiProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details?: Maybe<MagentoApiStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<MagentoApiProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<MagentoApiProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka?: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku?: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label?: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<MagentoApiUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage?: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<MagentoApiWebsite>>>;
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars["Float"]["output"]>;
  };

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type MagentoApiGroupedProductCustom_AttributesV2Args = {
  filters?: InputMaybe<MagentoApiAttributeFilterInput>;
};

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type MagentoApiGroupedProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Contains information about an individual grouped product item. */
export type MagentoApiGroupedProductItem = {
  __typename: "GroupedProductItem";
  /** The relative position of this item compared to the other group items. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** Details about this product option. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The quantity of this grouped product item. */
  qty?: Maybe<Scalars["Float"]["output"]>;
};

/** A grouped product wish list item. */
export type MagentoApiGroupedProductWishlistItem = MagentoApiWishlistItemInterface & {
  __typename: "GroupedProductWishlistItem";
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

/** Input to retrieve a guest order based on token. */
export type MagentoApiGuestOrderCancelInput = {
  /** Cancellation reason. */
  reason: Scalars["String"]["input"];
  /** Order token. */
  token: Scalars["String"]["input"];
};

export type MagentoApiHostedFieldsConfig = MagentoApiPaymentConfigItem & {
  __typename: "HostedFieldsConfig";
  /** Vault payment method code */
  cc_vault_code?: Maybe<Scalars["String"]["output"]>;
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars["String"]["output"]>;
  /** Card vault enabled */
  is_vault_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars["String"]["output"]>;
  /** The payment source for the payment method */
  payment_source?: Maybe<Scalars["String"]["output"]>;
  /** Card and bin details required */
  requires_card_details?: Maybe<Scalars["Boolean"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<MagentoApiSdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars["String"]["output"]>;
  /**
   * Whether 3DS is activated; true if 3DS mode is not OFF.
   * @deprecated Use 'three_ds_mode' instead.
   */
  three_ds?: Maybe<Scalars["Boolean"]["output"]>;
  /** 3DS mode */
  three_ds_mode?: Maybe<MagentoApiThreeDsMode>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Hosted Fields payment inputs */
export type MagentoApiHostedFieldsInput = {
  /** Card bin number */
  cardBin?: InputMaybe<Scalars["String"]["input"]>;
  /** Expiration month of the card */
  cardExpiryMonth?: InputMaybe<Scalars["String"]["input"]>;
  /** Expiration year of the card */
  cardExpiryYear?: InputMaybe<Scalars["String"]["input"]>;
  /** Last four digits of the card */
  cardLast4?: InputMaybe<Scalars["String"]["input"]>;
  /** Name on the card */
  holderName?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates whether details about the shopper's credit/debit card should be tokenized for later usage. Required only if Vault is enabled for the Payment Services payment integration. */
  is_active_payment_token_enabler?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars["String"]["input"]>;
  /** The payment services order ID */
  payments_order_id?: InputMaybe<Scalars["String"]["input"]>;
  /** PayPal order ID */
  paypal_order_id?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payments Pro Hosted Solution payment method. */
export type MagentoApiHostedProInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. For example, if the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars["String"]["input"];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. For example, if the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars["String"]["input"];
};

/** Contains the secure URL used for the Payments Pro Hosted Solution payment method. */
export type MagentoApiHostedProUrl = {
  __typename: "HostedProUrl";
  /** The secure URL generated by PayPal. */
  secure_form_url?: Maybe<Scalars["String"]["output"]>;
};

/** Contains the required input to request the secure URL for Payments Pro Hosted Solution payment. */
export type MagentoApiHostedProUrlInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars["String"]["input"];
};

/** Contains target path parameters. */
export type MagentoApiHttpQueryParameter = {
  __typename: "HttpQueryParameter";
  /** A parameter name. */
  name?: Maybe<Scalars["String"]["output"]>;
  /** A parameter value. */
  value?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiImageSwatchData = MagentoApiSwatchDataInterface & {
  __typename: "ImageSwatchData";
  /** The URL assigned to the thumbnail of the swatch image. */
  thumbnail?: Maybe<Scalars["String"]["output"]>;
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** List of templates/filters applied to customer attribute input. */
export type MagentoApiInputFilterEnum =
  /** Forces attribute input to follow the date format. */
  | "DATE"
  /** Escape HTML Entities. */
  | "ESCAPEHTML"
  /** There are no templates or filters to be applied. */
  | "NONE"
  /** Strip HTML Tags. */
  | "STRIPTAGS"
  /** Strip whitespace (or other characters) from the beginning and end of the input. */
  | "TRIM";

export type MagentoApiInsufficientStockError = MagentoApiError & {
  __typename: "InsufficientStockError";
  /** A cart-specific error code. */
  code: MagentoApiCartUserInputErrorType;
  /** A localized error message. */
  message: Scalars["String"]["output"];
  /** Amount of available stock */
  quantity?: Maybe<Scalars["Float"]["output"]>;
};

/** Contains an error message when an internal error occurred. */
export type MagentoApiInternalError = MagentoApiErrorInterface & {
  __typename: "InternalError";
  /** The returned error message. */
  message: Scalars["String"]["output"];
};

/** Contains invoice details. */
export type MagentoApiInvoice = {
  __typename: "Invoice";
  /** Comments on the invoice. */
  comments?: Maybe<Array<Maybe<MagentoApiSalesCommentItem>>>;
  /** The unique ID for a `Invoice` object. */
  id: Scalars["ID"]["output"];
  /** Invoiced product details. */
  items?: Maybe<Array<Maybe<MagentoApiInvoiceItemInterface>>>;
  /** Sequential invoice number. */
  number: Scalars["String"]["output"];
  path?: Maybe<Scalars["String"]["output"]>;
  /** Invoice total amount details. */
  total?: Maybe<MagentoApiInvoiceTotal>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiInvoiceItem = MagentoApiInvoiceItemInterface & {
  __typename: "InvoiceItem";
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Details about an individual order item. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars["Float"]["output"]>;
};

/** Contains detailes about invoiced items. */
export type MagentoApiInvoiceItemInterface = {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Details about an individual order item. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars["Float"]["output"]>;
};

/** Contains price details from an invoice. */
export type MagentoApiInvoiceTotal = {
  __typename: "InvoiceTotal";
  /** The final base grand total amount in the base currency. */
  base_grand_total: MagentoApiMoney;
  /** The applied discounts to the invoice. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: MagentoApiMoney;
  /** Details about the shipping and handling costs for the invoice. */
  shipping_handling?: Maybe<MagentoApiShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: MagentoApiMoney;
  /** The invoice tax details. */
  taxes?: Maybe<Array<Maybe<MagentoApiTaxItem>>>;
  /** The shipping amount for the invoice. */
  total_shipping: MagentoApiMoney;
  /** The amount of tax applied to the invoice. */
  total_tax: MagentoApiMoney;
};

/** Contains the result of the `isEmailAvailable` query. */
export type MagentoApiIsEmailAvailableOutput = {
  __typename: "IsEmailAvailableOutput";
  /** Indicates whether the specified email address can be used to create a customer. */
  is_email_available?: Maybe<Scalars["Boolean"]["output"]>;
};

/** A list of options of the selected bundle product. */
export type MagentoApiItemSelectedBundleOption = {
  __typename: "ItemSelectedBundleOption";
  /**
   * The unique ID for a `ItemSelectedBundleOption` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars["ID"]["output"];
  /** The label of the option. */
  label: Scalars["String"]["output"];
  /** The unique ID for a `ItemSelectedBundleOption` object. */
  uid: Scalars["ID"]["output"];
  /** A list of products that represent the values of the parent option. */
  values?: Maybe<Array<Maybe<MagentoApiItemSelectedBundleOptionValue>>>;
};

/** A list of values for the selected bundle product. */
export type MagentoApiItemSelectedBundleOptionValue = {
  __typename: "ItemSelectedBundleOptionValue";
  /**
   * The unique ID for a `ItemSelectedBundleOptionValue` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars["ID"]["output"];
  /** Provides information on the selections for presentation prices only on order item */
  presentation_info?: Maybe<MagentoApiPresentationPrices>;
  /** The price of the child bundle product. */
  price: MagentoApiMoney;
  /** The name of the child bundle product. */
  product_name: Scalars["String"]["output"];
  /** The SKU of the child bundle product. */
  product_sku: Scalars["String"]["output"];
  /** The number of this bundle product that were ordered. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `ItemSelectedBundleOptionValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains a key-value pair. */
export type MagentoApiKeyValue = {
  __typename: "KeyValue";
  /** The name part of the key/value pair. */
  name?: Maybe<Scalars["String"]["output"]>;
  /** The value part of the key/value pair. */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Contains information for rendering layered navigation. */
export type MagentoApiLayerFilter = {
  __typename: "LayerFilter";
  /**
   * An array of filter items.
   * @deprecated Use `Aggregation.options` instead.
   */
  filter_items?: Maybe<Array<Maybe<MagentoApiLayerFilterItemInterface>>>;
  /**
   * The count of filter items in filter group.
   * @deprecated Use `Aggregation.count` instead.
   */
  filter_items_count?: Maybe<Scalars["Int"]["output"]>;
  /**
   * The name of a layered navigation filter.
   * @deprecated Use `Aggregation.label` instead.
   */
  name?: Maybe<Scalars["String"]["output"]>;
  /**
   * The request variable name for a filter query.
   * @deprecated Use `Aggregation.attribute_code` instead.
   */
  request_var?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiLayerFilterItem = MagentoApiLayerFilterItemInterface & {
  __typename: "LayerFilterItem";
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars["Int"]["output"]>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars["String"]["output"]>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiLayerFilterItemInterface = {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars["Int"]["output"]>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars["String"]["output"]>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars["String"]["output"]>;
};

/** Defines characteristics about images and videos associated with a specific product. */
export type MagentoApiMediaGalleryEntry = {
  __typename: "MediaGalleryEntry";
  /** Details about the content of the media gallery item. */
  content?: Maybe<MagentoApiProductMediaGalleryEntriesContent>;
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** The path of the image on the server. */
  file?: Maybe<Scalars["String"]["output"]>;
  /**
   * The identifier assigned to the object.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** The alt text displayed on the storefront when the user points to the image. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** Either `image` or `video`. */
  media_type?: Maybe<Scalars["String"]["output"]>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The unique ID for a `MediaGalleryEntry` object. */
  uid: Scalars["ID"]["output"];
  /** Details about the content of a video item. */
  video_content?: Maybe<MagentoApiProductMediaGalleryEntriesVideoContent>;
};

/** Contains basic information about a product image or video. */
export type MagentoApiMediaGalleryInterface = {
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Contains basic information about a product image or video. */
export type MagentoApiMediaGalleryInterfaceUrlArgs = {
  dpr?: InputMaybe<Scalars["Int"]["input"]>;
  fit?: InputMaybe<Scalars["String"]["input"]>;
  height?: InputMaybe<Scalars["Int"]["input"]>;
  quality?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["String"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MagentoApiMessageStyleLogo = {
  __typename: "MessageStyleLogo";
  /** The type of logo for the PayPal Pay Later messaging */
  type?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiMessageStyles = {
  __typename: "MessageStyles";
  /** The message layout */
  layout?: Maybe<Scalars["String"]["output"]>;
  /** The message logo */
  logo?: Maybe<MagentoApiMessageStyleLogo>;
};

/** Defines a monetary value, including a numeric value and a currency code. */
export type MagentoApiMoney = {
  __typename: "Money";
  /** A three-letter currency code, such as USD or EUR. */
  currency?: Maybe<MagentoApiCurrencyEnum>;
  /** A number expressing a monetary value. */
  value?: Maybe<Scalars["Float"]["output"]>;
};

/** Defines a monetary value, including a numeric value and a currency code and multiplier. */
export type MagentoApiMoneyMultiplier = {
  __typename: "MoneyMultiplier";
  /** A three-letter currency code, such as USD or EUR. */
  currency?: Maybe<MagentoApiCurrencyEnum>;
  /** The specific multiplier for price value. */
  multiplier?: Maybe<Scalars["Int"]["output"]>;
  /** A number expressing a monetary value. */
  value?: Maybe<Scalars["Float"]["output"]>;
};

/** Contains the customer's gift registry and any errors encountered. */
export type MagentoApiMoveCartItemsToGiftRegistryOutput = MagentoApiGiftRegistryItemUserErrorInterface &
  MagentoApiGiftRegistryOutputInterface & {
    __typename: "MoveCartItemsToGiftRegistryOutput";
    /** The gift registry. */
    gift_registry?: Maybe<MagentoApiGiftRegistry>;
    /** Indicates whether the attempt to move the cart items to the gift registry was successful. */
    status: Scalars["Boolean"]["output"];
    /** An array of errors encountered while moving items from the cart to the gift registry. */
    user_errors: Array<Maybe<MagentoApiGiftRegistryItemsUserError>>;
  };

/** Contains the source and target wish lists after moving products. */
export type MagentoApiMoveProductsBetweenWishlistsOutput = {
  __typename: "MoveProductsBetweenWishlistsOutput";
  /** The destination wish list after receiving products moved from the source wish list. */
  destination_wishlist: MagentoApiWishlist;
  /** The source wish list after moving products from it. */
  source_wishlist: MagentoApiWishlist;
  /** An array of errors encountered while moving products to a wish list. */
  user_errors: Array<Maybe<MagentoApiWishListUserInputError>>;
};

export type MagentoApiMultiselectQuantity = {
  qty?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>;
  selection_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MagentoApiMutation = {
  __typename: "Mutation";
  /** Add one or more bundle products to the specified cart. We recommend using `addProductsToCart` instead. */
  addBundleProductsToCart?: Maybe<MagentoApiAddBundleProductsToCartOutput>;
  /** Add one or more configurable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addConfigurableProductsToCart?: Maybe<MagentoApiAddConfigurableProductsToCartOutput>;
  /** Add single pre-defined coupon code to the specified cart. */
  addCouponToCart?: Maybe<MagentoApiAddCouponToCartOutput>;
  /** Add one or more downloadable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addDownloadableProductsToCart?: Maybe<MagentoApiAddDownloadableProductsToCartOutput>;
  /** Add registrants to the specified gift registry. */
  addGiftRegistryRegistrants?: Maybe<MagentoApiAddGiftRegistryRegistrantsOutput>;
  /** Add any type of product to the cart. */
  addProductsToCart?: Maybe<MagentoApiAddProductsToCartOutput>;
  /** Add products to the specified compare list. */
  addProductsToCompareList?: Maybe<MagentoApiCompareList>;
  /** Creates a new cart and add any type of product to it */
  addProductsToNewCart?: Maybe<MagentoApiAddProductsToNewCartOutput>;
  /** Add one or more products to the specified wish list. This mutation supports all product types. */
  addProductsToWishlist?: Maybe<MagentoApiAddProductsToWishlistOutput>;
  /** Add a comment to an existing return. */
  addReturnComment?: Maybe<MagentoApiAddReturnCommentOutput>;
  /** Add tracking information to the return. */
  addReturnTracking?: Maybe<MagentoApiAddReturnTrackingOutput>;
  /** Add one or more simple products to the specified cart. We recommend using `addProductsToCart` instead. */
  addSimpleProductsToCart?: Maybe<MagentoApiAddSimpleProductsToCartOutput>;
  /** Add one or more virtual products to the specified cart. We recommend using `addProductsToCart` instead. */
  addVirtualProductsToCart?: Maybe<MagentoApiAddVirtualProductsToCartOutput>;
  /** Add items in the specified wishlist to the customer's cart. */
  addWishlistItemsToCart?: Maybe<MagentoApiAddWishlistItemsToCartOutput>;
  applyCampaignToCart?: Maybe<MagentoApiApplyCampaignToCartOutput>;
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponToCart?: Maybe<MagentoApiApplyCouponToCartOutput>;
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponsToCart?: Maybe<MagentoApiApplyCouponToCartOutput>;
  /** Apply a pre-defined gift card code to the specified cart. */
  applyGiftCardToCart?: Maybe<MagentoApiApplyGiftCardToCartOutput>;
  /** Apply all available points, up to the cart total. Partial redemption is not available. */
  applyRewardPointsToCart?: Maybe<MagentoApiApplyRewardPointsToCartOutput>;
  /** Apply store credit to the specified cart. */
  applyStoreCreditToCart?: Maybe<MagentoApiApplyStoreCreditToCartOutput>;
  /** Assign the specified compare list to the logged in customer. */
  assignCompareListToCustomer?: Maybe<MagentoApiAssignCompareListToCustomerOutput>;
  /** Assign a logged-in customer to the specified guest shopping cart. */
  assignCustomerToGuestCart: MagentoApiCart;
  /** Query by Subscribe for Back in Stock Notification. */
  backinstockSubscribe?: Maybe<Scalars["String"]["output"]>;
  /** Cancel the specified customer order. */
  cancelOrder?: Maybe<MagentoApiCancelOrderOutput>;
  /** Query by Cancel Order. */
  cancelorder?: Maybe<Scalars["Boolean"]["output"]>;
  cartCanApplyCoupons?: Maybe<Scalars["Boolean"]["output"]>;
  /** Change the password for the logged-in customer. */
  changeCustomerPassword?: Maybe<MagentoApiCustomer>;
  /** Remove all items from the specified cart. */
  clearCart: MagentoApiClearCartOutput;
  /** Synchronizes order details and place the order */
  completeOrder?: Maybe<MagentoApiPlaceOrderOutput>;
  /** Cancel the specified guest customer order. */
  confirmCancelOrder?: Maybe<MagentoApiCancelOrderOutput>;
  /** Confirms the email address for a customer. */
  confirmEmail?: Maybe<MagentoApiCustomerOutput>;
  /** Confirm the return. */
  confirmReturn?: Maybe<MagentoApiRequestReturnOutput>;
  /** Send a 'Contact Us' email to the merchant. */
  contactUs?: Maybe<MagentoApiContactUsOutput>;
  /** Copy products from one wish list to another. The original wish list is unchanged. */
  copyProductsBetweenWishlists?: Maybe<MagentoApiCopyProductsBetweenWishlistsOutput>;
  /** Create a new compare list. The compare list is saved for logged in customers. */
  createCompareList?: Maybe<MagentoApiCompareList>;
  /** @deprecated Use `createCustomerV2` instead. */
  createCustomer?: Maybe<MagentoApiCustomerOutput>;
  /** Create a billing or shipping address for a customer or guest. */
  createCustomerAddress?: Maybe<MagentoApiCustomerAddress>;
  /** Create a customer account. */
  createCustomerV2?: Maybe<MagentoApiCustomerOutput>;
  /**
   * Create an empty shopping cart for a guest or logged in user
   * @deprecated Use `Mutation.createGuestCart` or `Query.customerCart` for logged in customer
   */
  createEmptyCart?: Maybe<Scalars["String"]["output"]>;
  /** Create a gift registry on behalf of the customer. */
  createGiftRegistry?: Maybe<MagentoApiCreateGiftRegistryOutput>;
  /** Create a new shopping cart */
  createGuestCart?: Maybe<MagentoApiCreateGuestCartOutput>;
  /** Initiate a transaction and receive a token. Use this mutation for Payflow Pro and Payments Pro payment methods */
  createPayflowProToken?: Maybe<MagentoApiCreatePayflowProTokenOutput>;
  /** Creates a payment order for further payment processing */
  createPaymentOrder?: Maybe<MagentoApiCreatePaymentOrderOutput>;
  /** Initiate an Express Checkout transaction and receive a token. Use this mutation for Express Checkout and Payments Standard payment methods. */
  createPaypalExpressToken?: Maybe<MagentoApiPaypalExpressTokenOutput>;
  /** Create a product review for the specified product. */
  createProductReview: MagentoApiCreateProductReviewOutput;
  /** Creates a vault payment token */
  createVaultCardPaymentToken?: Maybe<MagentoApiCreateVaultCardPaymentTokenOutput>;
  /** Creates a vault card setup token */
  createVaultCardSetupToken?: Maybe<MagentoApiCreateVaultCardSetupTokenOutput>;
  /** Create a new wish list. */
  createWishlist?: Maybe<MagentoApiCreateWishlistOutput>;
  /** Delete the specified compare list. */
  deleteCompareList?: Maybe<MagentoApiDeleteCompareListOutput>;
  /** Delete customer account */
  deleteCustomer?: Maybe<Scalars["Boolean"]["output"]>;
  /** Delete the billing or shipping address of a customer. */
  deleteCustomerAddress?: Maybe<Scalars["Boolean"]["output"]>;
  /** Delete a customer's payment token. */
  deletePaymentToken?: Maybe<MagentoApiDeletePaymentTokenOutput>;
  /** Delete the specified wish list. You cannot delete the customer's default (first) wish list. */
  deleteWishlist?: Maybe<MagentoApiDeleteWishlistOutput>;
  /** Estimate shipping method(s) for cart based on address */
  estimateShippingMethods?: Maybe<Array<Maybe<MagentoApiAvailableShippingMethod>>>;
  /** Estimate totals for cart based on the address */
  estimateTotals: MagentoApiEstimateTotalsOutput;
  /** Generate a token for specified customer. */
  generateCustomerToken?: Maybe<MagentoApiCustomerToken>;
  /** Request a customer token so that an administrator can perform remote shopping assistance. */
  generateCustomerTokenAsAdmin?: Maybe<MagentoApiGenerateCustomerTokenAsAdminOutput>;
  /** Handle a payment response and save the payment in Quote. Use this mutation for Payflow Pro and Payments Pro payment methods. */
  handlePayflowProResponse?: Maybe<MagentoApiPayflowProResponseOutput>;
  /** Transfer the contents of a guest cart into the cart of a logged-in customer. */
  mergeCarts: MagentoApiCart;
  /** Move all items from the cart to a gift registry. */
  moveCartItemsToGiftRegistry?: Maybe<MagentoApiMoveCartItemsToGiftRegistryOutput>;
  /** Move products from one wish list to another. */
  moveProductsBetweenWishlists?: Maybe<MagentoApiMoveProductsBetweenWishlistsOutput>;
  /** Convert the quote into an order. */
  placeOrder?: Maybe<MagentoApiPlaceOrderOutput>;
  /** Redeem a gift card for store credit. */
  redeemGiftCardBalanceAsStoreCredit?: Maybe<MagentoApiGiftCardAccount>;
  removeCampaignFromCart?: Maybe<MagentoApiRemoveCampaignFromCartOutput>;
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponFromCart?: Maybe<MagentoApiRemoveCouponFromCartOutput>;
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponsFromCart?: Maybe<MagentoApiRemoveCouponFromCartOutput>;
  /** Removes a gift card from the cart. */
  removeGiftCardFromCart?: Maybe<MagentoApiRemoveGiftCardFromCartOutput>;
  /** Delete the specified gift registry. */
  removeGiftRegistry?: Maybe<MagentoApiRemoveGiftRegistryOutput>;
  /** Delete the specified items from a gift registry. */
  removeGiftRegistryItems?: Maybe<MagentoApiRemoveGiftRegistryItemsOutput>;
  /** Removes registrants from a gift registry. */
  removeGiftRegistryRegistrants?: Maybe<MagentoApiRemoveGiftRegistryRegistrantsOutput>;
  /** Delete the entire quantity of a specified item from the cart. If you remove all items from the cart, the cart continues to exist. */
  removeItemFromCart?: Maybe<MagentoApiRemoveItemFromCartOutput>;
  /** Remove products from the specified compare list. */
  removeProductsFromCompareList?: Maybe<MagentoApiCompareList>;
  /** Remove one or more products from the specified wish list. */
  removeProductsFromWishlist?: Maybe<MagentoApiRemoveProductsFromWishlistOutput>;
  /** Remove a tracked shipment from a return. */
  removeReturnTracking?: Maybe<MagentoApiRemoveReturnTrackingOutput>;
  /** Cancel the application of reward points to the cart. */
  removeRewardPointsFromCart?: Maybe<MagentoApiRemoveRewardPointsFromCartOutput>;
  /** Remove store credit that has been applied to the specified cart. */
  removeStoreCreditFromCart?: Maybe<MagentoApiRemoveStoreCreditFromCartOutput>;
  /** Add all products from a customer's previous order to the cart. */
  reorderItems?: Maybe<MagentoApiReorderItemsOutput>;
  /** Request to cancel specified guest order. */
  requestGuestOrderCancel?: Maybe<MagentoApiCancelOrderOutput>;
  requestGuestReturn?: Maybe<MagentoApiRequestReturnOutput>;
  /** Request an email with a reset password token for the registered customer identified by the specified email. */
  requestPasswordResetEmail?: Maybe<Scalars["Boolean"]["output"]>;
  /** Initiates a buyer's request to return items for replacement or refund. */
  requestReturn?: Maybe<MagentoApiRequestReturnOutput>;
  /** Resends the confirmation email to a customer. */
  resendConfirmationEmail?: Maybe<Scalars["Boolean"]["output"]>;
  /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using `requestPasswordResetEmail`. */
  resetPassword?: Maybe<Scalars["Boolean"]["output"]>;
  /** Revoke the customer token. */
  revokeCustomerToken?: Maybe<MagentoApiRevokeCustomerTokenOutput>;
  /** Send a message on behalf of a customer to the specified email addresses. */
  sendEmailToFriend?: Maybe<MagentoApiSendEmailToFriendOutput>;
  /** Set additional attributes for the selected cart */
  setAdditionalAttributes?: Maybe<MagentoApiSetAdditionalAttributesOutput>;
  /** Set the billing address on a specific cart. */
  setBillingAddressOnCart?: Maybe<MagentoApiSetBillingAddressOnCartOutput>;
  /** Sets the cart as inactive */
  setCartAsInactive?: Maybe<MagentoApiSetCartAsInactiveOutput>;
  /** Set gift options, including gift messages, gift wrapping, gift receipts, and printed cards. */
  setGiftOptionsOnCart?: Maybe<MagentoApiSetGiftOptionsOnCartOutput>;
  /** Assign the email address of a guest to the cart. */
  setGuestEmailOnCart?: Maybe<MagentoApiSetGuestEmailOnCartOutput>;
  /**
   * Set the cart payment method and convert the cart into an order.
   * @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request.
   */
  setPaymentMethodAndPlaceOrder?: Maybe<MagentoApiPlaceOrderOutput>;
  /** Apply a payment method to the cart. */
  setPaymentMethodOnCart?: Maybe<MagentoApiSetPaymentMethodOnCartOutput>;
  /** Set one or more shipping addresses on a specific cart. */
  setShippingAddressesOnCart?: Maybe<MagentoApiSetShippingAddressesOnCartOutput>;
  /** Set one or more delivery methods on a cart. */
  setShippingMethodsOnCart?: Maybe<MagentoApiSetShippingMethodsOnCartOutput>;
  /** Send an email about the gift registry to a list of invitees. */
  shareGiftRegistry?: Maybe<MagentoApiShareGiftRegistryOutput>;
  /** Subscribe the specified email to the store's newsletter. */
  subscribeEmailToNewsletter?: Maybe<MagentoApiSubscribeEmailToNewsletterOutput>;
  /** Synchronizes the payment order details for further payment processing */
  syncPaymentOrder?: Maybe<Scalars["Boolean"]["output"]>;
  /** Track that a product was viewed in adobe commerce */
  trackViewedProduct?: Maybe<Scalars["Boolean"]["output"]>;
  /** Modify items in the cart. */
  updateCartItems?: Maybe<MagentoApiUpdateCartItemsOutput>;
  /** @deprecated Use `updateCustomerV2` instead. */
  updateCustomer?: Maybe<MagentoApiCustomerOutput>;
  /** Update the billing or shipping address of a customer or guest. */
  updateCustomerAddress?: Maybe<MagentoApiCustomerAddress>;
  /** Change the email address for the logged-in customer. */
  updateCustomerEmail?: Maybe<MagentoApiCustomerOutput>;
  /** Update the customer's personal information. */
  updateCustomerV2?: Maybe<MagentoApiCustomerOutput>;
  /** Update the specified gift registry. */
  updateGiftRegistry?: Maybe<MagentoApiUpdateGiftRegistryOutput>;
  /** Update the specified items in the gift registry. */
  updateGiftRegistryItems?: Maybe<MagentoApiUpdateGiftRegistryItemsOutput>;
  /** Modify the properties of one or more gift registry registrants. */
  updateGiftRegistryRegistrants?: Maybe<MagentoApiUpdateGiftRegistryRegistrantsOutput>;
  /** Main entrypoint to update payment methods */
  updatePaymentMethod?: Maybe<MagentoApiUpdatePaymentOutput>;
  /** Update one or more products in the specified wish list. */
  updateProductsInWishlist?: Maybe<MagentoApiUpdateProductsInWishlistOutput>;
  /** Change the name and visibility of the specified wish list. */
  updateWishlist?: Maybe<MagentoApiUpdateWishlistOutput>;
};

export type MagentoApiMutationAddBundleProductsToCartArgs = {
  input?: InputMaybe<MagentoApiAddBundleProductsToCartInput>;
};

export type MagentoApiMutationAddConfigurableProductsToCartArgs = {
  input?: InputMaybe<MagentoApiAddConfigurableProductsToCartInput>;
};

export type MagentoApiMutationAddCouponToCartArgs = {
  input?: InputMaybe<MagentoApiAddCouponToCartInput>;
};

export type MagentoApiMutationAddDownloadableProductsToCartArgs = {
  input?: InputMaybe<MagentoApiAddDownloadableProductsToCartInput>;
};

export type MagentoApiMutationAddGiftRegistryRegistrantsArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  registrants: Array<MagentoApiAddGiftRegistryRegistrantInput>;
};

export type MagentoApiMutationAddProductsToCartArgs = {
  cartId: Scalars["String"]["input"];
  cartItems: Array<MagentoApiCartItemInput>;
};

export type MagentoApiMutationAddProductsToCompareListArgs = {
  input?: InputMaybe<MagentoApiAddProductsToCompareListInput>;
};

export type MagentoApiMutationAddProductsToNewCartArgs = {
  cartItems: Array<MagentoApiCartItemInput>;
};

export type MagentoApiMutationAddProductsToWishlistArgs = {
  wishlistId: Scalars["ID"]["input"];
  wishlistItems: Array<MagentoApiWishlistItemInput>;
};

export type MagentoApiMutationAddReturnCommentArgs = {
  input: MagentoApiAddReturnCommentInput;
};

export type MagentoApiMutationAddReturnTrackingArgs = {
  input: MagentoApiAddReturnTrackingInput;
};

export type MagentoApiMutationAddSimpleProductsToCartArgs = {
  input?: InputMaybe<MagentoApiAddSimpleProductsToCartInput>;
};

export type MagentoApiMutationAddVirtualProductsToCartArgs = {
  input?: InputMaybe<MagentoApiAddVirtualProductsToCartInput>;
};

export type MagentoApiMutationAddWishlistItemsToCartArgs = {
  wishlistId: Scalars["ID"]["input"];
  wishlistItemIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MagentoApiMutationApplyCampaignToCartArgs = {
  input?: InputMaybe<MagentoApiApplyCampaignToCartInput>;
};

export type MagentoApiMutationApplyCouponToCartArgs = {
  input?: InputMaybe<MagentoApiApplyCouponToCartInput>;
};

export type MagentoApiMutationApplyCouponsToCartArgs = {
  input?: InputMaybe<MagentoApiApplyCouponsToCartInput>;
};

export type MagentoApiMutationApplyGiftCardToCartArgs = {
  input?: InputMaybe<MagentoApiApplyGiftCardToCartInput>;
};

export type MagentoApiMutationApplyRewardPointsToCartArgs = {
  cartId: Scalars["ID"]["input"];
};

export type MagentoApiMutationApplyStoreCreditToCartArgs = {
  input: MagentoApiApplyStoreCreditToCartInput;
};

export type MagentoApiMutationAssignCompareListToCustomerArgs = {
  uid: Scalars["ID"]["input"];
};

export type MagentoApiMutationAssignCustomerToGuestCartArgs = {
  cart_id: Scalars["String"]["input"];
};

export type MagentoApiMutationBackinstockSubscribeArgs = {
  productId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MagentoApiMutationCancelOrderArgs = {
  input: MagentoApiCancelOrderInput;
};

export type MagentoApiMutationCancelorderArgs = {
  orderId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MagentoApiMutationCartCanApplyCouponsArgs = {
  input?: InputMaybe<MagentoApiCanApplyCouponsInput>;
};

export type MagentoApiMutationChangeCustomerPasswordArgs = {
  currentPassword: Scalars["String"]["input"];
  newPassword: Scalars["String"]["input"];
};

export type MagentoApiMutationClearCartArgs = {
  input: MagentoApiClearCartInput;
};

export type MagentoApiMutationCompleteOrderArgs = {
  input?: InputMaybe<MagentoApiCompleteOrderInput>;
};

export type MagentoApiMutationConfirmCancelOrderArgs = {
  input: MagentoApiConfirmCancelOrderInput;
};

export type MagentoApiMutationConfirmEmailArgs = {
  input: MagentoApiConfirmEmailInput;
};

export type MagentoApiMutationConfirmReturnArgs = {
  input: MagentoApiConfirmReturnInput;
};

export type MagentoApiMutationContactUsArgs = {
  input: MagentoApiContactUsInput;
};

export type MagentoApiMutationCopyProductsBetweenWishlistsArgs = {
  destinationWishlistUid: Scalars["ID"]["input"];
  sourceWishlistUid: Scalars["ID"]["input"];
  wishlistItems: Array<MagentoApiWishlistItemCopyInput>;
};

export type MagentoApiMutationCreateCompareListArgs = {
  input?: InputMaybe<MagentoApiCreateCompareListInput>;
};

export type MagentoApiMutationCreateCustomerArgs = {
  input: MagentoApiCustomerInput;
};

export type MagentoApiMutationCreateCustomerAddressArgs = {
  input: MagentoApiCustomerAddressInput;
};

export type MagentoApiMutationCreateCustomerV2Args = {
  input: MagentoApiCustomerCreateInput;
};

export type MagentoApiMutationCreateEmptyCartArgs = {
  input?: InputMaybe<MagentoApiCreateEmptyCartInput>;
};

export type MagentoApiMutationCreateGiftRegistryArgs = {
  giftRegistry: MagentoApiCreateGiftRegistryInput;
};

export type MagentoApiMutationCreateGuestCartArgs = {
  input?: InputMaybe<MagentoApiCreateGuestCartInput>;
};

export type MagentoApiMutationCreatePayflowProTokenArgs = {
  input: MagentoApiPayflowProTokenInput;
};

export type MagentoApiMutationCreatePaymentOrderArgs = {
  input: MagentoApiCreatePaymentOrderInput;
};

export type MagentoApiMutationCreatePaypalExpressTokenArgs = {
  input: MagentoApiPaypalExpressTokenInput;
};

export type MagentoApiMutationCreateProductReviewArgs = {
  input: MagentoApiCreateProductReviewInput;
};

export type MagentoApiMutationCreateVaultCardPaymentTokenArgs = {
  input: MagentoApiCreateVaultCardPaymentTokenInput;
};

export type MagentoApiMutationCreateVaultCardSetupTokenArgs = {
  input: MagentoApiCreateVaultCardSetupTokenInput;
};

export type MagentoApiMutationCreateWishlistArgs = {
  input: MagentoApiCreateWishlistInput;
};

export type MagentoApiMutationDeleteCompareListArgs = {
  uid: Scalars["ID"]["input"];
};

export type MagentoApiMutationDeleteCustomerAddressArgs = {
  id: Scalars["Int"]["input"];
};

export type MagentoApiMutationDeletePaymentTokenArgs = {
  public_hash: Scalars["String"]["input"];
};

export type MagentoApiMutationDeleteWishlistArgs = {
  wishlistId: Scalars["ID"]["input"];
};

export type MagentoApiMutationEstimateShippingMethodsArgs = {
  input: MagentoApiEstimateTotalsInput;
};

export type MagentoApiMutationEstimateTotalsArgs = {
  input: MagentoApiEstimateTotalsInput;
};

export type MagentoApiMutationGenerateCustomerTokenArgs = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type MagentoApiMutationGenerateCustomerTokenAsAdminArgs = {
  input: MagentoApiGenerateCustomerTokenAsAdminInput;
};

export type MagentoApiMutationHandlePayflowProResponseArgs = {
  input: MagentoApiPayflowProResponseInput;
};

export type MagentoApiMutationMergeCartsArgs = {
  destination_cart_id?: InputMaybe<Scalars["String"]["input"]>;
  source_cart_id: Scalars["String"]["input"];
};

export type MagentoApiMutationMoveCartItemsToGiftRegistryArgs = {
  cartUid: Scalars["ID"]["input"];
  giftRegistryUid: Scalars["ID"]["input"];
};

export type MagentoApiMutationMoveProductsBetweenWishlistsArgs = {
  destinationWishlistUid: Scalars["ID"]["input"];
  sourceWishlistUid: Scalars["ID"]["input"];
  wishlistItems: Array<MagentoApiWishlistItemMoveInput>;
};

export type MagentoApiMutationPlaceOrderArgs = {
  input?: InputMaybe<MagentoApiPlaceOrderInput>;
};

export type MagentoApiMutationRedeemGiftCardBalanceAsStoreCreditArgs = {
  input: MagentoApiGiftCardAccountInput;
};

export type MagentoApiMutationRemoveCampaignFromCartArgs = {
  input?: InputMaybe<MagentoApiRemoveCampaignFromCartInput>;
};

export type MagentoApiMutationRemoveCouponFromCartArgs = {
  input?: InputMaybe<MagentoApiRemoveCouponFromCartInput>;
};

export type MagentoApiMutationRemoveCouponsFromCartArgs = {
  input?: InputMaybe<MagentoApiRemoveCouponsFromCartInput>;
};

export type MagentoApiMutationRemoveGiftCardFromCartArgs = {
  input?: InputMaybe<MagentoApiRemoveGiftCardFromCartInput>;
};

export type MagentoApiMutationRemoveGiftRegistryArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
};

export type MagentoApiMutationRemoveGiftRegistryItemsArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  itemsUid: Array<Scalars["ID"]["input"]>;
};

export type MagentoApiMutationRemoveGiftRegistryRegistrantsArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  registrantsUid: Array<Scalars["ID"]["input"]>;
};

export type MagentoApiMutationRemoveItemFromCartArgs = {
  input?: InputMaybe<MagentoApiRemoveItemFromCartInput>;
};

export type MagentoApiMutationRemoveProductsFromCompareListArgs = {
  input?: InputMaybe<MagentoApiRemoveProductsFromCompareListInput>;
};

export type MagentoApiMutationRemoveProductsFromWishlistArgs = {
  wishlistId: Scalars["ID"]["input"];
  wishlistItemsIds: Array<Scalars["ID"]["input"]>;
};

export type MagentoApiMutationRemoveReturnTrackingArgs = {
  input: MagentoApiRemoveReturnTrackingInput;
};

export type MagentoApiMutationRemoveRewardPointsFromCartArgs = {
  cartId: Scalars["ID"]["input"];
};

export type MagentoApiMutationRemoveStoreCreditFromCartArgs = {
  input: MagentoApiRemoveStoreCreditFromCartInput;
};

export type MagentoApiMutationReorderItemsArgs = {
  orderNumber: Scalars["String"]["input"];
};

export type MagentoApiMutationRequestGuestOrderCancelArgs = {
  input: MagentoApiGuestOrderCancelInput;
};

export type MagentoApiMutationRequestGuestReturnArgs = {
  input: MagentoApiRequestGuestReturnInput;
};

export type MagentoApiMutationRequestPasswordResetEmailArgs = {
  email: Scalars["String"]["input"];
};

export type MagentoApiMutationRequestReturnArgs = {
  input: MagentoApiRequestReturnInput;
};

export type MagentoApiMutationResendConfirmationEmailArgs = {
  email: Scalars["String"]["input"];
};

export type MagentoApiMutationResetPasswordArgs = {
  email: Scalars["String"]["input"];
  newPassword: Scalars["String"]["input"];
  resetPasswordToken: Scalars["String"]["input"];
};

export type MagentoApiMutationSendEmailToFriendArgs = {
  input?: InputMaybe<MagentoApiSendEmailToFriendInput>;
};

export type MagentoApiMutationSetAdditionalAttributesArgs = {
  input: MagentoApiSetAdditionalAttributesInput;
};

export type MagentoApiMutationSetBillingAddressOnCartArgs = {
  input?: InputMaybe<MagentoApiSetBillingAddressOnCartInput>;
};

export type MagentoApiMutationSetCartAsInactiveArgs = {
  cartId: Scalars["String"]["input"];
};

export type MagentoApiMutationSetGiftOptionsOnCartArgs = {
  input?: InputMaybe<MagentoApiSetGiftOptionsOnCartInput>;
};

export type MagentoApiMutationSetGuestEmailOnCartArgs = {
  input?: InputMaybe<MagentoApiSetGuestEmailOnCartInput>;
};

export type MagentoApiMutationSetPaymentMethodAndPlaceOrderArgs = {
  input?: InputMaybe<MagentoApiSetPaymentMethodAndPlaceOrderInput>;
};

export type MagentoApiMutationSetPaymentMethodOnCartArgs = {
  input?: InputMaybe<MagentoApiSetPaymentMethodOnCartInput>;
};

export type MagentoApiMutationSetShippingAddressesOnCartArgs = {
  input?: InputMaybe<MagentoApiSetShippingAddressesOnCartInput>;
};

export type MagentoApiMutationSetShippingMethodsOnCartArgs = {
  input?: InputMaybe<MagentoApiSetShippingMethodsOnCartInput>;
};

export type MagentoApiMutationShareGiftRegistryArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  invitees: Array<MagentoApiShareGiftRegistryInviteeInput>;
  sender: MagentoApiShareGiftRegistrySenderInput;
};

export type MagentoApiMutationSubscribeEmailToNewsletterArgs = {
  email: Scalars["String"]["input"];
};

export type MagentoApiMutationSyncPaymentOrderArgs = {
  input?: InputMaybe<MagentoApiSyncPaymentOrderInput>;
};

export type MagentoApiMutationTrackViewedProductArgs = {
  sku: Scalars["String"]["input"];
};

export type MagentoApiMutationUpdateCartItemsArgs = {
  input?: InputMaybe<MagentoApiUpdateCartItemsInput>;
};

export type MagentoApiMutationUpdateCustomerArgs = {
  input: MagentoApiCustomerInput;
};

export type MagentoApiMutationUpdateCustomerAddressArgs = {
  id: Scalars["Int"]["input"];
  input?: InputMaybe<MagentoApiCustomerAddressInput>;
};

export type MagentoApiMutationUpdateCustomerEmailArgs = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type MagentoApiMutationUpdateCustomerV2Args = {
  input: MagentoApiCustomerUpdateInput;
};

export type MagentoApiMutationUpdateGiftRegistryArgs = {
  giftRegistry: MagentoApiUpdateGiftRegistryInput;
  giftRegistryUid: Scalars["ID"]["input"];
};

export type MagentoApiMutationUpdateGiftRegistryItemsArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  items: Array<MagentoApiUpdateGiftRegistryItemInput>;
};

export type MagentoApiMutationUpdateGiftRegistryRegistrantsArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  registrants: Array<MagentoApiUpdateGiftRegistryRegistrantInput>;
};

export type MagentoApiMutationUpdatePaymentMethodArgs = {
  input: MagentoApiUpdatePaymentInput;
};

export type MagentoApiMutationUpdateProductsInWishlistArgs = {
  wishlistId: Scalars["ID"]["input"];
  wishlistItems: Array<MagentoApiWishlistItemUpdateInput>;
};

export type MagentoApiMutationUpdateWishlistArgs = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  visibility?: InputMaybe<MagentoApiWishlistVisibilityEnum>;
  wishlistId: Scalars["ID"]["input"];
};

/** Contains an error message when an invalid UID was specified. */
export type MagentoApiNoSuchEntityUidError = MagentoApiErrorInterface & {
  __typename: "NoSuchEntityUidError";
  /** The returned error message. */
  message: Scalars["String"]["output"];
  /** The specified invalid unique ID of an object. */
  uid: Scalars["ID"]["output"];
};

/** Contains the order ID. */
export type MagentoApiOrder = {
  __typename: "Order";
  entity_id: Scalars["String"]["output"];
  /** @deprecated Use `order_number` instead. */
  order_id?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for an `Order` object. */
  order_number: Scalars["String"]["output"];
};

/** The list of available order actions. */
export type MagentoApiOrderActionType = "CANCEL" | "REORDER" | "RETURN";

/** Contains detailed information about an order's billing and shipping addresses. */
export type MagentoApiOrderAddress = {
  __typename: "OrderAddress";
  /** Administrative area level 2 */
  administrative_area_level_2?: Maybe<Scalars["String"]["output"]>;
  /** Building Number */
  building_number?: Maybe<Scalars["String"]["output"]>;
  /** The city or town. */
  city: Scalars["String"]["output"];
  /** The customer's company. */
  company?: Maybe<Scalars["String"]["output"]>;
  /** The customer's country. */
  country_code?: Maybe<MagentoApiCountryCodeEnum>;
  /** Custom attributes assigned to the customer address. */
  custom_attributesV2: Array<Maybe<MagentoApiAttributeValueInterface>>;
  /** District */
  district?: Maybe<Scalars["String"]["output"]>;
  /** The fax number. */
  fax?: Maybe<Scalars["String"]["output"]>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname?: Maybe<Scalars["String"]["output"]>;
  /** Apartment, floor, building, etc. */
  house_details?: Maybe<Scalars["String"]["output"]>;
  /** States if the selected address is a pickup address */
  is_pickup_address?: Maybe<Scalars["Boolean"]["output"]>;
  /** Landmark */
  landmark?: Maybe<Scalars["String"]["output"]>;
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Scalars["String"]["output"];
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars["String"]["output"]>;
  /** Neighborhood */
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  /** JSON encoded string of required fields like store id etc for the pickup point */
  pickup_information?: Maybe<Scalars["String"]["output"]>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars["String"]["output"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars["String"]["output"]>;
  /** Premise */
  premise?: Maybe<Scalars["String"]["output"]>;
  /** The state or province name. */
  region?: Maybe<Scalars["String"]["output"]>;
  /** The region code resolved from region_id. */
  region_code?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `Region` object of a pre-defined region. */
  region_id?: Maybe<Scalars["ID"]["output"]>;
  /** Short National Address */
  short_address?: Maybe<Scalars["String"]["output"]>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars["String"]["output"]>>;
  /** Street number */
  street_nr?: Maybe<Scalars["String"]["output"]>;
  /** Sublocality level 2 */
  sublocality_level_2?: Maybe<Scalars["String"]["output"]>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars["String"]["output"]>;
  /** The telephone number. */
  telephone?: Maybe<Scalars["String"]["output"]>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars["String"]["output"]>;
};

/** Contains detailed information about an order's billing and shipping addresses. */
export type MagentoApiOrderAddressCustom_AttributesV2Args = {
  attributeCodes?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MagentoApiOrderAttribute = {
  __typename: "OrderAttribute";
  /** Attribute code */
  code: Scalars["String"]["output"];
  /** Any valid data type text, numeric, boolean etc, see OrderDataTypeEnum */
  data_type: MagentoApiOrderDataTypeEnum;
  /** Attribute description */
  description: Scalars["String"]["output"];
  /** Any valid input html type checkbox, select, radio etc, see OrderInputTypeEnum */
  input_type: MagentoApiOrderInputTypeEnum;
  is_required: Scalars["Boolean"]["output"];
  /** Attribute label */
  label: Scalars["String"]["output"];
  /** Max Value Length */
  max_length: Scalars["Int"]["output"];
  /** Min Value Length */
  min_length: Scalars["Int"]["output"];
  /** Attribute placeholder */
  placeholder: Scalars["String"]["output"];
  /** Placement of input */
  placement: Scalars["String"]["output"];
  /** Order of input */
  sort_order: Scalars["Int"]["output"];
  /** Validate Regex */
  validate_regex: Scalars["String"]["output"];
  /** Default Attribute Value */
  value: Scalars["String"]["output"];
};

/** Specifies the attribute code and value of an order attribute. */
export type MagentoApiOrderAttributeInput = {
  /** The name assigned to the attribute. */
  attribute_code?: InputMaybe<Scalars["String"]["input"]>;
  /** The value assigned to the attribute. */
  value: Scalars["String"]["input"];
};

/** Specifies the attribute code and value of an order attribute. */
export type MagentoApiOrderAttributeOutput = {
  __typename: "OrderAttributeOutput";
  /** The name of the attribute. */
  attribute_code?: Maybe<Scalars["String"]["output"]>;
  /** The value of the attribute. */
  value?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiOrderCustomerInfo = {
  __typename: "OrderCustomerInfo";
  /** First name of the customer */
  firstname: Scalars["String"]["output"];
  /** Last name of the customer */
  lastname?: Maybe<Scalars["String"]["output"]>;
  /** Middle name of the customer */
  middlename?: Maybe<Scalars["String"]["output"]>;
  /** Prefix of the customer */
  prefix?: Maybe<Scalars["String"]["output"]>;
  /** Suffix of the customer */
  suffix?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiOrderDataTypeEnum = "int" | "text";

/** Input to retrieve an order based on details. */
export type MagentoApiOrderInformationInput = {
  /** Order billing address email. */
  email: Scalars["String"]["input"];
  /** Order billing address lastname. */
  lastname: Scalars["String"]["input"];
  /** Order number. */
  number: Scalars["String"]["input"];
};

export type MagentoApiOrderInputTypeEnum = "checkbox" | "multiselect" | "radio" | "select" | "text" | "textarea";

export type MagentoApiOrderItem = MagentoApiOrderItemInterface & {
  __typename: "OrderItem";
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return?: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: MagentoApiMoney;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<MagentoApiProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription?: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested?: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: MagentoApiMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: MagentoApiMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Order item details. */
export type MagentoApiOrderItemInterface = {
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return?: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: MagentoApiMoney;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<MagentoApiProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: MagentoApiMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription?: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested?: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: MagentoApiMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: MagentoApiMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<MagentoApiOrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Represents order item options like selected or entered. */
export type MagentoApiOrderItemOption = {
  __typename: "OrderItemOption";
  /** The name of the option. */
  label: Scalars["String"]["output"];
  /** The value of the option. */
  value: Scalars["String"]["output"];
};

export type MagentoApiOrderItemPrices = {
  __typename: "OrderItemPrices";
  /** An array of discounts to be applied to the cart item. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  fixed_product_taxes: Array<Maybe<MagentoApiFixedProductTax>>;
  /** The original price of the item. */
  original_price?: Maybe<MagentoApiMoney>;
  /** The original price of the item including tax. */
  original_price_including_tax?: Maybe<MagentoApiMoney>;
  /** The value of the original price multiplied by the quantity of the item. */
  original_row_total: MagentoApiMoney;
  /** The value of the original price multiplied by the quantity of the item including tax. */
  original_row_total_including_tax: MagentoApiMoney;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: MagentoApiMoney;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price_including_tax: MagentoApiMoney;
  /** The value of the price multiplied by the quantity of the item. */
  row_total: MagentoApiMoney;
  /** The value of `row_total` plus the tax applied to the item. */
  row_total_including_tax: MagentoApiMoney;
  /** The total of all discounts applied to the item. */
  total_item_discount: MagentoApiMoney;
};

/** Contains details about the payment method used to pay for the order. */
export type MagentoApiOrderPaymentMethod = {
  __typename: "OrderPaymentMethod";
  /** Additional data per payment method type. */
  additional_data?: Maybe<Array<Maybe<MagentoApiKeyValue>>>;
  /** Payment method code. */
  method_code: Scalars["String"]["output"];
  /** The label that describes the payment method. */
  name: Scalars["String"]["output"];
  /** The payment method code that indicates how the order was paid for. */
  type: Scalars["String"]["output"];
};

/** Contains order shipment details. */
export type MagentoApiOrderShipment = {
  __typename: "OrderShipment";
  /** Comments added to the shipment. */
  comments?: Maybe<Array<Maybe<MagentoApiSalesCommentItem>>>;
  /** The unique ID for a `OrderShipment` object. */
  id: Scalars["ID"]["output"];
  /** An array of items included in the shipment. */
  items?: Maybe<Array<Maybe<MagentoApiShipmentItemInterface>>>;
  /** The sequential credit shipment number. */
  number: Scalars["String"]["output"];
  /** An array of shipment tracking details. */
  tracking?: Maybe<Array<Maybe<MagentoApiShipmentTracking>>>;
};

export type MagentoApiOrderStatusReason = {
  __typename: "OrderStatusReason";
  /** Is order cancelled by user */
  cancelled_by_user?: Maybe<Scalars["Boolean"]["output"]>;
  /** Time when reason was added */
  created_at: Scalars["String"]["output"];
  /** Unique reason id */
  entity_id: Scalars["Int"]["output"];
  /** Order for which reason was added */
  order_id: Scalars["Int"]["output"];
  /** Order status reason code */
  reason_code: Scalars["String"]["output"];
  /** Order status reason description */
  reason_description?: Maybe<Scalars["String"]["output"]>;
  /** Order status for which reason was added */
  status: Scalars["String"]["output"];
};

/** Input to retrieve an order based on token. */
export type MagentoApiOrderTokenInput = {
  /** Order token. */
  token: Scalars["String"]["input"];
};

/** Contains details about the sales total amounts used to calculate the final price. */
export type MagentoApiOrderTotal = {
  __typename: "OrderTotal";
  /** The final base grand total amount in the base currency. */
  base_grand_total: MagentoApiMoney;
  /** The applied discounts to the order. */
  discounts?: Maybe<Array<Maybe<MagentoApiDiscount>>>;
  gift_options?: Maybe<MagentoApiGiftOptionsPrices>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: MagentoApiMoney;
  /** Details about the shipping and handling costs for the order. */
  shipping_handling?: Maybe<MagentoApiShippingHandling>;
  /**
   * The subtotal of the order, excluding shipping, discounts, and taxes.
   * @deprecated Use subtotal_excl_tax field instead
   */
  subtotal: MagentoApiMoney;
  /** The subtotal of the order, excluding taxes. */
  subtotal_excl_tax: MagentoApiMoney;
  /** Subtotal incl tax */
  subtotal_incl_tax: MagentoApiMoney;
  /** The order tax details. */
  taxes?: Maybe<Array<Maybe<MagentoApiTaxItem>>>;
  /** Total remained to refund */
  total_after_refund: MagentoApiMoney;
  /** The gift card balance applied to the order. */
  total_giftcard?: Maybe<MagentoApiMoney>;
  /** Total paid */
  total_paid: MagentoApiMoney;
  /** Refunded total amount */
  total_refunded: MagentoApiMoney;
  /** The total reward points applied to the order. */
  total_reward_points?: Maybe<MagentoApiMoney>;
  /** The shipping amount for the order. */
  total_shipping: MagentoApiMoney;
  /** The total store credit applied to the order. */
  total_store_credit?: Maybe<MagentoApiMoney>;
  /** The amount of tax applied to the order. */
  total_tax: MagentoApiMoney;
};

export type MagentoApiOrderTypeEnum = "REGULAR" | "TRIAL";

export type MagentoApiPackagingFormat = {
  __typename: "PackagingFormat";
  brandId: Scalars["ID"]["output"];
  contentsType: Scalars["String"]["output"];
  formatQuantity: Scalars["Int"]["output"];
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  itemsPerPackage: Scalars["Int"]["output"];
  label: Scalars["String"]["output"];
  packagesPerBundle: Scalars["Int"]["output"];
  productTypeName: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
};

/** Contains required input for Payflow Express Checkout payments. */
export type MagentoApiPayflowExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars["String"]["input"];
  /** The token returned by the createPaypalExpressToken mutation. */
  token: Scalars["String"]["input"];
};

/** A set of relative URLs that PayPal uses in response to various actions during the authorization process. Adobe Commerce prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payflow Link and Payments Advanced payment methods. */
export type MagentoApiPayflowLinkInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars["String"]["input"];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars["String"]["input"];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars["String"]["input"];
};

/** Indicates the mode for payment. Applies to the Payflow Link and Payments Advanced payment methods. */
export type MagentoApiPayflowLinkMode = "LIVE" | "TEST";

/** Contains information used to generate PayPal iframe for transaction. Applies to Payflow Link and Payments Advanced payment methods. */
export type MagentoApiPayflowLinkToken = {
  __typename: "PayflowLinkToken";
  /** The mode for the Payflow transaction. */
  mode?: Maybe<MagentoApiPayflowLinkMode>;
  /** The PayPal URL used for requesting a Payflow form. */
  paypal_url?: Maybe<Scalars["String"]["output"]>;
  /** The secure token generated by PayPal. */
  secure_token?: Maybe<Scalars["String"]["output"]>;
  /** The secure token ID generated by PayPal. */
  secure_token_id?: Maybe<Scalars["String"]["output"]>;
};

/** Contains information required to fetch payment token information for the Payflow Link and Payments Advanced payment methods. */
export type MagentoApiPayflowLinkTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
};

/** Contains input for the Payflow Pro and Payments Pro payment methods. */
export type MagentoApiPayflowProInput = {
  /** Required input for credit card related information. */
  cc_details: MagentoApiCreditCardDetailsInput;
  /** Indicates whether details about the shopper's credit/debit card should be tokenized for later usage. Required only if Vault is enabled for the PayPal Payflow Pro payment integration. */
  is_active_payment_token_enabler?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input required to complete payment. Applies to Payflow Pro and Payments Pro payment methods. */
export type MagentoApiPayflowProResponseInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars["String"]["input"];
  /** The payload returned from PayPal. */
  paypal_payload: Scalars["String"]["input"];
};

export type MagentoApiPayflowProResponseOutput = {
  __typename: "PayflowProResponseOutput";
  /** The cart with the updated selected payment method. */
  cart: MagentoApiCart;
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type MagentoApiPayflowProToken = {
  __typename: "PayflowProToken";
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars["String"]["output"];
  /** A non-zero value if any errors occurred. */
  result: Scalars["Int"]["output"];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars["Int"]["output"];
  /** A secure token generated by PayPal. */
  secure_token: Scalars["String"]["output"];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars["String"]["output"];
};

/** Contains input required to fetch payment token information for the Payflow Pro and Payments Pro payment methods. */
export type MagentoApiPayflowProTokenInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars["String"]["input"];
  /** A set of relative URLs that PayPal uses for callback. */
  urls: MagentoApiPayflowProUrlInput;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for the Payflow Pro and Payment Pro payment methods. */
export type MagentoApiPayflowProUrlInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars["String"]["input"];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars["String"]["input"];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars["String"]["input"];
};

export type MagentoApiPaymentCommonConfig = MagentoApiPaymentConfigItem & {
  __typename: "PaymentCommonConfig";
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<MagentoApiSdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars["String"]["output"]>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Contains payment fields that are common to all types of payment methods. */
export type MagentoApiPaymentConfigItem = {
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<MagentoApiSdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars["String"]["output"]>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Retrieves the payment configuration for a given location */
export type MagentoApiPaymentConfigOutput = {
  __typename: "PaymentConfigOutput";
  /** ApplePay payment method configuration */
  apple_pay?: Maybe<MagentoApiApplePayConfig>;
  /** Fastlane payment method configuration */
  fastlane?: Maybe<MagentoApiFastlaneConfig>;
  /** GooglePay payment method configuration */
  google_pay?: Maybe<MagentoApiGooglePayConfig>;
  /** Hosted fields payment method configuration */
  hosted_fields?: Maybe<MagentoApiHostedFieldsConfig>;
  /** Smart Buttons payment method configuration */
  smart_buttons?: Maybe<MagentoApiSmartButtonsConfig>;
};

/** Defines the origin location for that payment request */
export type MagentoApiPaymentLocation =
  "ADMIN" | "CART" | "CHECKOUT" | "MINICART" | "PRODUCT_DETAIL" | "START_OF_CHECKOUT";

/** Defines the payment method. */
export type MagentoApiPaymentMethodInput = {
  /** The internal name for the payment method. */
  code: Scalars["String"]["input"];
  /** Required input for PayPal Hosted pro payments. */
  hosted_pro?: InputMaybe<MagentoApiHostedProInput>;
  /** Required input for Payflow Express Checkout payments. */
  payflow_express?: InputMaybe<MagentoApiPayflowExpressInput>;
  /** Required input for PayPal Payflow Link and Payments Advanced payments. */
  payflow_link?: InputMaybe<MagentoApiPayflowLinkInput>;
  /** Required input for PayPal Payflow Pro and Payment Pro payments. */
  payflowpro?: InputMaybe<MagentoApiPayflowProInput>;
  /** Required input for PayPal Payflow Pro vault payments. */
  payflowpro_cc_vault?: InputMaybe<MagentoApiVaultTokenInput>;
  /** Required input for Apple Pay button */
  payment_services_paypal_apple_pay?: InputMaybe<MagentoApiApplePayMethodInput>;
  /** Required input for fastlane */
  payment_services_paypal_fastlane?: InputMaybe<MagentoApiFastlaneMethodInput>;
  /** Required input for Google Pay button */
  payment_services_paypal_google_pay?: InputMaybe<MagentoApiGooglePayMethodInput>;
  /** Required input for Hosted Fields */
  payment_services_paypal_hosted_fields?: InputMaybe<MagentoApiHostedFieldsInput>;
  /** Required input for Smart buttons */
  payment_services_paypal_smart_buttons?: InputMaybe<MagentoApiSmartButtonMethodInput>;
  /** Required input for vault */
  payment_services_paypal_vault?: InputMaybe<MagentoApiVaultMethodInput>;
  /** Required input for Express Checkout and Payments Standard payments. */
  paypal_express?: InputMaybe<MagentoApiPaypalExpressInput>;
  /** The purchase order number. Optional for most payment methods. */
  purchase_order_number?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains the payment order details */
export type MagentoApiPaymentOrderOutput = {
  __typename: "PaymentOrderOutput";
  /** PayPal order ID */
  id?: Maybe<Scalars["String"]["output"]>;
  /** The order ID generated by Payment Services */
  mp_order_id?: Maybe<Scalars["String"]["output"]>;
  /** Details about the card used on the order */
  payment_source_details?: Maybe<MagentoApiPaymentSourceDetails>;
  /** The status of the payment order */
  status?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiPaymentSdkParamsItem = {
  __typename: "PaymentSDKParamsItem";
  /** The payment method code used in the order */
  code?: Maybe<Scalars["String"]["output"]>;
  /** The payment SDK parameters */
  params?: Maybe<Array<Maybe<MagentoApiSdkParams>>>;
};

export type MagentoApiPaymentSourceDetails = {
  __typename: "PaymentSourceDetails";
  /** Details about the card used on the order */
  card?: Maybe<MagentoApiCard>;
};

/** The payment source information */
export type MagentoApiPaymentSourceInput = {
  /** The card payment source information */
  card: MagentoApiCardPaymentSourceInput;
};

/** The payment source information */
export type MagentoApiPaymentSourceOutput = {
  __typename: "PaymentSourceOutput";
  /** The card payment source information */
  card: MagentoApiCardPaymentSourceOutput;
};

/** The stored payment method available to the customer. */
export type MagentoApiPaymentToken = {
  __typename: "PaymentToken";
  /** A description of the stored account details. */
  details?: Maybe<Scalars["String"]["output"]>;
  /** The payment method code associated with the token. */
  payment_method_code: Scalars["String"]["output"];
  /** The public hash of the token. */
  public_hash: Scalars["String"]["output"];
  /** Specifies the payment token type. */
  type: MagentoApiPaymentTokenTypeEnum;
};

/** The list of available payment token types. */
export type MagentoApiPaymentTokenTypeEnum =
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  | "account"
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  | "card";

/** Contains required input for Express Checkout and Payments Standard payments. */
export type MagentoApiPaypalExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars["String"]["input"];
  /** The token returned by the `createPaypalExpressToken` mutation. */
  token: Scalars["String"]["input"];
};

/** Deprecated. Use `PaypalExpressTokenOutput` instead. */
export type MagentoApiPaypalExpressToken = {
  __typename: "PaypalExpressToken";
  /**
   * A set of URLs that allow the buyer to authorize payment and adjust checkout details.
   * @deprecated Use `PaypalExpressTokenOutput.paypal_urls` instead.
   */
  paypal_urls?: Maybe<MagentoApiPaypalExpressUrlList>;
  /**
   * The token returned by PayPal.
   * @deprecated Use `PaypalExpressTokenOutput.token` instead.
   */
  token?: Maybe<Scalars["String"]["output"]>;
};

/** Defines the attributes required to receive a payment token for Express Checkout and Payments Standard payment methods. */
export type MagentoApiPaypalExpressTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
  /** The payment method code. */
  code: Scalars["String"]["input"];
  /** Indicates whether the buyer selected the quick checkout button. The default value is false. */
  express_button?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** A set of relative URLs that PayPal uses in response to various actions during the authorization process. */
  urls: MagentoApiPaypalExpressUrlsInput;
  /** Indicates whether the buyer clicked the PayPal credit button. The default value is false. */
  use_paypal_credit?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Contains the token returned by PayPal and a set of URLs that allow the buyer to authorize payment and adjust checkout details. Applies to Express Checkout and Payments Standard payment methods. */
export type MagentoApiPaypalExpressTokenOutput = {
  __typename: "PaypalExpressTokenOutput";
  /** A set of URLs that allow the buyer to authorize payment and adjust checkout details. */
  paypal_urls?: Maybe<MagentoApiPaypalExpressUrlList>;
  /** The token returned by PayPal. */
  token?: Maybe<Scalars["String"]["output"]>;
};

/** Contains a set of URLs that allow the buyer to authorize payment and adjust checkout details for Express Checkout and Payments Standard transactions. */
export type MagentoApiPaypalExpressUrlList = {
  __typename: "PaypalExpressUrlList";
  /** The PayPal URL that allows the buyer to edit their checkout details. */
  edit?: Maybe<Scalars["String"]["output"]>;
  /** The URL to the PayPal login page. */
  start?: Maybe<Scalars["String"]["output"]>;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Express Checkout and Payments Standard payment methods. */
export type MagentoApiPaypalExpressUrlsInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars["String"]["input"];
  /** The relative URL of the page that PayPal redirects to when the payment has been put on hold for additional review. This condition mostly applies to ACH transactions, and is not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success_pending.html, the relative URL is paypal/action/success_pending.html. */
  pending_url?: InputMaybe<Scalars["String"]["input"]>;
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars["String"]["input"];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. Not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success.html, the relative URL is paypal/action/success.html. */
  success_url?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains attributes specific to tangible products. */
export type MagentoApiPhysicalProductInterface = {
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars["Float"]["output"]>;
};

/** An error encountered while placing an order. */
export type MagentoApiPlaceOrderError = {
  __typename: "PlaceOrderError";
  /** An error code that is specific to place order. */
  code: MagentoApiPlaceOrderErrorCodes;
  /** A localized error message. */
  message: Scalars["String"]["output"];
};

export type MagentoApiPlaceOrderErrorCodes =
  | "CART_NOT_ACTIVE"
  | "CART_NOT_FOUND"
  | "GUEST_EMAIL_MISSING"
  | "SALESRULE_GIFT_NOT_VALID"
  | "UNABLE_TO_PLACE_ORDER"
  | "UNDEFINED";

/** Specifies the quote to be converted to an order. */
export type MagentoApiPlaceOrderInput = {
  /** Order Attributes */
  additional_attributes?: InputMaybe<Array<InputMaybe<MagentoApiOrderAttributeInput>>>;
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
};

/** Contains the results of the request to place an order. */
export type MagentoApiPlaceOrderOutput = {
  __typename: "PlaceOrderOutput";
  /** An array of place order errors. */
  errors: Array<Maybe<MagentoApiPlaceOrderError>>;
  /**
   * The ID of the order.
   * @deprecated Use `orderV2` instead.
   */
  order?: Maybe<MagentoApiOrder>;
  /** Full order information. */
  orderV2?: Maybe<MagentoApiCustomerOrder>;
};

export type MagentoApiPresentationPrices = {
  __typename: "PresentationPrices";
  /** Catalog price */
  initial_price?: Maybe<Scalars["Float"]["output"]>;
  /** Presentation Selection price, if layer is Presentation */
  presentation_price?: Maybe<Scalars["Float"]["output"]>;
  /** Contains details about this product option. */
  product?: Maybe<MagentoApiProductInterface>;
};

/** Deprecated. Use `ProductPrice` instead. Defines the price of a product as well as any tax-related adjustments. */
export type MagentoApiPrice = {
  __typename: "Price";
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Use `ProductPrice` instead.
   */
  adjustments?: Maybe<Array<Maybe<MagentoApiPriceAdjustment>>>;
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Use `ProductPrice` instead.
   */
  amount?: Maybe<MagentoApiMoney>;
};

/** Deprecated. Taxes will be included or excluded in the price. Defines the amount of money to apply as an adjustment, the type of adjustment to apply, and whether the item is included or excluded from the adjustment. */
export type MagentoApiPriceAdjustment = {
  __typename: "PriceAdjustment";
  /** The amount of the price adjustment and its currency code. */
  amount?: Maybe<MagentoApiMoney>;
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  code?: Maybe<MagentoApiPriceAdjustmentCodesEnum>;
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  description?: Maybe<MagentoApiPriceAdjustmentDescriptionEnum>;
};

/** `PriceAdjustment.code` is deprecated. */
export type MagentoApiPriceAdjustmentCodesEnum = "TAX" | "WEEE" | "WEEE_TAX";

/** `PriceAdjustmentDescriptionEnum` is deprecated. States whether a price adjustment is included or excluded. */
export type MagentoApiPriceAdjustmentDescriptionEnum = "EXCLUDED" | "INCLUDED";

/** Can be used to retrieve the main price details in case of bundle product */
export type MagentoApiPriceDetails = {
  __typename: "PriceDetails";
  /** The percentage of discount applied to the main product price */
  discount_percentage?: Maybe<Scalars["Float"]["output"]>;
  /** The final price after applying the discount to the main product */
  main_final_price?: Maybe<Scalars["Float"]["output"]>;
  /** The regular price of the main product */
  main_price?: Maybe<Scalars["Float"]["output"]>;
};

/** Contains the price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export type MagentoApiPriceRange = {
  __typename: "PriceRange";
  /** The highest possible price for the product. */
  maximum_price?: Maybe<MagentoApiProductPrice>;
  /** The lowest possible price for the product. */
  minimum_price: MagentoApiProductPrice;
};

/** Defines the price type. */
export type MagentoApiPriceTypeEnum = "DYNAMIC" | "FIXED" | "PERCENT" | "PRESENTATION";

/** Defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export type MagentoApiPriceViewEnum = "AS_LOW_AS" | "PRICE_RANGE";

export type MagentoApiProduct = {
  __typename: "Product";
  color_label?: Maybe<Scalars["String"]["output"]>;
  flavor_label?: Maybe<Scalars["String"]["output"]>;
};

/** Contains a product attribute code and value. */
export type MagentoApiProductAttribute = {
  __typename: "ProductAttribute";
  /** The unique identifier for a product attribute code. */
  code: Scalars["String"]["output"];
  /** The display value of the attribute. */
  value: Scalars["String"]["output"];
};

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type MagentoApiProductAttributeFilterInput = {
  /** Attribute label: available_date */
  available_date?: InputMaybe<MagentoApiFilterRangeTypeInput>;
  /** Attribute label: Available for Mobile App */
  available_for_mobile_app?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Deprecated: use `category_uid` to filter product by category ID. */
  category_id?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Filter product by the unique ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Filter product by category URL path. */
  category_url_path?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Color */
  color?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Description */
  description?: InputMaybe<MagentoApiFilterMatchTypeInput>;
  /** Attribute label: Experience */
  experience?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Flavor */
  flavor?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Flavor Families */
  flavor_family?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Flavour */
  flavour?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Formula */
  formula?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Importer */
  importer?: InputMaybe<MagentoApiFilterMatchTypeInput>;
  /** Attribute label: Main Specifications */
  main_specifications?: InputMaybe<MagentoApiFilterMatchTypeInput>;
  /** Attribute label: Manufacturer */
  manufacturer?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Product Name */
  name?: InputMaybe<MagentoApiFilterMatchTypeInput>;
  /** Attribute label: Name & Model */
  name_and_model?: InputMaybe<MagentoApiFilterMatchTypeInput>;
  /** Attribute label: Portable Stick Tray */
  portable_stick_tray?: InputMaybe<MagentoApiFilterMatchTypeInput>;
  /** Attribute label: Pouch Size */
  pouch_size?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Price */
  price?: InputMaybe<MagentoApiFilterRangeTypeInput>;
  /** Attribute label: Province */
  province?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Region */
  region?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Short Description */
  short_description?: InputMaybe<MagentoApiFilterMatchTypeInput>;
  /** Attribute label: SKU */
  sku?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** Attribute label: Strength */
  strength?: InputMaybe<MagentoApiFilterEqualTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<MagentoApiFilterEqualTypeInput>;
};

/** Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. It's possible to sort products using searchable attributes with enabled 'Use in Filter Options' option */
export type MagentoApiProductAttributeSortInput = {
  /** Attribute label: Color */
  color?: InputMaybe<MagentoApiSortEnum>;
  /** Attribute label: Product Name */
  name?: InputMaybe<MagentoApiSortEnum>;
  /** Sort by the position assigned to each product. */
  position?: InputMaybe<MagentoApiSortEnum>;
  /** Attribute label: Price */
  price?: InputMaybe<MagentoApiSortEnum>;
  /** Sort by the search relevance score (default). */
  relevance?: InputMaybe<MagentoApiSortEnum>;
};

/** Product custom attributes */
export type MagentoApiProductCustomAttributes = {
  __typename: "ProductCustomAttributes";
  /** Errors when retrieving custom attributes metadata. */
  errors: Array<Maybe<MagentoApiAttributeMetadataError>>;
  /** Requested custom attributes */
  items: Array<Maybe<MagentoApiAttributeValueInterface>>;
};

/** Contains the discount applied to a product price. */
export type MagentoApiProductDiscount = {
  __typename: "ProductDiscount";
  /** The actual value of the discount. */
  amount_off?: Maybe<Scalars["Float"]["output"]>;
  /** The discount expressed a percentage. */
  percent_off?: Maybe<Scalars["Float"]["output"]>;
};

/** ProductFilterInput is deprecated, use @ProductAttributeFilterInput instead. ProductFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type MagentoApiProductFilterInput = {
  /** The category ID the product belongs to. */
  category_id?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<MagentoApiFilterTypeInput>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<MagentoApiFilterTypeInput>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<MagentoApiFilterTypeInput>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<MagentoApiFilterTypeInput>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<MagentoApiFilterTypeInput>;
  /** Indicates whether the product can be returned. */
  is_returnable?: InputMaybe<MagentoApiFilterTypeInput>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The numeric maximal price of the product. Do not include the currency code. */
  max_price?: InputMaybe<MagentoApiFilterTypeInput>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<MagentoApiFilterTypeInput>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<MagentoApiFilterTypeInput>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The numeric minimal price of the product. Do not include the currency code. */
  min_price?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<MagentoApiFilterTypeInput>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The keyword required to perform a logical OR comparison. */
  or?: InputMaybe<MagentoApiProductFilterInput>;
  /** The price of an item. */
  price?: InputMaybe<MagentoApiFilterTypeInput>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<MagentoApiFilterTypeInput>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<MagentoApiFilterTypeInput>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The discounted price of the product. Do not include the currency code. */
  special_price?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The file name of a swatch image. */
  swatch_image?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<MagentoApiFilterTypeInput>;
  url_path?: InputMaybe<MagentoApiFilterTypeInput>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<MagentoApiFilterTypeInput>;
};

/** Contains product image information, including the image URL and label. */
export type MagentoApiProductImage = MagentoApiMediaGalleryInterface & {
  __typename: "ProductImage";
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Alt text of the image */
  image_alt?: Maybe<Scalars["String"]["output"]>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** Role of the image */
  role?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Contains product image information, including the image URL and label. */
export type MagentoApiProductImageUrlArgs = {
  dpr?: InputMaybe<Scalars["Int"]["input"]>;
  fit?: InputMaybe<Scalars["String"]["input"]>;
  height?: InputMaybe<Scalars["Int"]["input"]>;
  quality?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["String"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MagentoApiProductImageThumbnail =
  /** Use thumbnail of product as image. */
  | "ITSELF"
  /** Use thumbnail of product's parent as image. */
  | "PARENT";

/** Contains fields that are common to all types of products. */
export type MagentoApiProductInterface = {
  /** @deprecated Use the `custom_attributes` field instead. */
  about_manufacturer?: Maybe<Scalars["String"]["output"]>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  available_date?: Maybe<Scalars["String"]["output"]>;
  /**
   * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
   * @deprecated Use the `custom_attributes` field instead.
   */
  available_for_mobile_app?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  battery?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  buy_cta_pdp?: Maybe<Scalars["Int"]["output"]>;
  /** CTA for PDP attribute translated label . */
  buy_cta_pdp_label: Scalars["String"]["output"];
  /** @deprecated Use the `custom_attributes` field instead. */
  buy_cta_plp?: Maybe<Scalars["Int"]["output"]>;
  /** CTA for PLP attribute translated label . */
  buy_cta_plp_label: Scalars["String"]["output"];
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars["String"]["output"]>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<MagentoApiCategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  charging_time?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars["Int"]["output"]>;
  /** Color attribute label. */
  color_label?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  connectors?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  connectors_1?: Maybe<Scalars["String"]["output"]>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars["String"]["output"]>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars["String"]["output"]>;
  /** An array of cross-sell products. */
  crosssell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
  /** Product custom attributes. */
  custom_attributesV2?: Maybe<MagentoApiProductCustomAttributes>;
  /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
  delivery_region_code?: Maybe<Scalars["String"]["output"]>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<MagentoApiComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  device_dimensions?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  dimensions?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  enable_lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Is quantity limit enabled for this product
   * @deprecated Use the `custom_attributes` field instead.
   */
  enable_order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  experience?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  flavor?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  flavor_family?: Maybe<Scalars["String"]["output"]>;
  /** Color attribute label. */
  flavor_label?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  flavour?: Maybe<Scalars["Int"]["output"]>;
  /** Get all details for flavour */
  flavour_details: Array<Maybe<MagentoApiFlavourDetails>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  formula?: Maybe<Scalars["Int"]["output"]>;
  /** A list of gift options for the given product */
  free_gifts?: Maybe<MagentoApiFreeGiftProductData>;
  /** Returns all attribute values and labels marked as visible on storefront */
  frontend_attributes?: Maybe<Array<Maybe<MagentoApiFrontendAttribute>>>;
  /** Returns a value indicating gift message availability for the product. */
  gift_message_available: Scalars["Boolean"]["output"];
  /** Returns a value indicating gift wrapping availability for the product. */
  gift_wrapping_available: Scalars["Boolean"]["output"];
  /** Returns value and currency indicating gift wrapping price for the product. */
  gift_wrapping_price?: Maybe<MagentoApiMoney>;
  /** @deprecated Use the `custom_attributes` field instead. */
  has_device?: Maybe<Scalars["Int"]["output"]>;
  /** Provides the flag to show if consent is required or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** Product is hidden_sku or not */
  hidden_sku?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<MagentoApiProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  importer?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  input_terminal?: Maybe<Scalars["Int"]["output"]>;
  /** Product discontinued flag */
  is_discontinued?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the product can be returned. */
  is_returnable?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  jti_brand_matrix?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  jti_category_redirect?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  jti_product_discontinued?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  jti_sku_redirect?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  large_stick_tray?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  main_specifications?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mandatory_positive_consent?: Maybe<Scalars["Int"]["output"]>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars["Int"]["output"]>;
  /** Product subscription format */
  manufacturer_label?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  material?: Maybe<Scalars["String"]["output"]>;
  /** Maximum Qty Allowed in Shopping Cart */
  max_sale_qty?: Maybe<Scalars["Float"]["output"]>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MagentoApiMediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MagentoApiMediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars["String"]["output"]>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars["String"]["output"]>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars["String"]["output"]>;
  /** Minimum Qty Allowed in Shopping Cart */
  min_sale_qty?: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  minimum_amount?: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  minimum_amount_type?: Maybe<Scalars["String"]["output"]>;
  /**
   * Multipack description for this product
   * @deprecated Use the `custom_attributes` field instead.
   */
  multipack_description?: Maybe<Scalars["String"]["output"]>;
  /** Is multipacks selected enabled for this product */
  multipack_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Multipack label for this product
   * @deprecated Use the `custom_attributes` field instead.
   */
  multipack_label?: Maybe<Scalars["String"]["output"]>;
  /** Multipack price text for this product */
  multipack_price?: Maybe<Scalars["String"]["output"]>;
  /** Multipack Products */
  multipack_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  multipacks_enabled?: Maybe<Scalars["Int"]["output"]>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  name_and_model?: Maybe<Scalars["String"]["output"]>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars["String"]["output"]>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  non_trade_in_sku?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  number_of_packs?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  number_of_sticks?: Maybe<Scalars["Int"]["output"]>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  option_grouped_by_brand?: Maybe<Scalars["Int"]["output"]>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars["String"]["output"]>;
  /**
   * Maximum quantity allowed per one order
   * @deprecated Use the `custom_attributes` field instead.
   */
  order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  portable_stick_tray?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pouch_size?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<MagentoApiProductPrices>;
  /** The range of prices for the product */
  price_range: MagentoApiPriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<MagentoApiTierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_brand?: Maybe<Scalars["String"]["output"]>;
  /** Product Brand Label */
  product_brand_label?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_category?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_category_type?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_color?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_disclaimer?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_family?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_generation?: Maybe<Scalars["String"]["output"]>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<MagentoApiProductLinksInterface>>>;
  /** Get all special offers for a product. */
  promotionalOffers: Array<Maybe<MagentoApiSpecialOffer>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  province?: Maybe<Scalars["String"]["output"]>;
  /** Product provence label for PLP attribute. */
  province_label?: Maybe<Scalars["String"]["output"]>;
  /** Amount of available stock */
  quantity?: Maybe<Scalars["Float"]["output"]>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars["Float"]["output"];
  /** Redirect category URL path for discontinued product */
  redirect_product_category?: Maybe<Scalars["String"]["output"]>;
  /** Redirect product SKU for discontinued product */
  redirect_sku?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  region?: Maybe<Scalars["Int"]["output"]>;
  /** Product Region attribute translated label. */
  region_label?: Maybe<Scalars["String"]["output"]>;
  /** An array of related products. */
  related_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars["Int"]["output"];
  /** @deprecated Use the `custom_attributes` field instead. */
  review_eligible?: Maybe<Scalars["Int"]["output"]>;
  /** The list of products reviews. */
  reviews: MagentoApiProductReviews;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<MagentoApiComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  size?: Maybe<Scalars["String"]["output"]>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars["String"]["output"]>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<MagentoApiProductImage>;
  /** Get all special offers for a product. */
  specialOffers: Array<Maybe<MagentoApiSpecialOffer>>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars["String"]["output"]>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars["Float"]["output"]>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is staged for a future campaign. */
  staged: Scalars["Boolean"]["output"];
  /** @deprecated Use the `custom_attributes` field instead. */
  stick_capability?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  stick_compatibility?: Maybe<Scalars["String"]["output"]>;
  /** Stock status of the product */
  stock_status?: Maybe<MagentoApiProductStockStatus>;
  /** @deprecated Use the `custom_attributes` field instead. */
  strength?: Maybe<Scalars["Int"]["output"]>;
  /** Get all details for strength */
  strength_details?: Maybe<MagentoApiStrengthDetails>;
  /** @deprecated Use the `custom_attributes` field instead. */
  subscription?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Product subscription format
   * @deprecated Use the `custom_attributes` field instead.
   */
  subscription_format?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  subtitle?: Maybe<Scalars["String"]["output"]>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars["String"]["output"]>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<MagentoApiProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars["Float"]["output"]>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<MagentoApiProductTierPrices>>>;
  /**
   * Product tooltip information
   * @deprecated Use the `custom_attributes` field instead.
   */
  tooltip_info?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  trabka?: Maybe<Scalars["String"]["output"]>;
  /**
   * Indicates whether the product is eligible for a trade-in purchase.
   * @deprecated Use the `custom_attributes` field instead.
   */
  trade_in: Scalars["Int"]["output"];
  /**
   * Specific to trial stores, provides information about the finalization sku
   * @deprecated Use the `custom_attributes` field instead.
   */
  trial_finalization_sku?: Maybe<Scalars["String"]["output"]>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars["String"]["output"]>;
  /** Product Type */
  type_label?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars["ID"]["output"];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars["String"]["output"]>;
  /** An array of up-sell products. */
  upsell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars["String"]["output"]>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<MagentoApiUrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  voltage?: Maybe<Scalars["String"]["output"]>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<MagentoApiWebsite>>>;
};

/** Contains fields that are common to all types of products. */
export type MagentoApiProductInterfaceCustom_AttributesV2Args = {
  filters?: InputMaybe<MagentoApiAttributeFilterInput>;
};

/** Contains fields that are common to all types of products. */
export type MagentoApiProductInterfaceReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An implementation of `ProductLinksInterface`. */
export type MagentoApiProductLinks = MagentoApiProductLinksInterface & {
  __typename: "ProductLinks";
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars["String"]["output"]>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars["String"]["output"]>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars["String"]["output"]>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars["String"]["output"]>;
};

/** Contains information about linked products, including the link type and product type of each item. */
export type MagentoApiProductLinksInterface = {
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars["String"]["output"]>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars["String"]["output"]>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars["String"]["output"]>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars["String"]["output"]>;
};

/** Contains an image in base64 format and basic information about the image. */
export type MagentoApiProductMediaGalleryEntriesContent = {
  __typename: "ProductMediaGalleryEntriesContent";
  /** The image in base64 format. */
  base64_encoded_data?: Maybe<Scalars["String"]["output"]>;
  /** The file name of the image. */
  name?: Maybe<Scalars["String"]["output"]>;
  /** The MIME type of the file, such as image/png. */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Contains a link to a video file and basic information about the video. */
export type MagentoApiProductMediaGalleryEntriesVideoContent = {
  __typename: "ProductMediaGalleryEntriesVideoContent";
  /** Must be external-video. */
  media_type?: Maybe<Scalars["String"]["output"]>;
  /** A description of the video. */
  video_description?: Maybe<Scalars["String"]["output"]>;
  /** Optional data about the video. */
  video_metadata?: Maybe<Scalars["String"]["output"]>;
  /** Describes the video source. */
  video_provider?: Maybe<Scalars["String"]["output"]>;
  /** The title of the video. */
  video_title?: Maybe<Scalars["String"]["output"]>;
  /** The URL to the video. */
  video_url?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a product price. */
export type MagentoApiProductPrice = {
  __typename: "ProductPrice";
  /** The price discount. Represents the difference between the regular and final price. */
  discount?: Maybe<MagentoApiProductDiscount>;
  /** The final price of the product after applying discounts. */
  final_price: MagentoApiMoney;
  /** The final prices of the product after applying discounts with multipliers from 1 to 5. */
  final_prices?: Maybe<Array<Maybe<MagentoApiMoneyMultiplier>>>;
  /** An array of the multiple Fixed Product Taxes that can be applied to a product price. */
  fixed_product_taxes?: Maybe<Array<Maybe<MagentoApiFixedProductTax>>>;
  /** The regular price of the product. */
  regular_price: MagentoApiMoney;
  /** The regular prices of the product with multipliers from 1 to 5. */
  regular_prices?: Maybe<Array<Maybe<MagentoApiMoneyMultiplier>>>;
};

/** Deprecated. Use `PriceRange` instead. Contains the regular price of an item, as well as its minimum and maximum prices. Only composite products, which include bundle, configurable, and grouped products, can contain a minimum and maximum price. */
export type MagentoApiProductPrices = {
  __typename: "ProductPrices";
  /**
   * The highest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `to` value.
   * @deprecated Use `PriceRange.maximum_price` instead.
   */
  maximalPrice?: Maybe<MagentoApiPrice>;
  /**
   * The lowest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `from` value.
   * @deprecated Use `PriceRange.minimum_price` instead.
   */
  minimalPrice?: Maybe<MagentoApiPrice>;
  /**
   * The base price of a product.
   * @deprecated Use `regular_price` from `PriceRange.minimum_price` or `PriceRange.maximum_price` instead.
   */
  regularPrice?: Maybe<MagentoApiPrice>;
};

/** Contains details of a product review. */
export type MagentoApiProductReview = {
  __typename: "ProductReview";
  /** The average of all ratings for this product. */
  average_rating: Scalars["Float"]["output"];
  /** The date the review was created. */
  created_at: Scalars["String"]["output"];
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars["String"]["output"];
  /** The reviewed product. */
  product: MagentoApiProductInterface;
  /** An array of ratings by rating category, such as quality, price, and value. */
  ratings_breakdown: Array<Maybe<MagentoApiProductReviewRating>>;
  /** The summary (title) of the review. */
  summary: Scalars["String"]["output"];
  /** The review text. */
  text: Scalars["String"]["output"];
};

/** Contains data about a single aspect of a product review. */
export type MagentoApiProductReviewRating = {
  __typename: "ProductReviewRating";
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars["String"]["output"];
  /** The rating value given by customer. By default, possible values range from 1 to 5. */
  value: Scalars["String"]["output"];
};

/** Contains the reviewer's rating for a single aspect of a review. */
export type MagentoApiProductReviewRatingInput = {
  /** An encoded rating ID. */
  id: Scalars["String"]["input"];
  /** An encoded rating value ID. */
  value_id: Scalars["String"]["input"];
};

/** Contains details about a single aspect of a product review. */
export type MagentoApiProductReviewRatingMetadata = {
  __typename: "ProductReviewRatingMetadata";
  /** An encoded rating ID. */
  id: Scalars["String"]["output"];
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars["String"]["output"];
  /** List of product review ratings sorted by position. */
  values: Array<Maybe<MagentoApiProductReviewRatingValueMetadata>>;
};

/** Contains details about a single value in a product review. */
export type MagentoApiProductReviewRatingValueMetadata = {
  __typename: "ProductReviewRatingValueMetadata";
  /** A ratings scale, such as the number of stars awarded. */
  value: Scalars["String"]["output"];
  /** An encoded rating value ID. */
  value_id: Scalars["String"]["output"];
};

/** Contains an array of metadata about each aspect of a product review. */
export type MagentoApiProductReviewRatingsMetadata = {
  __typename: "ProductReviewRatingsMetadata";
  /** An array of product reviews sorted by position. */
  items: Array<Maybe<MagentoApiProductReviewRatingMetadata>>;
};

/** Contains an array of product reviews. */
export type MagentoApiProductReviews = {
  __typename: "ProductReviews";
  /** An array of product reviews. */
  items: Array<Maybe<MagentoApiProductReview>>;
  /** Metadata for pagination rendering. */
  page_info: MagentoApiSearchResultPageInfo;
};

export type MagentoApiProductSkuFilterInput = {
  /** Product SKU */
  sku?: InputMaybe<MagentoApiFilterTypeInput>;
};

/** Deprecated. Use `ProductAttributeSortInput` instead. Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type MagentoApiProductSortInput = {
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<MagentoApiSortEnum>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<MagentoApiSortEnum>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<MagentoApiSortEnum>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<MagentoApiSortEnum>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<MagentoApiSortEnum>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<MagentoApiSortEnum>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<MagentoApiSortEnum>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<MagentoApiSortEnum>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<MagentoApiSortEnum>;
  /** Indicates whether the product can be returned. */
  is_returnable?: InputMaybe<MagentoApiSortEnum>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<MagentoApiSortEnum>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<MagentoApiSortEnum>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<MagentoApiSortEnum>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<MagentoApiSortEnum>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<MagentoApiSortEnum>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<MagentoApiSortEnum>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<MagentoApiSortEnum>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<MagentoApiSortEnum>;
  /** The price of the item. */
  price?: InputMaybe<MagentoApiSortEnum>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<MagentoApiSortEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<MagentoApiSortEnum>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<MagentoApiSortEnum>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<MagentoApiSortEnum>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<MagentoApiSortEnum>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<MagentoApiSortEnum>;
  /** The discounted price of the product. */
  special_price?: InputMaybe<MagentoApiSortEnum>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<MagentoApiSortEnum>;
  /** Indicates the criteria to sort swatches. */
  swatch_image?: InputMaybe<MagentoApiSortEnum>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<MagentoApiSortEnum>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<MagentoApiSortEnum>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<MagentoApiSortEnum>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<MagentoApiSortEnum>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<MagentoApiSortEnum>;
  url_path?: InputMaybe<MagentoApiSortEnum>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<MagentoApiSortEnum>;
};

/** This enumeration states whether a product stock status is in stock or out of stock */
export type MagentoApiProductStockStatus =
  /** Product is not available for online purchase but can be found in physical stores. */
  "AVAILABLE_IN_STORES" | "IN_STOCK" | "OUT_OF_STOCK";

/** Deprecated. Use `TierPrice` instead. Defines a tier price, which is a quantity discount offered to a specific customer group. */
export type MagentoApiProductTierPrices = {
  __typename: "ProductTierPrices";
  /**
   * The ID of the customer group.
   * @deprecated Not relevant for the storefront.
   */
  customer_group_id?: Maybe<Scalars["String"]["output"]>;
  /**
   * The percentage discount of the item.
   * @deprecated Use `TierPrice.discount` instead.
   */
  percentage_value?: Maybe<Scalars["Float"]["output"]>;
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated Use `TierPrice.quantity` instead.
   */
  qty?: Maybe<Scalars["Float"]["output"]>;
  /**
   * The price of the fixed price item.
   * @deprecated Use `TierPrice.final_price` instead.
   */
  value?: Maybe<Scalars["Float"]["output"]>;
  /**
   * The ID assigned to the website.
   * @deprecated Not relevant for the storefront.
   */
  website_id?: Maybe<Scalars["Float"]["output"]>;
};

/** Contains information about a product video. */
export type MagentoApiProductVideo = MagentoApiMediaGalleryInterface & {
  __typename: "ProductVideo";
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** Role of the image */
  role?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars["String"]["output"]>;
  /** Contains a `ProductMediaGalleryEntriesVideoContent` object. */
  video_content?: Maybe<MagentoApiProductMediaGalleryEntriesVideoContent>;
};

/** Contains information about a product video. */
export type MagentoApiProductVideoUrlArgs = {
  dpr?: InputMaybe<Scalars["Int"]["input"]>;
  fit?: InputMaybe<Scalars["String"]["input"]>;
  height?: InputMaybe<Scalars["Int"]["input"]>;
  quality?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["String"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Contains the results of a `products` query. */
export type MagentoApiProducts = {
  __typename: "Products";
  /** A bucket that contains the attribute code and label for each filterable option. */
  aggregations?: Maybe<Array<Maybe<MagentoApiAggregation>>>;
  /**
   * Layered navigation filters array.
   * @deprecated Use `aggregations` instead.
   */
  filters?: Maybe<Array<Maybe<MagentoApiLayerFilter>>>;
  /** An array of products that match the specified search criteria. */
  items?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<MagentoApiSearchResultPageInfo>;
  /** An object that includes the default sort field and all available sort fields. */
  sort_fields?: Maybe<MagentoApiSortFields>;
  /** An array of search suggestions for case when search query have no results. */
  suggestions?: Maybe<Array<Maybe<MagentoApiSearchSuggestion>>>;
  /** The number of products that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars["Int"]["output"]>;
};

/** Contains the results of a `products` query. */
export type MagentoApiProductsAggregationsArgs = {
  filter?: InputMaybe<MagentoApiAggregationsFilterInput>;
};

export type MagentoApiProductsPrices = {
  __typename: "ProductsPrices";
  items?: Maybe<Array<Maybe<MagentoApiProductsPricesItem>>>;
  total_count?: Maybe<Scalars["Int"]["output"]>;
};

export type MagentoApiProductsPricesItem = {
  __typename: "ProductsPricesItem";
  price_range: MagentoApiPriceRange;
  sku?: Maybe<Scalars["String"]["output"]>;
  stock_status?: Maybe<MagentoApiProductStockStatus>;
};

export type MagentoApiQuery = {
  __typename: "Query";
  /** Returns data for the customer's most recent order. */
  LastCustomerOrder?: Maybe<MagentoApiCustomerOrder>;
  /** Retrieve EAV attributes associated to a frontend form. Use countries query provided by DirectoryGraphQl module to retrieve region_id and country_id attribute options. */
  attributesForm: MagentoApiAttributesFormOutput;
  /** Returns a list of attributes metadata for a given entity type. */
  attributesList?: Maybe<MagentoApiAttributesMetadataOutput>;
  /** Get a list of available store views and their config information. */
  availableStores?: Maybe<Array<Maybe<MagentoApiStoreConfig>>>;
  /** Return information about the specified shopping cart with conditional request support. */
  cart?: Maybe<MagentoApiCart>;
  /** Return a list of categories that match the specified filter. */
  categories?: Maybe<MagentoApiCategoryResult>;
  /**
   * Search for categories that match the criteria specified in the `search` and `filter` attributes.
   * @deprecated Use `categories` instead.
   */
  category?: Maybe<MagentoApiCategoryTree>;
  /**
   * Return an array of categories based on the specified filters.
   * @deprecated Use `categories` instead.
   */
  categoryList?: Maybe<Array<Maybe<MagentoApiCategoryTree>>>;
  /** Return Terms and Conditions configuration information. */
  checkoutAgreements?: Maybe<Array<Maybe<MagentoApiCheckoutAgreement>>>;
  /** Return information about CMS blocks. */
  cmsBlocks?: Maybe<MagentoApiCmsBlocks>;
  /** Return details about a CMS page. */
  cmsPage?: Maybe<MagentoApiCmsPage>;
  /** Return products that have been added to the specified compare list. */
  compareList?: Maybe<MagentoApiCompareList>;
  /** The countries query provides information for all countries. */
  countries?: Maybe<Array<Maybe<MagentoApiCountry>>>;
  /** The countries query provides information for a single country. */
  country?: Maybe<MagentoApiCountry>;
  /** Return information about the store's currency. */
  currency?: Maybe<MagentoApiCurrency>;
  /**
   * Return the attribute type, given an attribute code and entity type.
   * @deprecated Use `customAttributeMetadataV2` query instead.
   */
  customAttributeMetadata?: Maybe<MagentoApiCustomAttributeMetadata>;
  /** Retrieve EAV attributes metadata. */
  customAttributeMetadataV2: MagentoApiAttributesMetadataOutput;
  /** Return detailed information about a customer account. */
  customer?: Maybe<MagentoApiCustomer>;
  /** Return information about the customer's shopping cart. */
  customerCart: MagentoApiCart;
  /** Return a list of downloadable products the customer has purchased. */
  customerDownloadableProducts?: Maybe<MagentoApiCustomerDownloadableProducts>;
  /** @deprecated Use the `customer` query instead. */
  customerOrders?: Maybe<MagentoApiCustomerOrders>;
  /** Return a list of customer payment tokens stored in the vault. */
  customerPaymentTokens?: Maybe<MagentoApiCustomerPaymentTokens>;
  /** Return a list of dynamic blocks filtered by type, location, or UIDs. */
  dynamicBlocks: MagentoApiDynamicBlocks;
  getBrandConsumableMatrix: Array<Maybe<MagentoApiBrandConsumablesMatrix>>;
  getConsumablesMatrix?: Maybe<MagentoApiConsumablesMatrix>;
  /** Delivery regions and the provinces belonging to each. Empty when region validation is not enabled. */
  getDeliveryRegions?: Maybe<Array<Maybe<MagentoApiDeliveryRegion>>>;
  /** Retrieve the secure PayPal URL for a Payments Pro Hosted Solution transaction. */
  getHostedProUrl?: Maybe<MagentoApiHostedProUrl>;
  /** Provides the necessary attributes for the FE */
  getOrderAttributes?: Maybe<Array<Maybe<MagentoApiOrderAttribute>>>;
  /** Query by Get Order Delivery Limits. */
  getOrderDeliveryLimits?: Maybe<MagentoApiGetOrderDeliveryLimits>;
  /** Retrieve payment credentials for a transaction. Use this query for Payflow Link and Payments Advanced payment methods. */
  getPayflowLinkToken?: Maybe<MagentoApiPayflowLinkToken>;
  /** Retrieves the payment configuration for a given location */
  getPaymentConfig?: Maybe<MagentoApiPaymentConfigOutput>;
  /** Retrieves the payment details for the order */
  getPaymentOrder?: Maybe<MagentoApiPaymentOrderOutput>;
  /** Gets the payment SDK urls and values */
  getPaymentSDK?: Maybe<MagentoApiGetPaymentSdkOutput>;
  /** The range of prices for the product */
  getProductPrice: MagentoApiPriceRange;
  /** Query for SpecialOffersList. */
  getPromotionalOffersList?: Maybe<MagentoApiSpecialOfferList>;
  /** Query for SpecialOffersList. */
  getSpecialOffersList?: Maybe<MagentoApiSpecialOfferList>;
  /** Provides the necessary attributes for the FE */
  getSticksMatrix?: Maybe<MagentoApiSticksMatrix>;
  /** Retrieves the vault configuration */
  getVaultConfig?: Maybe<MagentoApiVaultConfigOutput>;
  /** Query to retrieve the list of order statuses. */
  getorderstatus?: Maybe<Array<Maybe<MagentoApiGetorderstatus>>>;
  /** Return details about a specific gift card. */
  giftCardAccount?: Maybe<MagentoApiGiftCardAccount>;
  /** Return the specified gift registry. Some details will not be available to guests. */
  giftRegistry?: Maybe<MagentoApiGiftRegistry>;
  /** Search for gift registries by specifying a registrant email address. */
  giftRegistryEmailSearch?: Maybe<Array<Maybe<MagentoApiGiftRegistrySearchResult>>>;
  /** Search for gift registries by specifying a registry URL key. */
  giftRegistryIdSearch?: Maybe<Array<Maybe<MagentoApiGiftRegistrySearchResult>>>;
  /** Search for gift registries by specifying the registrant name and registry type ID. */
  giftRegistryTypeSearch?: Maybe<Array<Maybe<MagentoApiGiftRegistrySearchResult>>>;
  /** Get a list of available gift registry types. */
  giftRegistryTypes?: Maybe<Array<Maybe<MagentoApiGiftRegistryType>>>;
  /** Retrieve guest order details based on number, email and billing last name. */
  guestOrder: MagentoApiCustomerOrder;
  /** Retrieve guest order details based on token. */
  guestOrderByToken: MagentoApiCustomerOrder;
  /** Check whether the specified email has already been used to create a customer account. */
  isEmailAvailable?: Maybe<MagentoApiIsEmailAvailableOutput>;
  /** Return the active ratings attributes and the values each rating can have. */
  productReviewRatingsMetadata: MagentoApiProductReviewRatingsMetadata;
  /** Search for products that match the criteria specified in the `search` and `filter` attributes. */
  products?: Maybe<MagentoApiProducts>;
  products_prices?: Maybe<MagentoApiProductsPrices>;
  recaptchaFormConfig?: Maybe<MagentoApiReCaptchaConfigOutput>;
  /** Returns details about Google reCAPTCHA V3-Invisible configuration. */
  recaptchaV3Config?: Maybe<MagentoApiReCaptchaConfigurationV3>;
  /** Return the full details for a specified product, category, or CMS page. */
  route?: Maybe<MagentoApiRoutableInterface>;
  /** Return details about the store's configuration. */
  storeConfig?: Maybe<MagentoApiStoreConfig>;
  /**
   * Return the relative URL for a specified product, category or CMS page.
   * @deprecated Use the `route` query instead.
   */
  urlResolver?: Maybe<MagentoApiEntityUrl>;
  /**
   * Return the contents of a customer's wish list.
   * @deprecated Moved under `Customer.wishlist`.
   */
  wishlist?: Maybe<MagentoApiWishlistOutput>;
};

export type MagentoApiQueryAttributesFormArgs = {
  formCode: Scalars["String"]["input"];
};

export type MagentoApiQueryAttributesListArgs = {
  entityType: MagentoApiAttributeEntityTypeEnum;
  filters?: InputMaybe<MagentoApiAttributeFilterInput>;
};

export type MagentoApiQueryAvailableStoresArgs = {
  useCurrentGroup?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MagentoApiQueryCartArgs = {
  cart_id: Scalars["String"]["input"];
  if_modified_since?: InputMaybe<Scalars["String"]["input"]>;
};

export type MagentoApiQueryCategoriesArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<MagentoApiCategoryFilterInput>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MagentoApiQueryCategoryArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MagentoApiQueryCategoryListArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<MagentoApiCategoryFilterInput>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MagentoApiQueryCmsBlocksArgs = {
  identifiers?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MagentoApiQueryCmsPageArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  identifier?: InputMaybe<Scalars["String"]["input"]>;
};

export type MagentoApiQueryCompareListArgs = {
  uid: Scalars["ID"]["input"];
};

export type MagentoApiQueryCountryArgs = {
  id?: InputMaybe<Scalars["String"]["input"]>;
};

export type MagentoApiQueryCustomAttributeMetadataArgs = {
  attributes: Array<MagentoApiAttributeInput>;
};

export type MagentoApiQueryCustomAttributeMetadataV2Args = {
  attributes?: InputMaybe<Array<MagentoApiAttributeInput>>;
};

export type MagentoApiQueryDynamicBlocksArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  input?: InputMaybe<MagentoApiDynamicBlocksFilterInput>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MagentoApiQueryGetBrandConsumableMatrixArgs = {
  brandCode: Scalars["String"]["input"];
};

export type MagentoApiQueryGetHostedProUrlArgs = {
  input: MagentoApiHostedProUrlInput;
};

export type MagentoApiQueryGetPayflowLinkTokenArgs = {
  input: MagentoApiPayflowLinkTokenInput;
};

export type MagentoApiQueryGetPaymentConfigArgs = {
  location: MagentoApiPaymentLocation;
};

export type MagentoApiQueryGetPaymentOrderArgs = {
  cartId: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MagentoApiQueryGetPaymentSdkArgs = {
  location: MagentoApiPaymentLocation;
};

export type MagentoApiQueryGetProductPriceArgs = {
  quantity: Scalars["Int"]["input"];
  sku: Scalars["String"]["input"];
};

export type MagentoApiQueryGiftCardAccountArgs = {
  input: MagentoApiGiftCardAccountInput;
};

export type MagentoApiQueryGiftRegistryArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
};

export type MagentoApiQueryGiftRegistryEmailSearchArgs = {
  email: Scalars["String"]["input"];
};

export type MagentoApiQueryGiftRegistryIdSearchArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
};

export type MagentoApiQueryGiftRegistryTypeSearchArgs = {
  firstName: Scalars["String"]["input"];
  giftRegistryTypeUid?: InputMaybe<Scalars["ID"]["input"]>;
  lastName: Scalars["String"]["input"];
};

export type MagentoApiQueryGuestOrderArgs = {
  input: MagentoApiOrderInformationInput;
};

export type MagentoApiQueryGuestOrderByTokenArgs = {
  input: MagentoApiOrderTokenInput;
};

export type MagentoApiQueryIsEmailAvailableArgs = {
  email: Scalars["String"]["input"];
};

export type MagentoApiQueryProductsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  filter?: InputMaybe<MagentoApiProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<MagentoApiProductAttributeSortInput>;
};

export type MagentoApiQueryProducts_PricesArgs = {
  filter?: InputMaybe<MagentoApiProductSkuFilterInput>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MagentoApiQueryRecaptchaFormConfigArgs = {
  formType: MagentoApiReCaptchaFormEnum;
};

export type MagentoApiQueryRouteArgs = {
  url: Scalars["String"]["input"];
};

export type MagentoApiQueryUrlResolverArgs = {
  url: Scalars["String"]["input"];
};

export type MagentoApiQuoteAttribute = {
  __typename: "QuoteAttribute";
  attribute_code: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type MagentoApiQuoteAttributeInput = {
  attribute_code: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

/** Specifies the field to use for sorting quote items */
export type MagentoApiQuoteItemsSortInput = {
  /** Specifies the quote items field to sort by */
  field: MagentoApiSortQuoteItemsEnum;
  /** Specifies the order of quote items' sorting */
  order: MagentoApiSortEnum;
};

export type MagentoApiReCaptchaConfigOutput = {
  __typename: "ReCaptchaConfigOutput";
  /** Configuration details for reCaptcha type */
  configurations?: Maybe<MagentoApiReCaptchaConfiguration>;
  /** Indicates whether reCaptcha type is enabled */
  is_enabled: Scalars["Boolean"]["output"];
};

/** Contains reCAPTCHA form configuration details. */
export type MagentoApiReCaptchaConfiguration = {
  __typename: "ReCaptchaConfiguration";
  /** The position of the invisible reCAPTCHA badge on each page. */
  badge_position?: Maybe<Scalars["String"]["output"]>;
  /** A two-character code that specifies the language that is used for Google reCAPTCHA text and messaging. */
  language_code?: Maybe<Scalars["String"]["output"]>;
  /** The minimum score that identifies a user interaction as a potential risk. */
  minimum_score?: Maybe<Scalars["Float"]["output"]>;
  re_captcha_type: MagentoApiReCaptchaTypeEmum;
  /** The message that appears when reCaptcha fails. */
  technical_failure_message: Scalars["String"]["output"];
  /** Theme to be used to render reCaptcha. */
  theme: Scalars["String"]["output"];
  /** The message that appears to the user if validation fails. */
  validation_failure_message: Scalars["String"]["output"];
  /** The website key generated when the Google reCAPTCHA account was registered. */
  website_key: Scalars["String"]["output"];
};

/** Contains reCAPTCHA V3-Invisible configuration details. */
export type MagentoApiReCaptchaConfigurationV3 = {
  __typename: "ReCaptchaConfigurationV3";
  /** The position of the invisible reCAPTCHA badge on each page. */
  badge_position: Scalars["String"]["output"];
  /** The message that appears to the user if validation fails. */
  failure_message: Scalars["String"]["output"];
  /** A list of forms on the storefront that have been configured to use reCAPTCHA V3. */
  forms: Array<Maybe<MagentoApiReCaptchaFormEnum>>;
  /** Return whether recaptcha is enabled or not */
  is_enabled: Scalars["Boolean"]["output"];
  /** A two-character code that specifies the language that is used for Google reCAPTCHA text and messaging. */
  language_code?: Maybe<Scalars["String"]["output"]>;
  /** The minimum score that identifies a user interaction as a potential risk. */
  minimum_score: Scalars["Float"]["output"];
  /** Theme to be used to render reCaptcha. */
  theme: Scalars["String"]["output"];
  /** The website key generated when the Google reCAPTCHA account was registered. */
  website_key: Scalars["String"]["output"];
};

export type MagentoApiReCaptchaFormEnum =
  | "BRAINTREE"
  | "CONTACT"
  | "CUSTOMER_CREATE"
  | "CUSTOMER_EDIT"
  | "CUSTOMER_FORGOT_PASSWORD"
  | "CUSTOMER_LOGIN"
  | "NEWSLETTER"
  | "PLACE_ORDER"
  | "PRODUCT_REVIEW"
  | "RESEND_CONFIRMATION_EMAIL"
  | "SENDFRIEND";

export type MagentoApiReCaptchaTypeEmum = "INVISIBLE" | "RECAPTCHA" | "RECAPTCHA_V3";

export type MagentoApiRegion = {
  __typename: "Region";
  /** The two-letter code for the region, such as TX for Texas. */
  code?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `Region` object. */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** The name of the region, such as Texas. */
  name?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiRemoveCampaignFromCartInput = {
  cart_id: Scalars["String"]["input"];
};

export type MagentoApiRemoveCampaignFromCartOutput = {
  __typename: "RemoveCampaignFromCartOutput";
  cart?: Maybe<MagentoApiCart>;
};

/** Specifies the cart from which to remove a coupon. */
export type MagentoApiRemoveCouponFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** The coupon code to remove (will remove all coupons if empty). */
  coupon_code?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains details about the cart after removing a coupon. */
export type MagentoApiRemoveCouponFromCartOutput = {
  __typename: "RemoveCouponFromCartOutput";
  /** The cart after removing a coupon. */
  cart?: Maybe<MagentoApiCart>;
};

/** Remove coupons from the cart. */
export type MagentoApiRemoveCouponsFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of coupon codes to be removed from the quote. If coupon_codes is empty all coupons will be removed from the quote. */
  coupon_codes: Array<InputMaybe<Scalars["String"]["input"]>>;
};

/** Defines the input required to run the `removeGiftCardFromCart` mutation. */
export type MagentoApiRemoveGiftCardFromCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
  /** The gift card code to be removed to the cart. */
  gift_card_code: Scalars["String"]["input"];
};

/** Defines the possible output for the `removeGiftCardFromCart` mutation. */
export type MagentoApiRemoveGiftCardFromCartOutput = {
  __typename: "RemoveGiftCardFromCartOutput";
  /** The contents of the specified shopping cart. */
  cart: MagentoApiCart;
};

/** Contains the results of a request to remove an item from a gift registry. */
export type MagentoApiRemoveGiftRegistryItemsOutput = {
  __typename: "RemoveGiftRegistryItemsOutput";
  /** The gift registry after removing items. */
  gift_registry?: Maybe<MagentoApiGiftRegistry>;
};

/** Contains the results of a request to delete a gift registry. */
export type MagentoApiRemoveGiftRegistryOutput = {
  __typename: "RemoveGiftRegistryOutput";
  /** Indicates whether the gift registry was successfully deleted. */
  success: Scalars["Boolean"]["output"];
};

/** Contains the results of a request to delete a registrant. */
export type MagentoApiRemoveGiftRegistryRegistrantsOutput = {
  __typename: "RemoveGiftRegistryRegistrantsOutput";
  /** The gift registry after deleting registrants. */
  gift_registry?: Maybe<MagentoApiGiftRegistry>;
};

/** Specifies which items to remove from the cart. */
export type MagentoApiRemoveItemFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Required field. The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Contains details about the cart after removing an item. */
export type MagentoApiRemoveItemFromCartOutput = {
  __typename: "RemoveItemFromCartOutput";
  /** The cart after removing an item. */
  cart: MagentoApiCart;
};

/** Defines which products to remove from a compare list. */
export type MagentoApiRemoveProductsFromCompareListInput = {
  /** An array of product IDs to remove from the compare list. */
  products: Array<InputMaybe<Scalars["ID"]["input"]>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars["ID"]["input"];
};

/** Contains the customer's wish list and any errors encountered. */
export type MagentoApiRemoveProductsFromWishlistOutput = {
  __typename: "RemoveProductsFromWishlistOutput";
  /** An array of errors encountered while deleting products from a wish list. */
  user_errors: Array<Maybe<MagentoApiWishListUserInputError>>;
  /** Contains the wish list with after items were successfully deleted. */
  wishlist: MagentoApiWishlist;
};

/** Defines the tracking information to delete. */
export type MagentoApiRemoveReturnTrackingInput = {
  /** The unique ID for a `ReturnShippingTracking` object. */
  return_shipping_tracking_uid: Scalars["ID"]["input"];
};

/** Contains the response after deleting tracking information. */
export type MagentoApiRemoveReturnTrackingOutput = {
  __typename: "RemoveReturnTrackingOutput";
  /** Contains details about the modified return. */
  return?: Maybe<MagentoApiReturn>;
};

/** Contains the customer cart. */
export type MagentoApiRemoveRewardPointsFromCartOutput = {
  __typename: "RemoveRewardPointsFromCartOutput";
  /** The customer cart after reward points are removed. */
  cart: MagentoApiCart;
};

/** Defines the input required to run the `removeStoreCreditFromCart` mutation. */
export type MagentoApiRemoveStoreCreditFromCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
};

/** Defines the possible output for the `removeStoreCreditFromCart` mutation. */
export type MagentoApiRemoveStoreCreditFromCartOutput = {
  __typename: "RemoveStoreCreditFromCartOutput";
  /** The contents of the specified shopping cart. */
  cart: MagentoApiCart;
};

/** Contains the cart and any errors after adding products. */
export type MagentoApiReorderItemsOutput = {
  __typename: "ReorderItemsOutput";
  /** Detailed information about the customer's cart. */
  cart: MagentoApiCart;
  /** An array of reordering errors. */
  userInputErrors: Array<Maybe<MagentoApiCheckoutUserInputError>>;
};

/** Contains information needed to start a return request. */
export type MagentoApiRequestGuestReturnInput = {
  /** Text the buyer entered that describes the reason for the refund request. */
  comment_text?: InputMaybe<Scalars["String"]["input"]>;
  /** The email address the buyer enters to receive notifications about the status of the return. */
  contact_email?: InputMaybe<Scalars["String"]["input"]>;
  /** An array of items to be returned. */
  items: Array<InputMaybe<MagentoApiRequestReturnItemInput>>;
  /** Order token. */
  token: Scalars["String"]["input"];
};

/** Contains information needed to start a return request. */
export type MagentoApiRequestReturnInput = {
  /** Text the buyer entered that describes the reason for the refund request. */
  comment_text?: InputMaybe<Scalars["String"]["input"]>;
  /** The email address the buyer enters to receive notifications about the status of the return. */
  contact_email?: InputMaybe<Scalars["String"]["input"]>;
  /** An array of items to be returned. */
  items: Array<InputMaybe<MagentoApiRequestReturnItemInput>>;
  /** The unique ID for a `Order` object. */
  order_uid: Scalars["ID"]["input"];
};

/** Contains details about an item to be returned. */
export type MagentoApiRequestReturnItemInput = {
  /** Details about a custom attribute that was entered. */
  entered_custom_attributes?: InputMaybe<Array<InputMaybe<MagentoApiEnteredCustomAttributeInput>>>;
  /** The unique ID for a `OrderItemInterface` object. */
  order_item_uid: Scalars["ID"]["input"];
  /** The quantity of the item to be returned. */
  quantity_to_return: Scalars["Float"]["input"];
  /** An array of selected custom option IDs associated with the item to be returned. For example, the IDs for the selected color and size of a configurable product. */
  selected_custom_attributes?: InputMaybe<Array<InputMaybe<MagentoApiSelectedCustomAttributeInput>>>;
};

/** Contains the response to a return request. */
export type MagentoApiRequestReturnOutput = {
  __typename: "RequestReturnOutput";
  /** Details about a single return request. */
  return?: Maybe<MagentoApiReturn>;
  /** An array of return requests. */
  returns?: Maybe<MagentoApiReturns>;
};

/** Contains the response to a return request. */
export type MagentoApiRequestReturnOutputReturnsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Contains details about a return. */
export type MagentoApiReturn = {
  __typename: "Return";
  /** A list of shipping carriers available for returns. */
  available_shipping_carriers?: Maybe<Array<Maybe<MagentoApiReturnShippingCarrier>>>;
  /** A list of comments posted for the return request. */
  comments?: Maybe<Array<Maybe<MagentoApiReturnComment>>>;
  /** The date the return was requested. */
  created_at: Scalars["String"]["output"];
  /** Data from the customer who created the return request. */
  customer: MagentoApiReturnCustomer;
  /** A list of items being returned. */
  items?: Maybe<Array<Maybe<MagentoApiReturnItem>>>;
  /** A human-readable return number. */
  number: Scalars["String"]["output"];
  /** The order associated with the return. */
  order?: Maybe<MagentoApiCustomerOrder>;
  /** Shipping information for the return. */
  shipping?: Maybe<MagentoApiReturnShipping>;
  /** The status of the return request. */
  status?: Maybe<MagentoApiReturnStatus>;
  /** The unique ID for a `Return` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains details about a return comment. */
export type MagentoApiReturnComment = {
  __typename: "ReturnComment";
  /** The name or author who posted the comment. */
  author_name: Scalars["String"]["output"];
  /** The date and time the comment was posted. */
  created_at: Scalars["String"]["output"];
  /** The contents of the comment. */
  text: Scalars["String"]["output"];
  /** The unique ID for a `ReturnComment` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains details about a `ReturnCustomerAttribute` object. */
export type MagentoApiReturnCustomAttribute = {
  __typename: "ReturnCustomAttribute";
  /** A description of the attribute. */
  label: Scalars["String"]["output"];
  /** The unique ID for a `ReturnCustomAttribute` object. */
  uid: Scalars["ID"]["output"];
  /** A JSON-encoded value of the attribute. */
  value: Scalars["String"]["output"];
};

/** The customer information for the return. */
export type MagentoApiReturnCustomer = {
  __typename: "ReturnCustomer";
  /** The email address of the customer. */
  email: Scalars["String"]["output"];
  /** The first name of the customer. */
  firstname?: Maybe<Scalars["String"]["output"]>;
  /** The last name of the customer. */
  lastname?: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about a product being returned. */
export type MagentoApiReturnItem = {
  __typename: "ReturnItem";
  /**
   * Return item custom attributes that are visible on the storefront.
   * @deprecated Use custom_attributesV2 instead.
   */
  custom_attributes?: Maybe<Array<Maybe<MagentoApiReturnCustomAttribute>>>;
  /** Custom attributes that are visible on the storefront. */
  custom_attributesV2?: Maybe<Array<Maybe<MagentoApiAttributeValueInterface>>>;
  /** Provides access to the product being returned, including information about selected and entered options. */
  order_item: MagentoApiOrderItemInterface;
  /** The quantity of the item the merchant authorized to be returned. */
  quantity: Scalars["Float"]["output"];
  /** The quantity of the item requested to be returned. */
  request_quantity: Scalars["Float"]["output"];
  /** The return status of the item. */
  status: MagentoApiReturnItemStatus;
  /** The unique ID for a `ReturnItem` object. */
  uid: Scalars["ID"]["output"];
};

/** Return Item attribute metadata. */
export type MagentoApiReturnItemAttributeMetadata = MagentoApiCustomAttributeMetadataInterface & {
  __typename: "ReturnItemAttributeMetadata";
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars["ID"]["output"];
  /** Default attribute value. */
  default_value?: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type: MagentoApiAttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<MagentoApiAttributeFrontendInputEnum>;
  /** The template used for the input of the attribute (e.g., 'date'). */
  input_filter?: Maybe<MagentoApiInputFilterEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars["Boolean"]["output"];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The number of lines of the attribute value. */
  multiline_count?: Maybe<Scalars["Int"]["output"]>;
  /** Attribute options. */
  options: Array<Maybe<MagentoApiCustomAttributeOptionInterface>>;
  /** The position of the attribute in the form. */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The validation rules of the attribute value. */
  validate_rules?: Maybe<Array<Maybe<MagentoApiValidationRule>>>;
};

export type MagentoApiReturnItemStatus = "APPROVED" | "AUTHORIZED" | "DENIED" | "PENDING" | "RECEIVED" | "REJECTED";

/** Contains details about the return shipping address. */
export type MagentoApiReturnShipping = {
  __typename: "ReturnShipping";
  /** The merchant-defined return shipping address. */
  address?: Maybe<MagentoApiReturnShippingAddress>;
  /** The unique ID for a `ReturnShippingTracking` object. If a single UID is specified, the array contains a single tracking record. Otherwise, array contains all tracking information. */
  tracking?: Maybe<Array<Maybe<MagentoApiReturnShippingTracking>>>;
};

/** Contains details about the return shipping address. */
export type MagentoApiReturnShippingTrackingArgs = {
  uid?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Contains details about the shipping address used for receiving returned items. */
export type MagentoApiReturnShippingAddress = {
  __typename: "ReturnShippingAddress";
  /** The city for product returns. */
  city: Scalars["String"]["output"];
  /** The merchant's contact person. */
  contact_name?: Maybe<Scalars["String"]["output"]>;
  /** An object that defines the country for product returns. */
  country: MagentoApiCountry;
  /** The postal code for product returns. */
  postcode: Scalars["String"]["output"];
  /** An object that defines the state or province for product returns. */
  region: MagentoApiRegion;
  /** The street address for product returns. */
  street: Array<Maybe<Scalars["String"]["output"]>>;
  /** The telephone number for product returns. */
  telephone?: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about the carrier on a return. */
export type MagentoApiReturnShippingCarrier = {
  __typename: "ReturnShippingCarrier";
  /** A description of the shipping carrier. */
  label: Scalars["String"]["output"];
  /** The unique ID for a `ReturnShippingCarrier` object assigned to the shipping carrier. */
  uid: Scalars["ID"]["output"];
};

/** Contains shipping and tracking details. */
export type MagentoApiReturnShippingTracking = {
  __typename: "ReturnShippingTracking";
  /** Contains details of a shipping carrier. */
  carrier: MagentoApiReturnShippingCarrier;
  /** Details about the status of a shipment. */
  status?: Maybe<MagentoApiReturnShippingTrackingStatus>;
  /** A tracking number assigned by the carrier. */
  tracking_number: Scalars["String"]["output"];
  /** The unique ID for a `ReturnShippingTracking` object assigned to the tracking item. */
  uid: Scalars["ID"]["output"];
};

/** Contains the status of a shipment. */
export type MagentoApiReturnShippingTrackingStatus = {
  __typename: "ReturnShippingTrackingStatus";
  /** Text that describes the status. */
  text: Scalars["String"]["output"];
  /** Indicates whether the status type is informational or an error. */
  type: MagentoApiReturnShippingTrackingStatusType;
};

export type MagentoApiReturnShippingTrackingStatusType = "ERROR" | "INFORMATION";

export type MagentoApiReturnStatus =
  | "APPROVED"
  | "AUTHORIZED"
  | "CLOSED"
  | "DENIED"
  | "PARTIALLY_APPROVED"
  | "PARTIALLY_AUTHORIZED"
  | "PARTIALLY_RECEIVED"
  | "PARTIALLY_REJECTED"
  | "PENDING"
  | "PROCESSED_AND_CLOSED"
  | "RECEIVED"
  | "REJECTED"
  | "UNCONFIRMED";

/** Contains a list of customer return requests. */
export type MagentoApiReturns = {
  __typename: "Returns";
  /** A list of return requests. */
  items?: Maybe<Array<Maybe<MagentoApiReturn>>>;
  /** Pagination metadata. */
  page_info?: Maybe<MagentoApiSearchResultPageInfo>;
  /** The total number of return requests. */
  total_count?: Maybe<Scalars["Int"]["output"]>;
};

/** Contains the result of a request to revoke a customer token. */
export type MagentoApiRevokeCustomerTokenOutput = {
  __typename: "RevokeCustomerTokenOutput";
  /** The result of a request to revoke a customer token. */
  result: Scalars["Boolean"]["output"];
};

/** Contains details about a customer's reward points. */
export type MagentoApiRewardPoints = {
  __typename: "RewardPoints";
  /** The current balance of reward points. */
  balance?: Maybe<MagentoApiRewardPointsAmount>;
  /** The balance history of reward points. If the ability for customers to view the balance history has been disabled in the Admin, this field will be set to null. */
  balance_history?: Maybe<Array<Maybe<MagentoApiRewardPointsBalanceHistoryItem>>>;
  /** The current exchange rates for reward points. */
  exchange_rates?: Maybe<MagentoApiRewardPointsExchangeRates>;
  /** The subscription status of emails related to reward points. */
  subscription_status?: Maybe<MagentoApiRewardPointsSubscriptionStatus>;
};

export type MagentoApiRewardPointsAmount = {
  __typename: "RewardPointsAmount";
  /** The reward points amount in store currency. */
  money: MagentoApiMoney;
  /** The reward points amount in points. */
  points: Scalars["Float"]["output"];
};

/** Contain details about the reward points transaction. */
export type MagentoApiRewardPointsBalanceHistoryItem = {
  __typename: "RewardPointsBalanceHistoryItem";
  /** The award points balance after the completion of the transaction. */
  balance?: Maybe<MagentoApiRewardPointsAmount>;
  /** The reason the balance changed. */
  change_reason: Scalars["String"]["output"];
  /** The date of the transaction. */
  date: Scalars["String"]["output"];
  /** The number of points added or deducted in the transaction. */
  points_change: Scalars["Float"]["output"];
};

/** Lists the reward points exchange rates. The values depend on the customer group. */
export type MagentoApiRewardPointsExchangeRates = {
  __typename: "RewardPointsExchangeRates";
  /** How many points are earned for a given amount spent. */
  earning?: Maybe<MagentoApiRewardPointsRate>;
  /** How many points must be redeemed to get a given amount of currency discount at the checkout. */
  redemption?: Maybe<MagentoApiRewardPointsRate>;
};

/** Contains details about customer's reward points rate. */
export type MagentoApiRewardPointsRate = {
  __typename: "RewardPointsRate";
  /** The money value for the exchange rate. For earnings, this is the amount spent to earn the specified points. For redemption, this is the amount of money the number of points represents. */
  currency_amount: Scalars["Float"]["output"];
  /** The number of points for an exchange rate. For earnings, this is the number of points earned. For redemption, this is the number of points needed for redemption. */
  points: Scalars["Float"]["output"];
};

/** Indicates whether the customer subscribes to reward points emails. */
export type MagentoApiRewardPointsSubscriptionStatus = {
  __typename: "RewardPointsSubscriptionStatus";
  /** Indicates whether the customer subscribes to 'Reward points balance updates' emails. */
  balance_updates: MagentoApiRewardPointsSubscriptionStatusesEnum;
  /** Indicates whether the customer subscribes to 'Reward points expiration notifications' emails. */
  points_expiration_notifications: MagentoApiRewardPointsSubscriptionStatusesEnum;
};

export type MagentoApiRewardPointsSubscriptionStatusesEnum = "NOT_SUBSCRIBED" | "SUBSCRIBED";

/** Routable entities serve as the model for a rendered page. */
export type MagentoApiRoutableInterface = {
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars["Int"]["output"];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars["String"]["output"]>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
};

/** Default implementation of RoutableInterface. This type is returned when the URL is not linked to an entity. */
export type MagentoApiRoutableUrl = MagentoApiRoutableInterface & {
  __typename: "RoutableUrl";
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars["Int"]["output"];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars["String"]["output"]>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
};

/** Defines the name and value of a SDK parameter */
export type MagentoApiSdkParams = {
  __typename: "SDKParams";
  /** The name of the SDK parameter */
  name?: Maybe<Scalars["String"]["output"]>;
  /** The value of the SDK parameter */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about a comment. */
export type MagentoApiSalesCommentItem = {
  __typename: "SalesCommentItem";
  /** The text of the message. */
  message: Scalars["String"]["output"];
  /** The timestamp of the comment. */
  timestamp: Scalars["String"]["output"];
};

export type MagentoApiSalesItemInterface = {
  __typename: "SalesItemInterface";
  /** The entered gift message for the order item */
  gift_message?: Maybe<MagentoApiGiftMessage>;
};

/** This enumeration defines the scope type for customer orders. */
export type MagentoApiScopeTypeEnum = "GLOBAL" | "STORE" | "WEBSITE";

/** Provides navigation for the query response. */
export type MagentoApiSearchResultPageInfo = {
  __typename: "SearchResultPageInfo";
  /** The specific page to return. */
  current_page?: Maybe<Scalars["Int"]["output"]>;
  /** The maximum number of items to return per page of results. */
  page_size?: Maybe<Scalars["Int"]["output"]>;
  /** The total number of pages in the response. */
  total_pages?: Maybe<Scalars["Int"]["output"]>;
};

/** A string that contains search suggestion */
export type MagentoApiSearchSuggestion = {
  __typename: "SearchSuggestion";
  /** The search suggestion of existing product. */
  search: Scalars["String"]["output"];
};

/** Contains details about a selected bundle option. */
export type MagentoApiSelectedBundleOption = {
  __typename: "SelectedBundleOption";
  /** @deprecated Use `uid` instead */
  id: Scalars["Int"]["output"];
  /** The display name of the selected bundle product option. */
  label: Scalars["String"]["output"];
  /** The type of selected bundle product option. */
  type: Scalars["String"]["output"];
  /** The unique ID for a `SelectedBundleOption` object */
  uid: Scalars["ID"]["output"];
  /** An array of selected bundle option values. */
  values: Array<Maybe<MagentoApiSelectedBundleOptionValue>>;
};

/** Contains details about a value for a selected bundle option. */
export type MagentoApiSelectedBundleOptionValue = {
  __typename: "SelectedBundleOptionValue";
  /** Use `uid` instead */
  id: Scalars["Int"]["output"];
  /** The display name of the value for the selected bundle product option. */
  label: Scalars["String"]["output"];
  /** The original price of the value for the selected bundle product option. */
  original_price: MagentoApiMoney;
  /** Provides information on the selections for presentation prices only on quote item */
  presentation_info?: Maybe<MagentoApiPresentationPrices>;
  /**
   * The price of the value for the selected bundle product option.
   * @deprecated Use priceV2 instead.
   */
  price: Scalars["Float"]["output"];
  /** The price of the value for the selected bundle product option. */
  priceV2: MagentoApiMoney;
  /** The quantity of the value for the selected bundle product option. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `SelectedBundleOptionValue` object */
  uid: Scalars["ID"]["output"];
};

/** Contains details about a selected configurable option. */
export type MagentoApiSelectedConfigurableOption = {
  __typename: "SelectedConfigurableOption";
  /** The unique ID for a `ConfigurableProductOptions` object. */
  configurable_product_option_uid: Scalars["ID"]["output"];
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  configurable_product_option_value_uid: Scalars["ID"]["output"];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_uid` instead. */
  id: Scalars["Int"]["output"];
  /** The display text for the option. */
  option_label: Scalars["String"]["output"];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_value_uid` instead. */
  value_id: Scalars["Int"]["output"];
  /** The display name of the selected configurable option. */
  value_label: Scalars["String"]["output"];
};

/** Contains details about an attribute the buyer selected. */
export type MagentoApiSelectedCustomAttributeInput = {
  /** A string that identifies the selected attribute. */
  attribute_code: Scalars["String"]["input"];
  /** The unique ID for a selected custom attribute value. */
  value: Scalars["String"]["input"];
};

/** Identifies a customized product that has been placed in a cart. */
export type MagentoApiSelectedCustomizableOption = {
  __typename: "SelectedCustomizableOption";
  /** The unique ID for a specific `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  customizable_option_uid: Scalars["ID"]["output"];
  /** @deprecated Use `SelectedCustomizableOption.customizable_option_uid` instead. */
  id: Scalars["Int"]["output"];
  /** Indicates whether the customizable option is required. */
  is_required: Scalars["Boolean"]["output"];
  /** The display name of the selected customizable option. */
  label: Scalars["String"]["output"];
  /** A value indicating the order to display this option. */
  sort_order: Scalars["Int"]["output"];
  /** The type of `CustomizableOptionInterface` object. */
  type: Scalars["String"]["output"];
  /** An array of selectable values. */
  values: Array<Maybe<MagentoApiSelectedCustomizableOptionValue>>;
};

/** Identifies the value of the selected customized option. */
export type MagentoApiSelectedCustomizableOptionValue = {
  __typename: "SelectedCustomizableOptionValue";
  /** The unique ID for a value object that corresponds to the object represented by the `customizable_option_uid` attribute. */
  customizable_option_value_uid: Scalars["ID"]["output"];
  /** @deprecated Use `SelectedCustomizableOptionValue.customizable_option_value_uid` instead. */
  id: Scalars["Int"]["output"];
  /** The display name of the selected value. */
  label: Scalars["String"]["output"];
  /** The price of the selected customizable value. */
  price: MagentoApiCartItemSelectedOptionValuePrice;
  /** The text identifying the selected value. */
  value: Scalars["String"]["output"];
};

/** Describes the payment method the shopper selected. */
export type MagentoApiSelectedPaymentMethod = {
  __typename: "SelectedPaymentMethod";
  /** The payment method code. */
  code: Scalars["String"]["output"];
  /** The purchase order number. */
  purchase_order_number?: Maybe<Scalars["String"]["output"]>;
  /** The payment method title. */
  title: Scalars["String"]["output"];
};

/** Contains details about the selected shipping method and carrier. */
export type MagentoApiSelectedShippingMethod = {
  __typename: "SelectedShippingMethod";
  /** The cost of shipping using this shipping method. */
  amount: MagentoApiMoney;
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<MagentoApiMoney>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars["String"]["output"];
  /** The label for the carrier code. */
  carrier_title: Scalars["String"]["output"];
  estimated_delivery_time?: Maybe<Scalars["String"]["output"]>;
  /** A shipping method code associated with a carrier. */
  method_code: Scalars["String"]["output"];
  /** The label for the method code. */
  method_title: Scalars["String"]["output"];
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: MagentoApiMoney;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: MagentoApiMoney;
};

/** Defines the referenced product and the email sender and recipients. */
export type MagentoApiSendEmailToFriendInput = {
  /** The ID of the product that the sender is referencing. */
  product_id: Scalars["Int"]["input"];
  /** An array containing information about each recipient. */
  recipients: Array<InputMaybe<MagentoApiSendEmailToFriendRecipientInput>>;
  /** Information about the customer and the content of the message. */
  sender: MagentoApiSendEmailToFriendSenderInput;
};

/** Contains information about the sender and recipients. */
export type MagentoApiSendEmailToFriendOutput = {
  __typename: "SendEmailToFriendOutput";
  /** An array containing information about each recipient. */
  recipients?: Maybe<Array<Maybe<MagentoApiSendEmailToFriendRecipient>>>;
  /** Information about the customer and the content of the message. */
  sender?: Maybe<MagentoApiSendEmailToFriendSender>;
};

/** An output object that contains information about the recipient. */
export type MagentoApiSendEmailToFriendRecipient = {
  __typename: "SendEmailToFriendRecipient";
  /** The email address of the recipient. */
  email: Scalars["String"]["output"];
  /** The name of the recipient. */
  name: Scalars["String"]["output"];
};

/** Contains details about a recipient. */
export type MagentoApiSendEmailToFriendRecipientInput = {
  /** The email address of the recipient. */
  email: Scalars["String"]["input"];
  /** The name of the recipient. */
  name: Scalars["String"]["input"];
};

/** An output object that contains information about the sender. */
export type MagentoApiSendEmailToFriendSender = {
  __typename: "SendEmailToFriendSender";
  /** The email address of the sender. */
  email: Scalars["String"]["output"];
  /** The text of the message to be sent. */
  message: Scalars["String"]["output"];
  /** The name of the sender. */
  name: Scalars["String"]["output"];
};

/** Contains details about the sender. */
export type MagentoApiSendEmailToFriendSenderInput = {
  /** The email address of the sender. */
  email: Scalars["String"]["input"];
  /** The text of the message to be sent. */
  message: Scalars["String"]["input"];
  /** The name of the sender. */
  name: Scalars["String"]["input"];
};

/** Contains details about the configuration of the Email to a Friend feature. */
export type MagentoApiSendFriendConfiguration = {
  __typename: "SendFriendConfiguration";
  /** Indicates whether the Email to a Friend feature is enabled. */
  enabled_for_customers: Scalars["Boolean"]["output"];
  /** Indicates whether the Email to a Friend feature is enabled for guests. */
  enabled_for_guests: Scalars["Boolean"]["output"];
};

export type MagentoApiSetAdditionalAttributesError = {
  __typename: "SetAdditionalAttributesError";
  code: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type MagentoApiSetAdditionalAttributesInput = {
  additional_attributes: Array<InputMaybe<MagentoApiQuoteAttributeInput>>;
  /** Masked cart ID */
  cart_id: Scalars["String"]["input"];
};

export type MagentoApiSetAdditionalAttributesOutput = {
  __typename: "SetAdditionalAttributesOutput";
  errors: Array<Maybe<MagentoApiSetAdditionalAttributesError>>;
};

/** Sets the billing address. */
export type MagentoApiSetBillingAddressOnCartInput = {
  /** The billing address. */
  billing_address: MagentoApiBillingAddressInput;
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
};

/** Contains details about the cart after setting the billing address. */
export type MagentoApiSetBillingAddressOnCartOutput = {
  __typename: "SetBillingAddressOnCartOutput";
  /** The cart after setting the billing address. */
  cart: MagentoApiCart;
};

/** Sets the cart as inactive */
export type MagentoApiSetCartAsInactiveOutput = {
  __typename: "SetCartAsInactiveOutput";
  /** The error message returned after failing to set the cart as inactive */
  error?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the cart was set as inactive */
  success: Scalars["Boolean"]["output"];
};

/** Defines the gift options applied to the cart. */
export type MagentoApiSetGiftOptionsOnCartInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars["String"]["input"];
  /** Gift message details for the cart. */
  gift_message?: InputMaybe<MagentoApiGiftMessageInput>;
  /** Whether customer requested gift receipt for the cart. */
  gift_receipt_included: Scalars["Boolean"]["input"];
  /** The unique ID for a `GiftWrapping` object to be used for the cart. */
  gift_wrapping_id?: InputMaybe<Scalars["ID"]["input"]>;
  /** Whether customer requested printed card for the cart. */
  printed_card_included: Scalars["Boolean"]["input"];
};

/** Contains the cart after gift options have been applied. */
export type MagentoApiSetGiftOptionsOnCartOutput = {
  __typename: "SetGiftOptionsOnCartOutput";
  /** The modified cart object. */
  cart: MagentoApiCart;
};

/** Defines the guest email and cart. */
export type MagentoApiSetGuestEmailOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** The email address of the guest. */
  email: Scalars["String"]["input"];
};

/** Contains details about the cart after setting the email of a guest. */
export type MagentoApiSetGuestEmailOnCartOutput = {
  __typename: "SetGuestEmailOnCartOutput";
  /** The cart after setting the guest email. */
  cart: MagentoApiCart;
};

/** Applies a payment method to the quote. */
export type MagentoApiSetPaymentMethodAndPlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** The payment method data to apply to the cart. */
  payment_method: MagentoApiPaymentMethodInput;
};

/** Applies a payment method to the cart. */
export type MagentoApiSetPaymentMethodOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** The payment method data to apply to the cart. */
  payment_method: MagentoApiPaymentMethodInput;
};

/** Contains details about the cart after setting the payment method. */
export type MagentoApiSetPaymentMethodOnCartOutput = {
  __typename: "SetPaymentMethodOnCartOutput";
  /** The cart after setting the payment method. */
  cart: MagentoApiCart;
};

/** Specifies an array of addresses to use for shipping. */
export type MagentoApiSetShippingAddressesOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of shipping addresses. */
  shipping_addresses: Array<InputMaybe<MagentoApiShippingAddressInput>>;
};

/** Contains details about the cart after setting the shipping addresses. */
export type MagentoApiSetShippingAddressesOnCartOutput = {
  __typename: "SetShippingAddressesOnCartOutput";
  /** The cart after setting the shipping addresses. */
  cart: MagentoApiCart;
};

/** Applies one or shipping methods to the cart. */
export type MagentoApiSetShippingMethodsOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of shipping methods. */
  shipping_methods: Array<InputMaybe<MagentoApiShippingMethodInput>>;
};

/** Contains details about the cart after setting the shipping methods. */
export type MagentoApiSetShippingMethodsOnCartOutput = {
  __typename: "SetShippingMethodsOnCartOutput";
  /** The cart after setting the shipping methods. */
  cart: MagentoApiCart;
};

/** Defines a gift registry invitee. */
export type MagentoApiShareGiftRegistryInviteeInput = {
  /** The email address of the gift registry invitee. */
  email: Scalars["String"]["input"];
  /** The name of the gift registry invitee. */
  name: Scalars["String"]["input"];
};

/** Contains the results of a request to share a gift registry. */
export type MagentoApiShareGiftRegistryOutput = {
  __typename: "ShareGiftRegistryOutput";
  /** Indicates whether the gift registry was successfully shared. */
  is_shared: Scalars["Boolean"]["output"];
};

/** Defines the sender of an invitation to view a gift registry. */
export type MagentoApiShareGiftRegistrySenderInput = {
  /** A brief message from the sender. */
  message: Scalars["String"]["input"];
  /** The sender of the gift registry invitation. */
  name: Scalars["String"]["input"];
};

/** Defines whether bundle items must be shipped together. */
export type MagentoApiShipBundleItemsEnum = "SEPARATELY" | "TOGETHER";

export type MagentoApiShipmentItem = MagentoApiShipmentItemInterface & {
  __typename: "ShipmentItem";
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of shipped items. */
  quantity_shipped: Scalars["Float"]["output"];
};

/** Order shipment item details. */
export type MagentoApiShipmentItemInterface = {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<MagentoApiOrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product. */
  product_sale_price: MagentoApiMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of shipped items. */
  quantity_shipped: Scalars["Float"]["output"];
};

/** Contains order shipment tracking details. */
export type MagentoApiShipmentTracking = {
  __typename: "ShipmentTracking";
  /** The shipping carrier for the order delivery. */
  carrier: Scalars["String"]["output"];
  /** The tracking number of the order shipment. */
  number?: Maybe<Scalars["String"]["output"]>;
  /** The shipment tracking title. */
  title: Scalars["String"]["output"];
  /** The tracking URL of the order shipment. */
  track_url?: Maybe<Scalars["String"]["output"]>;
};

/** Defines a single shipping address. */
export type MagentoApiShippingAddressInput = {
  /** Defines a shipping address. */
  address?: InputMaybe<MagentoApiCartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for shipping. */
  customer_address_id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Text provided by the shopper. */
  customer_notes?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains shipping addresses and methods. */
export type MagentoApiShippingCartAddress = MagentoApiCartAddressInterface & {
  __typename: "ShippingCartAddress";
  /** Administrative area level 2 */
  administrative_area_level_2?: Maybe<Scalars["String"]["output"]>;
  /** An array that lists the shipping methods that can be applied to the cart. */
  available_shipping_methods?: Maybe<Array<Maybe<MagentoApiAvailableShippingMethod>>>;
  /** Building Number */
  building_number?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `cart_items_v2` instead. */
  cart_items?: Maybe<Array<Maybe<MagentoApiCartItemQuantity>>>;
  /** An array that lists the items in the cart. */
  cart_items_v2?: Maybe<Array<Maybe<MagentoApiCartItemInterface>>>;
  /** The city specified for the billing or shipping address. */
  city: Scalars["String"]["output"];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars["String"]["output"]>;
  /** An object containing the country label and code. */
  country: MagentoApiCartAddressCountry;
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes: Array<Maybe<MagentoApiAttributeValueInterface>>;
  /** Text provided by the shopper. */
  customer_notes?: Maybe<Scalars["String"]["output"]>;
  /** District */
  district?: Maybe<Scalars["String"]["output"]>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars["String"]["output"]>;
  /** The first name of the customer or guest. */
  firstname?: Maybe<Scalars["String"]["output"]>;
  /** Apartment, floor, building, etc. */
  house_details?: Maybe<Scalars["String"]["output"]>;
  /** Id of the customer address. */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** States if the selected address is a pickup address */
  is_pickup_address?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated This information should not be exposed on the frontend. */
  items_weight?: Maybe<Scalars["Float"]["output"]>;
  /** Landmark */
  landmark?: Maybe<Scalars["String"]["output"]>;
  /** The last name of the customer or guest. */
  lastname: Scalars["String"]["output"];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: Maybe<Scalars["String"]["output"]>;
  /** Neighborhood */
  neighborhood?: Maybe<Scalars["String"]["output"]>;
  /** JSON encoded string of required fields like store id etc for the pickup point */
  pickup_information?: Maybe<Scalars["String"]["output"]>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars["String"]["output"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars["String"]["output"]>;
  /** Premise */
  premise?: Maybe<Scalars["String"]["output"]>;
  /** An object containing the region label and code. */
  region?: Maybe<MagentoApiCartAddressRegion>;
  /** Indicates whether the shipping address is same as billing address. */
  same_as_billing: Scalars["Boolean"]["output"];
  /** An object that describes the selected shipping method. */
  selected_shipping_method?: Maybe<MagentoApiSelectedShippingMethod>;
  /** Short National Address */
  short_address?: Maybe<Scalars["String"]["output"]>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars["String"]["output"]>>;
  /** Street number */
  street_nr?: Maybe<Scalars["String"]["output"]>;
  /** Sublocality level 2 */
  sublocality_level_2?: Maybe<Scalars["String"]["output"]>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars["String"]["output"]>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars["String"]["output"]>;
  /** The unique id of the customer address. */
  uid: Scalars["String"]["output"];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars["String"]["output"]>;
};

/** Defines an individual shipping discount. This discount can be applied to shipping. */
export type MagentoApiShippingDiscount = {
  __typename: "ShippingDiscount";
  /** The amount of the discount. */
  amount: MagentoApiMoney;
};

/** Contains details about shipping and handling costs. */
export type MagentoApiShippingHandling = {
  __typename: "ShippingHandling";
  /** The shipping amount, excluding tax. */
  amount_excluding_tax?: Maybe<MagentoApiMoney>;
  /** The shipping amount, including tax. */
  amount_including_tax?: Maybe<MagentoApiMoney>;
  /** The applied discounts to the shipping. */
  discounts?: Maybe<Array<Maybe<MagentoApiShippingDiscount>>>;
  /** Details about taxes applied for shipping. */
  taxes?: Maybe<Array<Maybe<MagentoApiTaxItem>>>;
  /** The total amount for shipping. */
  total_amount: MagentoApiMoney;
};

/** Defines the shipping carrier and method. */
export type MagentoApiShippingMethodInput = {
  /** A string that identifies a commercial carrier or an offline delivery method. */
  carrier_code: Scalars["String"]["input"];
  /** A string that indicates which service a commercial carrier will use to ship items. For offline delivery methods, this value is similar to the label displayed on the checkout page. */
  method_code: Scalars["String"]["input"];
};

/** An implementation for simple product cart items. */
export type MagentoApiSimpleCartItem = MagentoApiCartItemInterface & {
  __typename: "SimpleCartItem";
  /** The list of available gift wrapping options for the cart item. */
  available_gift_wrapping: Array<Maybe<MagentoApiGiftWrapping>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<MagentoApiCartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<MagentoApiGiftMessage>;
  /** The selected gift wrapping for the cart item. */
  gift_wrapping?: Maybe<MagentoApiGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiCartItemPrices>;
  /** Details about an item in the cart. */
  product: MagentoApiProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type MagentoApiSimpleProduct = MagentoApiCustomizableProductInterface &
  MagentoApiPhysicalProductInterface &
  MagentoApiProductInterface &
  MagentoApiRoutableInterface & {
    __typename: "SimpleProduct";
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer?: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<MagentoApiCategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1?: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2?: Maybe<MagentoApiProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code?: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family?: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<MagentoApiFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula?: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts?: Maybe<MagentoApiFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes?: Maybe<Array<Maybe<MagentoApiFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price?: Maybe<MagentoApiMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device?: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image?: Maybe<MagentoApiProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal?: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent?: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MagentoApiMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MagentoApiMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type?: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description?: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label?: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price?: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled?: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model?: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks?: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand?: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<MagentoApiCustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<MagentoApiProductPrices>;
    /** The range of prices for the product */
    price_range: MagentoApiPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<MagentoApiTierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand?: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation?: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<MagentoApiProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province?: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label?: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity?: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category?: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region?: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label?: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible?: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: MagentoApiProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<MagentoApiProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility?: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status?: Maybe<MagentoApiProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details?: Maybe<MagentoApiStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<MagentoApiProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<MagentoApiProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka?: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku?: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label?: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<MagentoApiUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage?: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<MagentoApiWebsite>>>;
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars["Float"]["output"]>;
  };

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type MagentoApiSimpleProductCustom_AttributesV2Args = {
  filters?: InputMaybe<MagentoApiAttributeFilterInput>;
};

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type MagentoApiSimpleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Defines a single product to add to the cart. */
export type MagentoApiSimpleProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<MagentoApiCustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: MagentoApiCartItemInput;
};

/** Contains a simple product wish list item. */
export type MagentoApiSimpleWishlistItem = MagentoApiWishlistItemInterface & {
  __typename: "SimpleWishlistItem";
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

/** Smart button payment inputs */
export type MagentoApiSmartButtonMethodInput = {
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars["String"]["input"]>;
  /** The payment services order ID */
  payments_order_id?: InputMaybe<Scalars["String"]["input"]>;
  /** PayPal order ID */
  paypal_order_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type MagentoApiSmartButtonsConfig = MagentoApiPaymentConfigItem & {
  __typename: "SmartButtonsConfig";
  /** Indicated whether to use App Switch on enabled mobile devices */
  app_switch_when_available?: Maybe<Scalars["Boolean"]["output"]>;
  /** The styles for the PayPal Smart Button configuration */
  button_styles?: Maybe<MagentoApiButtonStyles>;
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether to display the PayPal Pay Later message */
  display_message?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether to display Venmo */
  display_venmo?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars["Boolean"]["output"]>;
  /** Contains details about the styles for the PayPal Pay Later message */
  message_styles?: Maybe<MagentoApiMessageStyles>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<MagentoApiSdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars["String"]["output"]>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Indicates whether to return results in ascending or descending order. */
export type MagentoApiSortEnum = "ASC" | "DESC";

/** Defines a possible sort field. */
export type MagentoApiSortField = {
  __typename: "SortField";
  /** The label of the sort field. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The attribute code of the sort field. */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Contains a default value for sort fields and all available sort fields. */
export type MagentoApiSortFields = {
  __typename: "SortFields";
  /** The default sort field value. */
  default?: Maybe<Scalars["String"]["output"]>;
  /** An array of possible sort fields. */
  options?: Maybe<Array<Maybe<MagentoApiSortField>>>;
};

/** Specifies the field to use for sorting quote items */
export type MagentoApiSortQuoteItemsEnum =
  | "BASE_DISCOUNT_AMOUNT"
  | "BASE_DISCOUNT_TAX_COMPENSATION_AMOUNT"
  | "BASE_PRICE"
  | "BASE_PRICE_INC_TAX"
  | "BASE_ROW_TOTAL"
  | "BASE_ROW_TOTAL_INC_TAX"
  | "BASE_TAX_AMOUNT"
  | "BASE_TAX_BEFORE_DISCOUNT"
  | "CREATED_AT"
  | "CUSTOM_PRICE"
  | "DESCRIPTION"
  | "DISCOUNT_AMOUNT"
  | "DISCOUNT_PERCENT"
  | "DISCOUNT_TAX_COMPENSATION_AMOUNT"
  | "FREE_SHIPPING"
  | "ITEM_ID"
  | "NAME"
  | "ORIGINAL_CUSTOM_PRICE"
  | "PRICE"
  | "PRICE_INC_TAX"
  | "PRODUCT_ID"
  | "PRODUCT_TYPE"
  | "QTY"
  | "ROW_TOTAL"
  | "ROW_TOTAL_INC_TAX"
  | "ROW_TOTAL_WITH_DISCOUNT"
  | "ROW_WEIGHT"
  | "SKU"
  | "TAX_AMOUNT"
  | "TAX_BEFORE_DISCOUNT"
  | "TAX_PERCENT"
  | "UPDATED_AT"
  | "WEIGHT";

export type MagentoApiSpecialOffer = {
  __typename: "SpecialOffer";
  /** Promotional Campaign changeable code/indentifier */
  code: Scalars["String"]["output"];
  /** Promotional Campaign description type */
  description?: Maybe<MagentoApiSpecialOfferDescription>;
  /** Promotional Campaign can be used by customer or not */
  eligible: Scalars["Boolean"]["output"];
  /** Maximum uses per user */
  limit_qty?: Maybe<Scalars["Int"]["output"]>;
  /** Promotional Campaign can be POTENTIALLY used by customer or not */
  potentially_eligible: Scalars["Boolean"]["output"];
  /** Promotional Campaign applicable products */
  skus?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** Promotion type */
  type: MagentoApiSpecialOfferTypeEnum;
};

export type MagentoApiSpecialOfferDescription = {
  __typename: "SpecialOfferDescription";
  /** Promotional Campaign description */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Promotional Campaign hint */
  hint?: Maybe<Scalars["String"]["output"]>;
  /** Promotional Campaign label */
  label?: Maybe<Scalars["String"]["output"]>;
  /** Promotional Campaign title */
  title?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiSpecialOfferList = {
  __typename: "SpecialOfferList";
  /** List of promotional campaigns */
  items?: Maybe<Array<Maybe<MagentoApiSpecialOffer>>>;
};

export type MagentoApiSpecialOfferTypeEnum = "conditional_purchase" | "free_gift_fixed" | "free_gift_flexible";

export type MagentoApiStatusReason = {
  __typename: "StatusReason";
  reason_code: Scalars["String"]["output"];
  reason_message: Scalars["String"]["output"];
};

export type MagentoApiStick = {
  __typename: "Stick";
  /** Flavour attribute ID. */
  flavour?: Maybe<Scalars["Int"]["output"]>;
  /** Flavour attribute label. */
  flavour_label?: Maybe<Scalars["String"]["output"]>;
  /** The SKU of the stick product. */
  sku?: Maybe<Scalars["String"]["output"]>;
  /** The Color Swatch Data in Hex of the stick product. */
  swatch_data?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiSticksMatrix = {
  __typename: "SticksMatrix";
  /** Carton configuration. */
  cartons: MagentoApiSticksPeriod;
  /** Mix-n-match configuration. */
  mix_n_match: MagentoApiSticksPeriod;
  /** Single packs configuration. */
  single_packs: MagentoApiSticksPeriod;
};

export type MagentoApiSticksPeriod = {
  __typename: "SticksPeriod";
  /** Onetime sticks configuration. */
  onetime: Array<Maybe<MagentoApiStick>>;
  /** Subscription sticks configuration. */
  subscription: Array<Maybe<MagentoApiStick>>;
};

/** Contains information about a store's configuration. */
export type MagentoApiStoreConfig = {
  __typename: "StoreConfig";
  /** Contains scripts that must be included in the HTML before the closing `<body>` tag. */
  absolute_footer?: Maybe<Scalars["String"]["output"]>;
  /** Configured age verification journey mode */
  age_verification_mode: MagentoApiAgeVerificationMode;
  /** If allowed empty firstname */
  allow_empty_firstname?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates if the gift sender has the option to send a gift receipt. Possible values: 1 (Yes) and 0 (No). */
  allow_gift_receipt?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether gift wrapping can be added for the entire order. Possible values: 1 (Yes) and 0 (No). */
  allow_gift_wrapping_on_order?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether gift wrapping can be added for individual order items. Possible values: 1 (Yes) and 0 (No). */
  allow_gift_wrapping_on_order_items?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether guest users can write product reviews. Possible values: 1 (Yes) and 0 (No). */
  allow_guests_to_write_product_reviews?: Maybe<Scalars["String"]["output"]>;
  /** The value of the Allow Gift Messages for Order Items option */
  allow_items?: Maybe<Scalars["String"]["output"]>;
  /** The value of the Allow Gift Messages on Order Level option */
  allow_order?: Maybe<Scalars["String"]["output"]>;
  /** Indicates if a printed card can accompany an order. Possible values: 1 (Yes) and 0 (No). */
  allow_printed_card?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether to enable autocomplete on login and forgot password forms. */
  autocomplete_on_storefront?: Maybe<Scalars["Boolean"]["output"]>;
  /** The base currency code. */
  base_currency_code?: Maybe<Scalars["String"]["output"]>;
  /** A fully-qualified URL that is used to create relative links to the `base_url`. */
  base_link_url?: Maybe<Scalars["String"]["output"]>;
  /** The fully-qualified URL that specifies the location of media files. */
  base_media_url?: Maybe<Scalars["String"]["output"]>;
  /** The fully-qualified URL that specifies the location of static view files. */
  base_static_url?: Maybe<Scalars["String"]["output"]>;
  /** The store’s fully-qualified base URL. */
  base_url?: Maybe<Scalars["String"]["output"]>;
  /** checkout/cart/delete_quote_after: quote lifetime in days. */
  cart_expires_in_days?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates if gift wrapping prices are displayed on the Shopping Cart page. Possible values: 1 (Yes) and 0 (No). */
  cart_gift_wrapping?: Maybe<Scalars["String"]["output"]>;
  /** Indicates if printed card prices are displayed on the Shopping Cart page. Possible values: 1 (Yes) and 0 (No). */
  cart_printed_card?: Maybe<Scalars["String"]["output"]>;
  /** checkout/cart_link/use_qty: what to show in the display cart summary, number of items or item quantities. */
  cart_summary_display_quantity?: Maybe<Scalars["Int"]["output"]>;
  /** Cartons limit value */
  cartons_limit_value?: Maybe<Scalars["Int"]["output"]>;
  /** The default sort order of the search results list. */
  catalog_default_sort_by?: Maybe<Scalars["String"]["output"]>;
  /** Corresponds to the 'Display Prices In Product Lists' field in the Admin. It indicates how FPT information is displayed on category pages. */
  category_fixed_product_tax_display_setting?: Maybe<MagentoApiFixedProductTaxDisplaySettings>;
  /** The suffix applied to category pages, such as `.htm` or `.html`. */
  category_url_suffix?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether only specific countries can use this payment method. */
  check_money_order_enable_for_specific_countries?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the Check/Money Order payment method is enabled. */
  check_money_order_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** The name of the party to whom the check must be payable. */
  check_money_order_make_check_payable_to?: Maybe<Scalars["String"]["output"]>;
  /** The maximum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_max_order_total?: Maybe<Scalars["String"]["output"]>;
  /** The minimum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_min_order_total?: Maybe<Scalars["String"]["output"]>;
  /** The status of new orders placed using the Check/Money Order payment method. */
  check_money_order_new_order_status?: Maybe<Scalars["String"]["output"]>;
  /** A comma-separated list of specific countries allowed to use the Check/Money Order payment method. */
  check_money_order_payment_from_specific_countries?: Maybe<Scalars["String"]["output"]>;
  /** The full street address or PO Box where the checks are mailed. */
  check_money_order_send_check_to?: Maybe<Scalars["String"]["output"]>;
  /** A number indicating the position of the Check/Money Order payment method in the list of available payment methods during checkout. */
  check_money_order_sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The title of the Check/Money Order payment method displayed on the storefront. */
  check_money_order_title?: Maybe<Scalars["String"]["output"]>;
  /** The name of the CMS page that identifies the home page for the store. */
  cms_home_page?: Maybe<Scalars["String"]["output"]>;
  /** A specific CMS page that displays when cookies are not enabled for the browser. */
  cms_no_cookies?: Maybe<Scalars["String"]["output"]>;
  /** A specific CMS page that displays when a 404 'Page Not Found' error occurs. */
  cms_no_route?: Maybe<Scalars["String"]["output"]>;
  /**
   * A code assigned to the store to identify it.
   * @deprecated Use `store_code` instead.
   */
  code?: Maybe<Scalars["String"]["output"]>;
  /** checkout/cart/configurable_product_image: which image to use for configurable products. */
  configurable_product_image: MagentoApiProductImageThumbnail;
  /** Indicates whether the `parent` or child (`itself`) thumbnail should be used in the cart for configurable products. */
  configurable_thumbnail_source?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the Contact Us form in enabled. */
  contact_enabled: Scalars["Boolean"]["output"];
  /** The copyright statement that appears at the bottom of each page. */
  copyright?: Maybe<Scalars["String"]["output"]>;
  /** Extended Config Data - general/region/state_required */
  countries_with_required_region?: Maybe<Scalars["String"]["output"]>;
  /** Indicates if the new accounts need confirmation. */
  create_account_confirmation?: Maybe<Scalars["Boolean"]["output"]>;
  /** Query by creditmemo_creditmemo_enabled. */
  creditmemo_creditmemo_enabled?: Maybe<Scalars["String"]["output"]>;
  /** Customer access token lifetime. */
  customer_access_token_lifetime?: Maybe<Scalars["Float"]["output"]>;
  /** Extended Config Data - general/country/default */
  default_country?: Maybe<Scalars["String"]["output"]>;
  /** The description that provides a summary of your site for search engine listings. It should not be more than 160 characters in length. */
  default_description?: Maybe<Scalars["String"]["output"]>;
  /** The default display currency code. */
  default_display_currency_code?: Maybe<Scalars["String"]["output"]>;
  /** A series of keywords that describe your store, each separated by a comma. */
  default_keywords?: Maybe<Scalars["String"]["output"]>;
  /** The title that appears at the title bar of each page when viewed in a browser. */
  default_title?: Maybe<Scalars["String"]["output"]>;
  /** Controls the display of the demo store notice at the top of the page. Options: 0 (No) or 1 (Yes). */
  demonotice?: Maybe<Scalars["Int"]["output"]>;
  /** Configuration data from tax/display/type */
  display_product_prices_in_catalog: Scalars["Int"]["output"];
  /** Configuration data from tax/display/shipping */
  display_shipping_prices: Scalars["Int"]["output"];
  /** Extended Config Data - general/region/display_all */
  display_state_if_optional?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether customers can have multiple wish lists. Possible values: 1 (Yes) and 0 (No). */
  enable_multiple_wishlists?: Maybe<Scalars["String"]["output"]>;
  /** Configuration data from tax/weee/apply_vat */
  fixed_product_taxes_apply_tax_to_fpt: Scalars["Boolean"]["output"];
  /** Configuration data from tax/weee/display_email */
  fixed_product_taxes_display_prices_in_emails: Scalars["Int"]["output"];
  /** Configuration data from tax/weee/display_list */
  fixed_product_taxes_display_prices_in_product_lists: Scalars["Int"]["output"];
  /** Configuration data from tax/weee/display_sales */
  fixed_product_taxes_display_prices_in_sales_modules: Scalars["Int"]["output"];
  /** Configuration data from tax/weee/display */
  fixed_product_taxes_display_prices_on_product_view_page: Scalars["Int"]["output"];
  /** Configuration data from tax/weee/enable */
  fixed_product_taxes_enable: Scalars["Boolean"]["output"];
  /** Configuration data from tax/weee/include_in_subtotal */
  fixed_product_taxes_include_fpt_in_subtotal: Scalars["Boolean"]["output"];
  /** The landing page that is associated with the base URL. */
  front?: Maybe<Scalars["String"]["output"]>;
  /** Provides total amount of gifts in the basket */
  gift_basket_quantity_limitation?: Maybe<Scalars["String"]["output"]>;
  /** The default number of products per page in Grid View. */
  grid_per_page?: Maybe<Scalars["Int"]["output"]>;
  /** A list of numbers that define how many products can be displayed in Grid View. */
  grid_per_page_values?: Maybe<Scalars["String"]["output"]>;
  /** checkout/cart/grouped_product_image: which image to use for grouped products. */
  grouped_product_image: MagentoApiProductImageThumbnail;
  /** Scripts that must be included in the HTML before the closing `<head>` tag. */
  head_includes?: Maybe<Scalars["String"]["output"]>;
  /** The small graphic image (favicon) that appears in the address bar and tab of the browser. */
  head_shortcut_icon?: Maybe<Scalars["String"]["output"]>;
  /** The path to the logo that appears in the header. */
  header_logo_src?: Maybe<Scalars["String"]["output"]>;
  /**
   * The ID number assigned to the store.
   * @deprecated Use `store_code` instead.
   */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** Is 2FA verification module enabled */
  is_2fa_verification_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is 2FA verification logging enabled */
  is_2fa_verification_logging_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether cart-level age verification is enabled */
  is_age_verification_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is age verification logging enabled */
  is_age_verification_logging_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Configuration data from checkout/options/enable_agreements */
  is_checkout_agreements_enabled: Scalars["Boolean"]["output"];
  /** Is order filtering enabled in customer area */
  is_customer_area_order_filtering_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the store view has been designated as the default within the store group. */
  is_default_store?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the store group has been designated as the default within the website. */
  is_default_store_group?: Maybe<Scalars["Boolean"]["output"]>;
  /** Provides the flag to show if gifts are enabled or not */
  is_free_gifts_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** checkout/options/guest_checkout: whether the guest checkout is enabled or not. */
  is_guest_checkout_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** checkout/options/onepage_checkout_enabled: whether the one page checkout is enabled or not */
  is_one_page_checkout_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is order limit module enabled */
  is_order_limit_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is order value limit enabled */
  is_order_value_limit_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** The format of the search results list. */
  list_mode?: Maybe<Scalars["String"]["output"]>;
  /** The default number of products per page in List View. */
  list_per_page?: Maybe<Scalars["Int"]["output"]>;
  /** A list of numbers that define how many products can be displayed in List View. */
  list_per_page_values?: Maybe<Scalars["String"]["output"]>;
  /** The store locale. */
  locale?: Maybe<Scalars["String"]["output"]>;
  /** The Alt text that is associated with the logo. */
  logo_alt?: Maybe<Scalars["String"]["output"]>;
  /** The height of the logo image, in pixels. */
  logo_height?: Maybe<Scalars["Int"]["output"]>;
  /** The width of the logo image, in pixels. */
  logo_width?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether reward points functionality is enabled. Possible values: 1 (Enabled) and 0 (Disabled). */
  magento_reward_general_is_enabled?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether reward points functionality is enabled on the storefront. Possible values: 1 (Enabled) and 0 (Disabled). */
  magento_reward_general_is_enabled_on_front?: Maybe<Scalars["String"]["output"]>;
  /** The minimum point balance customers must have before they can redeem them. A null value indicates no minimum. */
  magento_reward_general_min_points_balance?: Maybe<Scalars["String"]["output"]>;
  /** When enabled, customers can see a detailed history of their reward points. Possible values: 1 (Enabled) and 0 (Disabled). */
  magento_reward_general_publish_history?: Maybe<Scalars["String"]["output"]>;
  /** The number of points for a referral when an invitee registers on the site. */
  magento_reward_points_invitation_customer?: Maybe<Scalars["String"]["output"]>;
  /** The maximum number of registration referrals that will qualify for rewards. A null value indicates no limit. */
  magento_reward_points_invitation_customer_limit?: Maybe<Scalars["String"]["output"]>;
  /** The number of points for a referral, when an invitee places their first order on the site. */
  magento_reward_points_invitation_order?: Maybe<Scalars["String"]["output"]>;
  /** The number of order conversions that can earn points for the customer who sends the invitation. A null value indicates no limit. */
  magento_reward_points_invitation_order_limit?: Maybe<Scalars["String"]["output"]>;
  /** The number of points earned by registered customers who subscribe to a newsletter. */
  magento_reward_points_newsletter?: Maybe<Scalars["String"]["output"]>;
  /** Indicates customers earn points for shopping according to the reward point exchange rate. In Luma, this also controls whether to show a message in the shopping cart about the rewards points earned for the purchase, as well as the customer’s current reward point balance. */
  magento_reward_points_order?: Maybe<Scalars["String"]["output"]>;
  /** The number of points customer gets for registering. */
  magento_reward_points_register?: Maybe<Scalars["String"]["output"]>;
  /** The number of points for writing a review. */
  magento_reward_points_review?: Maybe<Scalars["String"]["output"]>;
  /** The maximum number of reviews that will qualify for the rewards. A null value indicates no limit. */
  magento_reward_points_review_limit?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether wishlists are enabled (1) or disabled (0). */
  magento_wishlist_general_is_enabled?: Maybe<Scalars["String"]["output"]>;
  /** checkout/options/max_items_display_count: maximum number of items to display in order summary. */
  max_items_in_order_summary?: Maybe<Scalars["Int"]["output"]>;
  /** If multiple wish lists are enabled, the maximum number of wish lists the customer can have. */
  maximum_number_of_wishlists?: Maybe<Scalars["String"]["output"]>;
  /** checkout/sidebar/display: whether to display the minicart or not. */
  minicart_display?: Maybe<Scalars["Boolean"]["output"]>;
  /** checkout/sidebar/count: maximum number of items to show in minicart. */
  minicart_max_items?: Maybe<Scalars["Int"]["output"]>;
  /** The minimum number of characters required for a valid password. */
  minimum_password_length?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether newsletters are enabled. */
  newsletter_enabled: Scalars["Boolean"]["output"];
  /** The default page that displays when a 404 'Page not Found' error occurs. */
  no_route?: Maybe<Scalars["String"]["output"]>;
  /** Extended Config Data - general/country/optional_zip_countries */
  optional_zip_countries?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether orders can be cancelled by customers or not. */
  order_cancellation_enabled: Scalars["Boolean"]["output"];
  /** An array containing available cancellation reasons. */
  order_cancellation_reasons: Array<Maybe<MagentoApiCancellationReason>>;
  /** Order limit value */
  order_limit_value?: Maybe<Scalars["Float"]["output"]>;
  /** Configuration data from tax/sales_display/full_summary */
  orders_invoices_credit_memos_display_full_summary: Scalars["Boolean"]["output"];
  /** Configuration data from tax/sales_display/grandtotal */
  orders_invoices_credit_memos_display_grandtotal: Scalars["Boolean"]["output"];
  /** Configuration data from tax/sales_display/price */
  orders_invoices_credit_memos_display_price: Scalars["Int"]["output"];
  /** Configuration data from tax/sales_display/shipping */
  orders_invoices_credit_memos_display_shipping_amount: Scalars["Int"]["output"];
  /** Configuration data from tax/sales_display/subtotal */
  orders_invoices_credit_memos_display_subtotal: Scalars["Int"]["output"];
  /** Configuration data from tax/sales_display/zero_tax */
  orders_invoices_credit_memos_display_zero_tax: Scalars["Boolean"]["output"];
  /** Payflow Pro vault status. */
  payment_payflowpro_cc_vault_active?: Maybe<Scalars["String"]["output"]>;
  /** Is postcode required / mandatory */
  postcode_is_required?: Maybe<Scalars["Boolean"]["output"]>;
  /** Postcode max value length */
  postcode_max_length?: Maybe<Scalars["Int"]["output"]>;
  /** Postcode min value length */
  postcode_min_length?: Maybe<Scalars["Int"]["output"]>;
  /** Postcode regex pattern validate */
  postcode_validate_regex?: Maybe<Scalars["String"]["output"]>;
  /** Is postcode validation enabled */
  postcode_validation_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The default price of a printed card that accompanies an order.
   * @deprecated Use printed_card_priceV2 instead
   */
  printed_card_price?: Maybe<Scalars["String"]["output"]>;
  /** The default price of a printed card that accompanies an order. */
  printed_card_priceV2?: Maybe<MagentoApiMoney>;
  /** Corresponds to the 'Display Prices On Product View Page' field in the Admin. It indicates how FPT information is displayed on product pages. */
  product_fixed_product_tax_display_setting?: Maybe<MagentoApiFixedProductTaxDisplaySettings>;
  /** Indicates whether product reviews are enabled. Possible values: 1 (Yes) and 0 (No). */
  product_reviews_enabled?: Maybe<Scalars["String"]["output"]>;
  /** The suffix applied to product pages, such as `.htm` or `.html`. */
  product_url_suffix?: Maybe<Scalars["String"]["output"]>;
  /** The number of different character classes (lowercase, uppercase, digits, special characters) required in a password. */
  required_character_classes_number?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether RMA is enabled on the storefront. Possible values: enabled/disabled. */
  returns_enabled: Scalars["String"]["output"];
  /**
   * The ID of the root category.
   * @deprecated Use `root_category_uid` instead.
   */
  root_category_id?: Maybe<Scalars["Int"]["output"]>;
  /** The unique ID for a `CategoryInterface` object. */
  root_category_uid?: Maybe<Scalars["ID"]["output"]>;
  /** Corresponds to the 'Display Prices In Sales Modules' field in the Admin. It indicates how FPT information is displayed on cart, checkout, and order pages. */
  sales_fixed_product_tax_display_setting?: Maybe<MagentoApiFixedProductTaxDisplaySettings>;
  /** Indicates if gift wrapping prices are displayed on the Orders page. Possible values: 1 (Yes) and 0 (No). */
  sales_gift_wrapping?: Maybe<Scalars["String"]["output"]>;
  /** Indicates if printed card prices are displayed on the Orders page. Possible values: 1 (Yes) and 0 (No). */
  sales_printed_card?: Maybe<Scalars["String"]["output"]>;
  /** A secure fully-qualified URL that is used to create relative links to the `base_url`. */
  secure_base_link_url?: Maybe<Scalars["String"]["output"]>;
  /** The secure fully-qualified URL that specifies the location of media files. */
  secure_base_media_url?: Maybe<Scalars["String"]["output"]>;
  /** The secure fully-qualified URL that specifies the location of static view files. */
  secure_base_static_url?: Maybe<Scalars["String"]["output"]>;
  /** The store’s fully-qualified secure base URL. */
  secure_base_url?: Maybe<Scalars["String"]["output"]>;
  /** Email to a Friend configuration. */
  send_friend?: Maybe<MagentoApiSendFriendConfiguration>;
  /** Extended Config Data - tax/cart_display/full_summary */
  shopping_cart_display_full_summary?: Maybe<Scalars["Boolean"]["output"]>;
  /** Extended Config Data - tax/cart_display/grandtotal */
  shopping_cart_display_grand_total?: Maybe<Scalars["Boolean"]["output"]>;
  /** Extended Config Data - tax/cart_display/price */
  shopping_cart_display_price?: Maybe<Scalars["Int"]["output"]>;
  /** Extended Config Data - tax/cart_display/shipping */
  shopping_cart_display_shipping?: Maybe<Scalars["Int"]["output"]>;
  /** Extended Config Data - tax/cart_display/subtotal */
  shopping_cart_display_subtotal?: Maybe<Scalars["Int"]["output"]>;
  /** Extended Config Data - tax/cart_display/gift_wrapping */
  shopping_cart_display_tax_gift_wrapping?: Maybe<MagentoApiTaxWrappingEnum>;
  /** Extended Config Data - tax/cart_display/zero_tax */
  shopping_cart_display_zero_tax?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether a breadcrumb trail appears on all CMS pages in the catalog. 0 (No) or 1 (Yes). */
  show_cms_breadcrumbs?: Maybe<Scalars["Int"]["output"]>;
  /** The unique ID of the store view. In the Admin, this is called the Store View Code. When making a GraphQL call, assign this value to the `Store` header to provide the scope. */
  store_code?: Maybe<Scalars["ID"]["output"]>;
  /** The unique ID assigned to the store group. In the Admin, this is called the Store Name. */
  store_group_code?: Maybe<Scalars["ID"]["output"]>;
  /** The label assigned to the store group. */
  store_group_name?: Maybe<Scalars["String"]["output"]>;
  /** The label assigned to the store view. */
  store_name?: Maybe<Scalars["String"]["output"]>;
  /** The store view sort order. */
  store_sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The time zone of the store. */
  timezone?: Maybe<Scalars["String"]["output"]>;
  /** A prefix that appears before the title to create a two- or three-part title. */
  title_prefix?: Maybe<Scalars["String"]["output"]>;
  /** The character that separates the category name and subcategory in the browser title bar. */
  title_separator?: Maybe<Scalars["String"]["output"]>;
  /** A suffix that appears after the title to create a two- or three-part title. */
  title_suffix?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the store code should be used in the URL. */
  use_store_in_url?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is postcode region validation enabled */
  validate_region?: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for the website. */
  website_code?: Maybe<Scalars["ID"]["output"]>;
  /**
   * The ID number assigned to the website store.
   * @deprecated The field should not be used on the storefront.
   */
  website_id?: Maybe<Scalars["Int"]["output"]>;
  /** The label assigned to the website. */
  website_name?: Maybe<Scalars["String"]["output"]>;
  /** The unit of weight. */
  weight_unit?: Maybe<Scalars["String"]["output"]>;
  /** Text that appears in the header of the page and includes the name of the logged in customer. */
  welcome?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether only specific countries can use this payment method. */
  zero_subtotal_enable_for_specific_countries?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the Zero Subtotal payment method is enabled. */
  zero_subtotal_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** The status of new orders placed using the Zero Subtotal payment method. */
  zero_subtotal_new_order_status?: Maybe<Scalars["String"]["output"]>;
  /** When the new order status is 'Processing', this can be set to `authorize_capture` to automatically invoice all items that have a zero balance. */
  zero_subtotal_payment_action?: Maybe<Scalars["String"]["output"]>;
  /** A comma-separated list of specific countries allowed to use the Zero Subtotal payment method. */
  zero_subtotal_payment_from_specific_countries?: Maybe<Scalars["String"]["output"]>;
  /** A number indicating the position of the Zero Subtotal payment method in the list of available payment methods during checkout. */
  zero_subtotal_sort_order?: Maybe<Scalars["Int"]["output"]>;
  /** The title of the Zero Subtotal payment method displayed on the storefront. */
  zero_subtotal_title?: Maybe<Scalars["String"]["output"]>;
};

/** Indicates where an attribute can be displayed. */
export type MagentoApiStorefrontProperties = {
  __typename: "StorefrontProperties";
  /** The relative position of the attribute in the layered navigation block. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the attribute is filterable with results, without results, or not at all. */
  use_in_layered_navigation?: Maybe<MagentoApiUseInLayeredNavigationOptions>;
  /** Indicates whether the attribute is displayed in product listings. */
  use_in_product_listing?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the attribute can be used in layered navigation on search results pages. */
  use_in_search_results_layered_navigation?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the attribute is displayed on product pages. */
  visible_on_catalog_pages?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MagentoApiStrengthDetails = {
  __typename: "StrengthDetails";
  /** Strength level. */
  level: Scalars["String"]["output"];
  /** Strength label. */
  name: Scalars["String"]["output"];
  /** Strength rating. */
  rating: Scalars["Int"]["output"];
};

/** Contains the result of the `subscribeEmailToNewsletter` operation. */
export type MagentoApiSubscribeEmailToNewsletterOutput = {
  __typename: "SubscribeEmailToNewsletterOutput";
  /** The status of the subscription request. */
  status?: Maybe<MagentoApiSubscriptionStatusesEnum>;
};

/** Indicates the status of the request. */
export type MagentoApiSubscriptionStatusesEnum = "NOT_ACTIVE" | "SUBSCRIBED" | "UNCONFIRMED" | "UNSUBSCRIBED";

/** Describes the swatch type and a value. */
export type MagentoApiSwatchData = {
  __typename: "SwatchData";
  /** The type of swatch filter item: 1 - text; 2 - image. */
  type?: Maybe<Scalars["String"]["output"]>;
  /** The value for the swatch item. It could be text or an image link. */
  value?: Maybe<Scalars["String"]["output"]>;
};

export type MagentoApiSwatchDataInterface = {
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Swatch attribute metadata input types. */
export type MagentoApiSwatchInputTypeEnum =
  | "BOOLEAN"
  | "DATE"
  | "DATETIME"
  | "DROPDOWN"
  | "FILE"
  | "GALLERY"
  | "HIDDEN"
  | "IMAGE"
  | "MEDIA_IMAGE"
  | "MULTILINE"
  | "MULTISELECT"
  | "PRICE"
  | "SELECT"
  | "TEXT"
  | "TEXTAREA"
  | "UNDEFINED"
  | "VISUAL"
  | "WEIGHT";

export type MagentoApiSwatchLayerFilterItem = MagentoApiLayerFilterItemInterface &
  MagentoApiSwatchLayerFilterItemInterface & {
    __typename: "SwatchLayerFilterItem";
    /**
     * The count of items per filter.
     * @deprecated Use `AggregationOption.count` instead.
     */
    items_count?: Maybe<Scalars["Int"]["output"]>;
    /**
     * The label for a filter.
     * @deprecated Use `AggregationOption.label` instead.
     */
    label?: Maybe<Scalars["String"]["output"]>;
    /** Data required to render a swatch filter item. */
    swatch_data?: Maybe<MagentoApiSwatchData>;
    /**
     * The value of a filter request variable to be used in query.
     * @deprecated Use `AggregationOption.value` instead.
     */
    value_string?: Maybe<Scalars["String"]["output"]>;
  };

export type MagentoApiSwatchLayerFilterItemInterface = {
  /** Data required to render a swatch filter item. */
  swatch_data?: Maybe<MagentoApiSwatchData>;
};

/** Synchronizes the payment order details */
export type MagentoApiSyncPaymentOrderInput = {
  /** The customer cart ID */
  cartId: Scalars["String"]["input"];
  /** PayPal order ID */
  id: Scalars["String"]["input"];
};

/** Contains tax item details. */
export type MagentoApiTaxItem = {
  __typename: "TaxItem";
  /** The amount of tax applied to the item. */
  amount: MagentoApiMoney;
  /** The rate used to calculate the tax. */
  rate: Scalars["Float"]["output"];
  /** A title that describes the tax. */
  title: Scalars["String"]["output"];
};

export type MagentoApiTaxWrappingEnum = "DISPLAY_EXCLUDING_TAX" | "DISPLAY_INCLUDING_TAX" | "DISPLAY_TYPE_BOTH";

export type MagentoApiTextSwatchData = MagentoApiSwatchDataInterface & {
  __typename: "TextSwatchData";
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** 3D Secure mode. */
export type MagentoApiThreeDsMode = "OFF" | "SCA_ALWAYS" | "SCA_WHEN_REQUIRED";

/** Defines a price based on the quantity purchased. */
export type MagentoApiTierPrice = {
  __typename: "TierPrice";
  /** The price discount that this tier represents. */
  discount?: Maybe<MagentoApiProductDiscount>;
  /** The price of the product at this tier. */
  final_price?: Maybe<MagentoApiMoney>;
  /** Label of the tier price. */
  label?: Maybe<Scalars["String"]["output"]>;
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity?: Maybe<Scalars["Float"]["output"]>;
  /** Total_price => final_price * quantity. */
  total_price?: Maybe<MagentoApiMoney>;
};

/** Provides necessary information about the full order trial amounts in the process */
export type MagentoApiTrialTotals = {
  __typename: "TrialTotals";
  tax?: Maybe<MagentoApiMoney>;
  total?: Maybe<MagentoApiMoney>;
  total_incl_tax?: Maybe<MagentoApiMoney>;
};

/** Modifies the specified items in the cart. */
export type MagentoApiUpdateCartItemsInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of items to be updated. */
  cart_items: Array<InputMaybe<MagentoApiCartItemUpdateInput>>;
};

/** Contains details about the cart after updating items. */
export type MagentoApiUpdateCartItemsOutput = {
  __typename: "UpdateCartItemsOutput";
  /** The cart after updating products. */
  cart: MagentoApiCart;
  /** Contains errors encountered while updating an item to the cart. */
  errors: Array<Maybe<MagentoApiCartUserInputError>>;
};

/** Defines updates to a `GiftRegistry` object. */
export type MagentoApiUpdateGiftRegistryInput = {
  /** Additional attributes specified as a code-value pair. Unspecified dynamic attributes are not changed. */
  dynamic_attributes?: InputMaybe<Array<InputMaybe<MagentoApiGiftRegistryDynamicAttributeInput>>>;
  /** The updated name of the event. */
  event_name?: InputMaybe<Scalars["String"]["input"]>;
  /** The updated message describing the event. */
  message?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates whether the gift registry is PRIVATE or PUBLIC. */
  privacy_settings?: InputMaybe<MagentoApiGiftRegistryPrivacySettings>;
  /** The updated shipping address for all gift registry items. */
  shipping_address?: InputMaybe<MagentoApiGiftRegistryShippingAddressInput>;
  /** Indicates whether the gift registry is ACTIVE or INACTIVE. */
  status?: InputMaybe<MagentoApiGiftRegistryStatus>;
};

/** Defines updates to an item in a gift registry. */
export type MagentoApiUpdateGiftRegistryItemInput = {
  /** The unique ID of a `giftRegistryItem` object. */
  gift_registry_item_uid: Scalars["ID"]["input"];
  /** The updated description of the item. */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** The updated quantity of the gift registry item. */
  quantity: Scalars["Float"]["input"];
};

/** Contains the results of a request to update gift registry items. */
export type MagentoApiUpdateGiftRegistryItemsOutput = {
  __typename: "UpdateGiftRegistryItemsOutput";
  /** The gift registry after updating updating items. */
  gift_registry?: Maybe<MagentoApiGiftRegistry>;
};

/** Contains the results of a request to update a gift registry. */
export type MagentoApiUpdateGiftRegistryOutput = {
  __typename: "UpdateGiftRegistryOutput";
  /** The updated gift registry. */
  gift_registry?: Maybe<MagentoApiGiftRegistry>;
};

/** Defines updates to an existing registrant. */
export type MagentoApiUpdateGiftRegistryRegistrantInput = {
  /** As a result of the update, only the values of provided attributes will be affected. If the attribute is missing in the request, its value will not be changed. */
  dynamic_attributes?: InputMaybe<Array<InputMaybe<MagentoApiGiftRegistryDynamicAttributeInput>>>;
  /** The updated email address of the registrant. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** The updated first name of the registrant. */
  firstname?: InputMaybe<Scalars["String"]["input"]>;
  /** The unique ID of a `giftRegistryRegistrant` object. */
  gift_registry_registrant_uid: Scalars["ID"]["input"];
  /** The updated last name of the registrant. */
  lastname?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains the results a request to update registrants. */
export type MagentoApiUpdateGiftRegistryRegistrantsOutput = {
  __typename: "UpdateGiftRegistryRegistrantsOutput";
  /** The gift registry after updating registrants. */
  gift_registry?: Maybe<MagentoApiGiftRegistry>;
};

export type MagentoApiUpdatePaymentInput = {
  /** Method code of the payment to be updated */
  method_code: Scalars["String"]["input"];
  /** Order ID for the update action */
  order_id: Scalars["String"]["input"];
};

export type MagentoApiUpdatePaymentOutput = {
  __typename: "UpdatePaymentOutput";
  success: Scalars["Boolean"]["output"];
};

/** Contains the customer's wish list and any errors encountered. */
export type MagentoApiUpdateProductsInWishlistOutput = {
  __typename: "UpdateProductsInWishlistOutput";
  /** An array of errors encountered while updating products in a wish list. */
  user_errors: Array<Maybe<MagentoApiWishListUserInputError>>;
  /** Contains the wish list with all items that were successfully updated. */
  wishlist: MagentoApiWishlist;
};

/** Contains the name and visibility of an updated wish list. */
export type MagentoApiUpdateWishlistOutput = {
  __typename: "UpdateWishlistOutput";
  /** The wish list name. */
  name: Scalars["String"]["output"];
  /** The unique ID of a `Wishlist` object. */
  uid: Scalars["ID"]["output"];
  /** Indicates whether the wish list is public or private. */
  visibility: MagentoApiWishlistVisibilityEnum;
};

/** Contains URL rewrite details. */
export type MagentoApiUrlRewrite = {
  __typename: "UrlRewrite";
  /** An array of request parameters. */
  parameters?: Maybe<Array<Maybe<MagentoApiHttpQueryParameter>>>;
  /** The request URL. */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** This enumeration defines the entity type. */
export type MagentoApiUrlRewriteEntityTypeEnum = "CATEGORY" | "CMS_PAGE" | "PRODUCT";

/** Defines whether the attribute is filterable in layered navigation. */
export type MagentoApiUseInLayeredNavigationOptions = "FILTERABLE_NO_RESULT" | "FILTERABLE_WITH_RESULTS" | "NO";

/** Defines a customer attribute validation rule. */
export type MagentoApiValidationRule = {
  __typename: "ValidationRule";
  /** Validation rule name applied to a customer attribute. */
  name?: Maybe<MagentoApiValidationRuleEnum>;
  /** Validation rule value. */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** List of validation rule names applied to a customer attribute. */
export type MagentoApiValidationRuleEnum =
  | "DATE_RANGE_MAX"
  | "DATE_RANGE_MIN"
  | "FILE_EXTENSIONS"
  | "INPUT_VALIDATION"
  | "MAX_FILE_SIZE"
  | "MAX_IMAGE_HEIGHT"
  | "MAX_IMAGE_WIDTH"
  | "MAX_TEXT_LENGTH"
  | "MIN_TEXT_LENGTH";

/** Retrieves the vault configuration */
export type MagentoApiVaultConfigOutput = {
  __typename: "VaultConfigOutput";
  /** Credit card vault method configuration */
  credit_card?: Maybe<MagentoApiVaultCreditCardConfig>;
};

export type MagentoApiVaultCreditCardConfig = {
  __typename: "VaultCreditCardConfig";
  /** Is vault enabled */
  is_vault_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** The parameters required to load the Paypal JS SDK */
  sdk_params?: Maybe<Array<Maybe<MagentoApiSdkParams>>>;
  /** 3DS mode */
  three_ds_mode?: Maybe<MagentoApiThreeDsMode>;
};

/** Vault payment inputs */
export type MagentoApiVaultMethodInput = {
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars["String"]["input"]>;
  /** The payment services order ID */
  payments_order_id?: InputMaybe<Scalars["String"]["input"]>;
  /** PayPal order ID */
  paypal_order_id?: InputMaybe<Scalars["String"]["input"]>;
  /** The public hash of the token. */
  public_hash?: InputMaybe<Scalars["String"]["input"]>;
};

/** The payment source information */
export type MagentoApiVaultSetupTokenInput = {
  /** The payment source information */
  payment_source: MagentoApiPaymentSourceInput;
};

/** Contains required input for payment methods with Vault support. */
export type MagentoApiVaultTokenInput = {
  /** The public hash of the payment token. */
  public_hash: Scalars["String"]["input"];
};

/** An implementation for virtual product cart items. */
export type MagentoApiVirtualCartItem = MagentoApiCartItemInterface & {
  __typename: "VirtualCartItem";
  /** An array containing customizable options the shopper selected. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<MagentoApiCartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data?: Maybe<MagentoApiGiftData>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<MagentoApiCartItemPrices>;
  /** Details about an item in the cart. */
  product: MagentoApiProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type MagentoApiVirtualProduct = MagentoApiCustomizableProductInterface &
  MagentoApiProductInterface &
  MagentoApiRoutableInterface & {
    __typename: "VirtualProduct";
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer?: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp?: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<MagentoApiCategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1?: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2?: Maybe<MagentoApiProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code?: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family?: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<MagentoApiFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula?: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts?: Maybe<MagentoApiFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes?: Maybe<Array<Maybe<MagentoApiFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price?: Maybe<MagentoApiMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device?: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent?: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image?: Maybe<MagentoApiProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal?: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent?: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer?: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material?: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MagentoApiMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MagentoApiMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type?: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description?: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label?: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price?: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled?: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model?: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks?: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand?: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<MagentoApiCustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<MagentoApiProductPrices>;
    /** The range of prices for the product */
    price_range: MagentoApiPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<MagentoApiTierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand?: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation?: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<MagentoApiProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province?: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label?: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity?: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category?: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region?: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label?: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible?: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: MagentoApiProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<MagentoApiComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size?: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<MagentoApiProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<MagentoApiSpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility?: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status?: Maybe<MagentoApiProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength?: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details?: Maybe<MagentoApiStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<MagentoApiProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<MagentoApiProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka?: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku?: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<MagentoApiUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label?: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products?: Maybe<Array<Maybe<MagentoApiProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<MagentoApiUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage?: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<MagentoApiWebsite>>>;
  };

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type MagentoApiVirtualProductCustom_AttributesV2Args = {
  filters?: InputMaybe<MagentoApiAttributeFilterInput>;
};

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type MagentoApiVirtualProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Defines a single product to add to the cart. */
export type MagentoApiVirtualProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<MagentoApiCustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: MagentoApiCartItemInput;
};

/** Contains a virtual product wish list item. */
export type MagentoApiVirtualWishlistItem = MagentoApiWishlistItemInterface & {
  __typename: "VirtualWishlistItem";
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

/** Deprecated. It should not be used on the storefront. Contains information about a website. */
export type MagentoApiWebsite = {
  __typename: "Website";
  /**
   * A code assigned to the website to identify it.
   * @deprecated The field should not be used on the storefront.
   */
  code?: Maybe<Scalars["String"]["output"]>;
  /**
   * The default group ID of the website.
   * @deprecated The field should not be used on the storefront.
   */
  default_group_id?: Maybe<Scalars["String"]["output"]>;
  /**
   * The ID number assigned to the website.
   * @deprecated The field should not be used on the storefront.
   */
  id?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Indicates whether this is the default website.
   * @deprecated The field should not be used on the storefront.
   */
  is_default?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name?: Maybe<Scalars["String"]["output"]>;
  /**
   * The attribute to use for sorting websites.
   * @deprecated The field should not be used on the storefront.
   */
  sort_order?: Maybe<Scalars["Int"]["output"]>;
};

/** An error encountered while performing operations with WishList. */
export type MagentoApiWishListUserInputError = {
  __typename: "WishListUserInputError";
  /** A wish list-specific error code. */
  code: MagentoApiWishListUserInputErrorType;
  /** A localized error message. */
  message: Scalars["String"]["output"];
};

/** A list of possible error types. */
export type MagentoApiWishListUserInputErrorType = "PRODUCT_NOT_FOUND" | "UNDEFINED";

/** Contains a customer wish list. */
export type MagentoApiWishlist = {
  __typename: "Wishlist";
  /** The unique ID for a `Wishlist` object. */
  id?: Maybe<Scalars["ID"]["output"]>;
  /** @deprecated Use the `items_v2` field instead. */
  items?: Maybe<Array<Maybe<MagentoApiWishlistItem>>>;
  /** The number of items in the wish list. */
  items_count?: Maybe<Scalars["Int"]["output"]>;
  /** An array of items in the customer's wish list. */
  items_v2?: Maybe<MagentoApiWishlistItems>;
  /** The name of the wish list. */
  name?: Maybe<Scalars["String"]["output"]>;
  /** An encrypted code that Magento uses to link to the wish list. */
  sharing_code?: Maybe<Scalars["String"]["output"]>;
  /** The time of the last modification to the wish list. */
  updated_at?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the wish list is public or private. */
  visibility: MagentoApiWishlistVisibilityEnum;
};

/** Contains a customer wish list. */
export type MagentoApiWishlistItems_V2Args = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Contains details about errors encountered when a customer added wish list items to the cart. */
export type MagentoApiWishlistCartUserInputError = {
  __typename: "WishlistCartUserInputError";
  /** An error code that describes the error encountered. */
  code: MagentoApiWishlistCartUserInputErrorType;
  /** A localized error message. */
  message: Scalars["String"]["output"];
  /** The unique ID of the `Wishlist` object containing an error. */
  wishlistId: Scalars["ID"]["output"];
  /** The unique ID of the wish list item containing an error. */
  wishlistItemId: Scalars["ID"]["output"];
};

/** A list of possible error types. */
export type MagentoApiWishlistCartUserInputErrorType =
  "INSUFFICIENT_STOCK" | "NOT_SALABLE" | "PRODUCT_NOT_FOUND" | "UNDEFINED";

/** Contains details about a wish list item. */
export type MagentoApiWishlistItem = {
  __typename: "WishlistItem";
  /** The time when the customer added the item to the wish list. */
  added_at?: Maybe<Scalars["String"]["output"]>;
  /** The customer's comment about this item. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItem` object. */
  id?: Maybe<Scalars["Int"]["output"]>;
  /** Details about the wish list item. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The quantity of this wish list item */
  qty?: Maybe<Scalars["Float"]["output"]>;
};

/** Specifies the IDs of items to copy and their quantities. */
export type MagentoApiWishlistItemCopyInput = {
  /** The quantity of this item to copy to the destination wish list. This value can't be greater than the quantity in the source wish list. */
  quantity?: InputMaybe<Scalars["Float"]["input"]>;
  /** The unique ID of the `WishlistItemInterface` object to be copied. */
  wishlist_item_id: Scalars["ID"]["input"];
};

/** Defines the items to add to a wish list. */
export type MagentoApiWishlistItemInput = {
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<MagentoApiEnteredOptionInput>>>;
  /** For complex product types, the SKU of the parent product. */
  parent_sku?: InputMaybe<Scalars["String"]["input"]>;
  /** The amount or number of items to add. */
  quantity: Scalars["Float"]["input"];
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /** The SKU of the product to add. For complex product types, specify the child product SKU. */
  sku: Scalars["String"]["input"];
};

/** The interface for wish list items. */
export type MagentoApiWishlistItemInterface = {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<MagentoApiSelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product?: Maybe<MagentoApiProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

/** Specifies the IDs of the items to move and their quantities. */
export type MagentoApiWishlistItemMoveInput = {
  /** The quantity of this item to move to the destination wish list. This value can't be greater than the quantity in the source wish list. */
  quantity?: InputMaybe<Scalars["Float"]["input"]>;
  /** The unique ID of the `WishlistItemInterface` object to be moved. */
  wishlist_item_id: Scalars["ID"]["input"];
};

/** Defines updates to items in a wish list. */
export type MagentoApiWishlistItemUpdateInput = {
  /** Customer-entered comments about the item. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<MagentoApiEnteredOptionInput>>>;
  /** The new amount or number of this item. */
  quantity?: InputMaybe<Scalars["Float"]["input"]>;
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /** The unique ID for a `WishlistItemInterface` object. */
  wishlist_item_id: Scalars["ID"]["input"];
};

/** Contains an array of items in a wish list. */
export type MagentoApiWishlistItems = {
  __typename: "WishlistItems";
  /** A list of items in the wish list. */
  items: Array<Maybe<MagentoApiWishlistItemInterface>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<MagentoApiSearchResultPageInfo>;
};

/** Deprecated: Use the `Wishlist` type instead. */
export type MagentoApiWishlistOutput = {
  __typename: "WishlistOutput";
  /**
   * An array of items in the customer's wish list
   * @deprecated Use the `Wishlist.items` field instead.
   */
  items?: Maybe<Array<Maybe<MagentoApiWishlistItem>>>;
  /**
   * The number of items in the wish list.
   * @deprecated Use the `Wishlist.items_count` field instead.
   */
  items_count?: Maybe<Scalars["Int"]["output"]>;
  /**
   * When multiple wish lists are enabled, the name the customer assigns to the wishlist.
   * @deprecated This field is related to Commerce functionality and is always `null` in Open Source.
   */
  name?: Maybe<Scalars["String"]["output"]>;
  /**
   * An encrypted code that links to the wish list.
   * @deprecated Use the `Wishlist.sharing_code` field instead.
   */
  sharing_code?: Maybe<Scalars["String"]["output"]>;
  /**
   * The time of the last modification to the wish list.
   * @deprecated Use the `Wishlist.updated_at` field instead.
   */
  updated_at?: Maybe<Scalars["String"]["output"]>;
};

/** Defines the wish list visibility types. */
export type MagentoApiWishlistVisibilityEnum = "PRIVATE" | "PUBLIC";

/** Assigns a specific `cart_id` to the empty cart. */
export type MagentoApiCreateEmptyCartInput = {
  /** The ID to assign to the cart. */
  cart_id?: InputMaybe<Scalars["String"]["input"]>;
};
